import { GraphQLClient } from 'graphql-request';
import { GraphQLClientRequestHeaders } from 'graphql-request/build/cjs/types';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Decimal: any;
  Long: any;
};

export type GAgentByTenant = {
  __typename?: 'AgentByTenant';
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedByAgent?: Maybe<GAgentEntity>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedByAgent?: Maybe<GAgentEntity>;
  isFirstAgentInTenant: Scalars['Boolean'];
  role: GTenantRoleItem;
  status: GAgentStatusItem;
  teams: Array<GTeamEntity>;
  tenant?: Maybe<GTenantEntity>;
};

export type GAgentDataInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type GAgentEntity = {
  __typename?: 'AgentEntity';
  away: Scalars['Boolean'];
  awayFromPhone?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['String'];
  idle: Scalars['Boolean'];
  lastName: Scalars['String'];
  locale: GLocaleItem;
  name: Scalars['String'];
  perTenant: GAgentByTenant;
  releaseChannel: GUserReleaseChannelItem;
  settings: GAgentSettings;
  workerId?: Maybe<Scalars['String']>;
};

export type GAgentIsNotAuthorizedForConversationError = GUserError & {
  __typename?: 'AgentIsNotAuthorizedForConversationError';
  code: GUserErrorCode;
  message: Scalars['String'];
};

export type GAgentNotAuthorizedError = GUserError & {
  __typename?: 'AgentNotAuthorizedError';
  code: GUserErrorCode;
  message: Scalars['String'];
};

export type GAgentNotFoundError = GUserError & {
  __typename?: 'AgentNotFoundError';
  code: GUserErrorCode;
  message: Scalars['String'];
};

export type GAgentNotificationContinuationTokenConnection = {
  __typename?: 'AgentNotificationContinuationTokenConnection';
  continuationToken?: Maybe<Scalars['String']>;
  items: Array<Maybe<GAgentNotificationEntity>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type GAgentNotificationEntity = {
  __typename?: 'AgentNotificationEntity';
  conversation?: Maybe<GConversationEntity>;
  conversationTimeline?: Maybe<GConversationTimelineEntity>;
  eventType: GNotificationEvent;
  generatedByAgent?: Maybe<GAgentEntity>;
  generatedByAgentId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  seen: Scalars['Boolean'];
  timestamp: Scalars['DateTime'];
};

export type GAgentNotificationNotFoundError = GUserError & {
  __typename?: 'AgentNotificationNotFoundError';
  code: GUserErrorCode;
  message: Scalars['String'];
};

export type GAgentNotificationSeenModified = {
  __typename?: 'AgentNotificationSeenModified';
  agentNotificationId: Scalars['String'];
  fromSeen: Scalars['Boolean'];
  tenantId: Scalars['String'];
  toSeen: Scalars['Boolean'];
};

export type GAgentNotificationSettingEntity = {
  __typename?: 'AgentNotificationSettingEntity';
  conversationAgentMentioned: GAgentSettingsNotificationFlags;
  conversationAssignedAgentContactMessageCreated: GAgentSettingsNotificationFlags;
  conversationAssignedAgentCreatedByContact: GAgentSettingsNotificationFlags;
  conversationAssignedAgentUnSnoozed: GAgentSettingsNotificationFlags;
  conversationAssignedTeamContactMessageCreated: GAgentSettingsNotificationFlags;
  conversationAssignedTeamCreatedByContact: GAgentSettingsNotificationFlags;
  conversationAssignedTeamUnSnoozed: GAgentSettingsNotificationFlags;
  conversationAssignedToAgent: GAgentSettingsNotificationFlags;
  conversationAssignedToTeam: GAgentSettingsNotificationFlags;
  conversationUnassignedContactMessageCreated: GAgentSettingsNotificationFlags;
  conversationUnassignedCreatedByContact: GAgentSettingsNotificationFlags;
  conversationUnassignedUnSnoozed: GAgentSettingsNotificationFlags;
};

export enum GAgentPushSubscriptionClientModeItem {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE'
}

export type GAgentSettings = {
  __typename?: 'AgentSettings';
  autoAdvance: GAgentSettingsAutoAdvance;
};

export type GAgentSettingsAutoAdvance = {
  __typename?: 'AgentSettingsAutoAdvance';
  action: GAutoAdvanceOptionItem;
  autoAdvanceNextConversationRule?: Maybe<GAutoAdvanceNextConversationRuleItem>;
  autoAdvancePrioritizeChatChannels?: Maybe<Scalars['Boolean']>;
};

export type GAgentSettingsAutoAdvanceInput = {
  action: GAutoAdvanceOptionItem;
  autoAdvanceNextConversationRule?: InputMaybe<GAutoAdvanceNextConversationRuleItem>;
  autoAdvancePrioritizeChatChannels?: InputMaybe<Scalars['Boolean']>;
};

export type GAgentSettingsInput = {
  autoAdvance: GAgentSettingsAutoAdvanceInput;
};

export type GAgentSettingsNotificationFlags = {
  __typename?: 'AgentSettingsNotificationFlags';
  inApp: Scalars['Boolean'];
  preferDesktop: Scalars['Boolean'];
  pushNotification: Scalars['Boolean'];
  pushNotificationWhenAway: Scalars['Boolean'];
};

export type GAgentSettingsNotificationFlagsInput = {
  inApp: Scalars['Boolean'];
  preferDesktop: Scalars['Boolean'];
  pushNotification: Scalars['Boolean'];
  pushNotificationWhenAway: Scalars['Boolean'];
};

export enum GAgentStatusItem {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Disabled = 'DISABLED',
  Invited = 'INVITED',
  Unknown = 'UNKNOWN'
}

export type GAgentStopWatchConversationInput = {
  conversationId: Scalars['String'];
};

export type GAgentStopWatchConversationPayload = {
  __typename?: 'AgentStopWatchConversationPayload';
  success?: Maybe<Scalars['Boolean']>;
};

export type GAgentStoppedTypingInConversation = {
  __typename?: 'AgentStoppedTypingInConversation';
  agentId: Scalars['String'];
  conversationId: Scalars['String'];
  typingId: Scalars['String'];
};

export type GAgentStoppedTypingInConversationError = GAgentIsNotAuthorizedForConversationError;

export type GAgentStoppedTypingInConversationInput = {
  accessKey: Scalars['String'];
  conversationId: Scalars['String'];
  typingId: Scalars['String'];
};

export type GAgentStoppedTypingInConversationPayload = {
  __typename?: 'AgentStoppedTypingInConversationPayload';
  errors?: Maybe<Array<GAgentStoppedTypingInConversationError>>;
  typingId?: Maybe<Scalars['String']>;
};

export type GAgentStoppedWatchingConversation = {
  __typename?: 'AgentStoppedWatchingConversation';
  agentId: Scalars['String'];
  conversationId: Scalars['String'];
  updated: Scalars['DateTime'];
};

export type GAgentTypingInConversation = {
  __typename?: 'AgentTypingInConversation';
  agentId: Scalars['String'];
  content: Scalars['String'];
  conversationId: Scalars['String'];
  isFullContent: Scalars['Boolean'];
  sequence: Scalars['Int'];
  typingId: Scalars['String'];
};

export type GAgentTypingInConversationError = GAgentIsNotAuthorizedForConversationError;

export type GAgentTypingInConversationInput = {
  accessKey?: InputMaybe<Scalars['String']>;
  content: Scalars['String'];
  conversationId: Scalars['String'];
  isFullContent: Scalars['Boolean'];
  sequence: Scalars['Int'];
  typingId?: InputMaybe<Scalars['String']>;
};

export type GAgentTypingInConversationPayload = {
  __typename?: 'AgentTypingInConversationPayload';
  accessKey?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<GAgentTypingInConversationError>>;
  typingId?: Maybe<Scalars['String']>;
};

export type GAgentWatchConversationInput = {
  conversationId: Scalars['String'];
};

export type GAgentWatchConversationPayload = {
  __typename?: 'AgentWatchConversationPayload';
  success?: Maybe<Scalars['Boolean']>;
};

export enum GAiModelItem {
  Claude2 = 'CLAUDE2',
  Claude3Haiku = 'CLAUDE3_HAIKU',
  Claude3Opus = 'CLAUDE3_OPUS',
  Claude3Sonnet = 'CLAUDE3_SONNET',
  ClaudeInstant12 = 'CLAUDE_INSTANT12',
  Gpt4 = 'GPT4',
  Gpt4Turbo = 'GPT4_TURBO',
  Gpt35 = 'GPT35'
}

export type GAppEventByTenant = {
  __typename?: 'AppEventByTenant';
  eventData?: Maybe<GAppEventMetaData>;
  eventType: GAppEventType;
  id: Scalars['String'];
  timestamp: Scalars['DateTime'];
};

export type GAppEventMetaData = GConversationAgentComment | GConversationAgentMessage | GConversationBotMessage | GConversationBotSuggestion | GConversationContactMessage | GConversationEvent;

export enum GAppEventType {
  ConversationAgentComment = 'CONVERSATION_AGENT_COMMENT',
  ConversationAgentMessage = 'CONVERSATION_AGENT_MESSAGE',
  ConversationArchived = 'CONVERSATION_ARCHIVED',
  ConversationAssigned = 'CONVERSATION_ASSIGNED',
  ConversationBotAssistantDisconnected = 'CONVERSATION_BOT_ASSISTANT_DISCONNECTED',
  ConversationBotAssistantReplying = 'CONVERSATION_BOT_ASSISTANT_REPLYING',
  ConversationBotAssistantSuggesting = 'CONVERSATION_BOT_ASSISTANT_SUGGESTING',
  ConversationBotMessage = 'CONVERSATION_BOT_MESSAGE',
  ConversationBotSuggestion = 'CONVERSATION_BOT_SUGGESTION',
  ConversationChatEnded = 'CONVERSATION_CHAT_ENDED',
  ConversationContactMessage = 'CONVERSATION_CONTACT_MESSAGE',
  ConversationCreated = 'CONVERSATION_CREATED',
  ConversationSnoozed = 'CONVERSATION_SNOOZED',
  ConversationSnoozeExpired = 'CONVERSATION_SNOOZE_EXPIRED',
  ConversationTagsChanged = 'CONVERSATION_TAGS_CHANGED',
  ConversationTransferred = 'CONVERSATION_TRANSFERRED',
  ConversationUnArchived = 'CONVERSATION_UN_ARCHIVED',
  ConversationUnSnoozed = 'CONVERSATION_UN_SNOOZED'
}

export enum GApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER',
  Validation = 'VALIDATION'
}

export type GAssistantError = GUserError & {
  __typename?: 'AssistantError';
  assistantErrorCode: GAssistantErrorCode;
  code: GUserErrorCode;
  message: Scalars['String'];
};

export enum GAssistantErrorCode {
  InconclusiveResult = 'INCONCLUSIVE_RESULT',
  SystemError = 'SYSTEM_ERROR',
  TokenQuotaExceeded = 'TOKEN_QUOTA_EXCEEDED'
}

export enum GAutoAdvanceNextConversationRuleItem {
  NewestConversation = 'NEWEST_CONVERSATION',
  OldestConversation = 'OLDEST_CONVERSATION'
}

export enum GAutoAdvanceOptionItem {
  AutoAdvance = 'AUTO_ADVANCE',
  ReturnToConversationList = 'RETURN_TO_CONVERSATION_LIST',
  StayInConversation = 'STAY_IN_CONVERSATION'
}

export type GBaseConnectedServiceEntity = {
  __typename?: 'BaseConnectedServiceEntity';
  assistantBehaviourSettings?: Maybe<GBotAssistantBehaviourSettings>;
  capabilities: Array<GConnectedServiceCapabilityItem>;
  deleted: Scalars['Boolean'];
  id: Scalars['String'];
  status: GConnectedServiceStatusItem;
  team?: Maybe<GTeamEntity>;
  type: GConnectedServiceItem;
};

export enum GBotActionableAnswerResultItem {
  AnsweredExternalFacts = 'ANSWERED_EXTERNAL_FACTS',
  AnsweredInternalFacts = 'ANSWERED_INTERNAL_FACTS',
  AnswerNotFound = 'ANSWER_NOT_FOUND'
}

export type GBotActionableTask = {
  __typename?: 'BotActionableTask';
  answer?: Maybe<Scalars['String']>;
  answerResult: GBotActionableAnswerResultItem;
  kbMatches: Array<GBotActionableTaskKbMatch>;
  queries: Array<Maybe<Scalars['String']>>;
  specificity: Scalars['Int'];
  task?: Maybe<Scalars['String']>;
};

export type GBotActionableTaskKbMatch = {
  __typename?: 'BotActionableTaskKbMatch';
  aiRelevanceCheck: Scalars['Boolean'];
  knowledgeBaseArticle: GKnowledgeBaseArticleEntity;
  knowledgeBaseArticleId: Scalars['String'];
  vectorSearchScore: Scalars['Float'];
};

export type GBotAssistantBehaviourSettings = {
  __typename?: 'BotAssistantBehaviourSettings';
  canUseExternalFacts: Scalars['Boolean'];
  defaultBotAssistantMode: GConversationBotAssistantModeItem;
  splitActionableTasks: Scalars['Boolean'];
};

export type GBotAssistantBehaviourSettingsInput = {
  canUseExternalFacts: Scalars['Boolean'];
  defaultBotAssistantMode: GConversationBotAssistantModeItem;
  splitActionableTasks: Scalars['Boolean'];
};

export type GBotAssistantTenantSettingsEntity = {
  __typename?: 'BotAssistantTenantSettingsEntity';
  defaultBehaviourSettings: GBotAssistantBehaviourSettings;
  id: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  minimumChunkRelevance: Scalars['Float'];
  minimumObjectiveRelevance: Scalars['Float'];
  minimumQuestionRelevance: Scalars['Float'];
  monthlyMaxTokenConsumption: Scalars['Int'];
};

export enum GBotResponseResultItem {
  AnswerFound = 'ANSWER_FOUND',
  AnswerNotFound = 'ANSWER_NOT_FOUND',
  Error = 'ERROR',
  LowSpecificity = 'LOW_SPECIFICITY',
  NoQuestion = 'NO_QUESTION',
  PageAgent = 'PAGE_AGENT',
  Processing = 'PROCESSING'
}

export enum GChatPreChatSurveyFieldTargetEntityType {
  Contact = 'CONTACT',
  Conversation = 'CONVERSATION',
  Unknown = 'UNKNOWN'
}

export enum GChatPreChatSurveyFieldType {
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  DateTime = 'DATE_TIME',
  Dropdown = 'DROPDOWN',
  Email = 'EMAIL',
  MultilineText = 'MULTILINE_TEXT',
  Name = 'NAME',
  Number = 'NUMBER',
  PhoneNumber = 'PHONE_NUMBER',
  Radio = 'RADIO',
  Text = 'TEXT',
  Unknown = 'UNKNOWN'
}

export enum GConnectedServiceCapabilityItem {
  Email = 'EMAIL',
  EmbeddedChat = 'EMBEDDED_CHAT',
  FacebookMessenger = 'FACEBOOK_MESSENGER',
  Sms = 'SMS',
  WhatsApp = 'WHATS_APP'
}

export type GConnectedServiceChatEntity = {
  __typename?: 'ConnectedServiceChatEntity';
  assistantBehaviourSettings?: Maybe<GBotAssistantBehaviourSettings>;
  behaviour: GWidgetConfigurationBehaviour;
  capabilities: Array<GConnectedServiceCapabilityItem>;
  channels?: Maybe<Array<GWidgetConfigurationChannel>>;
  codeInstalled: Scalars['Boolean'];
  conversationSettings: GWidgetConfigurationConversation;
  delayedResponseNotificationText?: Maybe<Scalars['String']>;
  delayedResponseNotificationTimeoutInSeconds: Scalars['Int'];
  deleted: Scalars['Boolean'];
  embedCode: Scalars['String'];
  id: Scalars['String'];
  iframeSettings: GWidgetConfigurationIframe;
  locale: GLocaleItem;
  preChatSurveyFields?: Maybe<Array<GWidgetConfigurationPreChatSurveyField>>;
  status: GConnectedServiceStatusItem;
  team?: Maybe<GTeamEntity>;
  text: GWidgetConfigurationText;
  theme: GWidgetConfigurationTheme;
  type: GConnectedServiceItem;
};

export enum GConnectedServiceChatEntityConversationStartModeItem {
  StartOnFirstContactMessage = 'START_ON_FIRST_CONTACT_MESSAGE',
  StartOnSurveySubmission = 'START_ON_SURVEY_SUBMISSION'
}

export enum GConnectedServiceChatEntityOperationModeItem {
  AgentsAlwaysAvailable = 'AGENTS_ALWAYS_AVAILABLE',
  AgentsOnShift = 'AGENTS_ON_SHIFT'
}

export type GConnectedServiceEmailEntity = {
  __typename?: 'ConnectedServiceEmailEntity';
  assistantBehaviourSettings?: Maybe<GBotAssistantBehaviourSettings>;
  capabilities: Array<GConnectedServiceCapabilityItem>;
  deleted: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  emailLocalPart: Scalars['String'];
  id: Scalars['String'];
  status: GConnectedServiceStatusItem;
  team?: Maybe<GTeamEntity>;
  type: GConnectedServiceItem;
};

export enum GConnectedServiceItem {
  Chat = 'CHAT',
  ChatV2 = 'CHAT_V2',
  Email = 'EMAIL',
  Messenger = 'MESSENGER',
  None = 'NONE',
  SmsSubnumber = 'SMS_SUBNUMBER',
  Vonage = 'VONAGE'
}

export type GConnectedServiceMessengerEntity = {
  __typename?: 'ConnectedServiceMessengerEntity';
  assistantBehaviourSettings?: Maybe<GBotAssistantBehaviourSettings>;
  capabilities: Array<GConnectedServiceCapabilityItem>;
  deleted: Scalars['Boolean'];
  facebookPageId: Scalars['String'];
  facebookPageName: Scalars['String'];
  id: Scalars['String'];
  status: GConnectedServiceStatusItem;
  team?: Maybe<GTeamEntity>;
  type: GConnectedServiceItem;
};

export type GConnectedServiceNotFoundError = GUserError & {
  __typename?: 'ConnectedServiceNotFoundError';
  code: GUserErrorCode;
  message: Scalars['String'];
};

export type GConnectedServiceSmsSubNumberEntity = {
  __typename?: 'ConnectedServiceSmsSubNumberEntity';
  assistantBehaviourSettings?: Maybe<GBotAssistantBehaviourSettings>;
  capabilities: Array<GConnectedServiceCapabilityItem>;
  deleted: Scalars['Boolean'];
  id: Scalars['String'];
  smsPrefixText?: Maybe<Scalars['String']>;
  smsSuffixText?: Maybe<Scalars['String']>;
  status: GConnectedServiceStatusItem;
  team?: Maybe<GTeamEntity>;
  type: GConnectedServiceItem;
};

export enum GConnectedServiceStatusItem {
  Disabled = 'DISABLED',
  Healthy = 'HEALTHY',
  NeedsReAuth = 'NEEDS_RE_AUTH',
  Pending = 'PENDING',
  Unknown = 'UNKNOWN',
  UnknownError = 'UNKNOWN_ERROR'
}

export type GConnectedServiceVonageEntity = {
  __typename?: 'ConnectedServiceVonageEntity';
  assistantBehaviourSettings?: Maybe<GBotAssistantBehaviourSettings>;
  capabilities: Array<GConnectedServiceCapabilityItem>;
  conversationMessageWindowInHours: Scalars['Float'];
  deleted: Scalars['Boolean'];
  hasSmsCapability: Scalars['Boolean'];
  hasWhatsAppCapability: Scalars['Boolean'];
  id: Scalars['String'];
  isPendingWhatsAppSetup: Scalars['Boolean'];
  linkedPhoneNumber?: Maybe<Scalars['String']>;
  smsPrefixText?: Maybe<Scalars['String']>;
  smsSuffixText?: Maybe<Scalars['String']>;
  status: GConnectedServiceStatusItem;
  team?: Maybe<GTeamEntity>;
  type: GConnectedServiceItem;
};

export type GContactAddressAlreadyUsedError = {
  __typename?: 'ContactAddressAlreadyUsedError';
  address: Scalars['String'];
  contactId: Scalars['String'];
  type: GInputContactAddressTypeItem;
};

export type GContactAddressConflictError = GUserError & {
  __typename?: 'ContactAddressConflictError';
  code: GUserErrorCode;
  conflicts: Array<GContactAddressAlreadyUsedError>;
  message: Scalars['String'];
};

export type GContactAddressEntity = {
  __typename?: 'ContactAddressEntity';
  address: Scalars['String'];
  addressType: GInputContactAddressTypeItem;
  id: Scalars['String'];
};

export type GContactAddressIndex = {
  __typename?: 'ContactAddressIndex';
  address: Scalars['String'];
  addressType: Scalars['String'];
  id: Scalars['String'];
};

export type GContactEntity = {
  __typename?: 'ContactEntity';
  address: Array<GContactAddressEntity>;
  created: Scalars['DateTime'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  updated: Scalars['DateTime'];
};

export type GContactIndex = {
  __typename?: 'ContactIndex';
  addresses: Array<GContactAddressIndex>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  tags: Array<Scalars['String']>;
};

export type GContactNotFoundError = GUserError & {
  __typename?: 'ContactNotFoundError';
  code: GUserErrorCode;
  message: Scalars['String'];
};

export type GContactStoppedTypingInConversation = {
  __typename?: 'ContactStoppedTypingInConversation';
  contactId: Scalars['String'];
  conversationId: Scalars['String'];
  tenantId: Scalars['String'];
};

export type GContactTypingInConversation = {
  __typename?: 'ContactTypingInConversation';
  contactId: Scalars['String'];
  content: Scalars['String'];
  conversationId: Scalars['String'];
  isFullContent: Scalars['Boolean'];
  sequence: Scalars['Int'];
  tenantId: Scalars['String'];
};

export type GConversationAgentComment = {
  __typename?: 'ConversationAgentComment';
  agent?: Maybe<GAgentEntity>;
  attachments: Array<GConversationAttachment>;
  content: Scalars['String'];
  contentIsTruncated: Scalars['Boolean'];
  conversation: GConversationEntity;
  conversationId: Scalars['String'];
  quotedContent?: Maybe<Scalars['String']>;
};

export type GConversationAgentMessage = {
  __typename?: 'ConversationAgentMessage';
  agent?: Maybe<GAgentEntity>;
  attachments: Array<GConversationAttachment>;
  content: Scalars['String'];
  contentIsTruncated: Scalars['Boolean'];
  conversation: GConversationEntity;
  conversationId: Scalars['String'];
  status: GMessageStatusItem;
};

export type GConversationAgentWatchEntity = {
  __typename?: 'ConversationAgentWatchEntity';
  agentId: Scalars['String'];
  conversationId: Scalars['String'];
  updated: Scalars['DateTime'];
};

export type GConversationAssignedMetaData = {
  __typename?: 'ConversationAssignedMetaData';
  newAssignee?: Maybe<GAgentEntity>;
  newTeam?: Maybe<GTeamEntity>;
  previousAssignee?: Maybe<GAgentEntity>;
  previousTeam?: Maybe<GTeamEntity>;
};

export type GConversationAttachment = {
  __typename?: 'ConversationAttachment';
  contentType: Scalars['String'];
  downloadUrl: Scalars['String'];
  filename: Scalars['String'];
  previewUrl: Scalars['String'];
  size: Scalars['Long'];
};

export enum GConversationBotAssistantModeItem {
  CreateReply = 'CREATE_REPLY',
  Disconnected = 'DISCONNECTED',
  SuggestReply = 'SUGGEST_REPLY'
}

export type GConversationBotMessage = {
  __typename?: 'ConversationBotMessage';
  content: Scalars['String'];
  conversation: GConversationEntity;
  conversationId: Scalars['String'];
  status: GMessageStatusItem;
};

export type GConversationBotSuggestion = {
  __typename?: 'ConversationBotSuggestion';
  actionableTasks: Array<GBotActionableTask>;
  aiModel: GAiModelItem;
  botResponseResult: GBotResponseResultItem;
  content: Scalars['String'];
  conversation: GConversationEntity;
  conversationId: Scalars['String'];
  quotedContent?: Maybe<Scalars['String']>;
};

export enum GConversationChannelItem {
  Email = 'EMAIL',
  EmbeddedChat = 'EMBEDDED_CHAT',
  FacebookMessenger = 'FACEBOOK_MESSENGER',
  Sms = 'SMS',
  Unknown = 'UNKNOWN',
  VoiceCall = 'VOICE_CALL',
  WhatsApp = 'WHATS_APP'
}

export type GConversationContactMessage = {
  __typename?: 'ConversationContactMessage';
  aiModelsProcessing: Array<GAiModelItem>;
  attachments: Array<GConversationAttachment>;
  botIsProcessing: Scalars['Boolean'];
  contact: GContactEntity;
  contactAddress: GContactAddressEntity;
  content: Scalars['String'];
  contentIsTruncated: Scalars['Boolean'];
  conversation: GConversationEntity;
  conversationId: Scalars['String'];
};

export type GConversationContinuationTokenConnection = {
  __typename?: 'ConversationContinuationTokenConnection';
  continuationToken?: Maybe<Scalars['String']>;
  items: Array<GConversationEntity>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type GConversationCountPayload = {
  __typename?: 'ConversationCountPayload';
  count: Array<GKeyValuePairOfStringAndInt64>;
};

export type GConversationEntity = {
  __typename?: 'ConversationEntity';
  assignee?: Maybe<GAgentEntity>;
  botAssistantMode: GConversationBotAssistantModeItem;
  contact: GContactEntity;
  currentChannel: GConversationChannelItem;
  currentContactAddress?: Maybe<GContactAddressEntity>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDemoContent?: Maybe<Scalars['Boolean']>;
  lastMessageContent?: Maybe<Scalars['String']>;
  minutesToFirstResponse?: Maybe<Scalars['Float']>;
  originalChannel: GConversationChannelItem;
  started: Scalars['DateTime'];
  status: GConversationStatusItem;
  team?: Maybe<GTeamEntity>;
  tenantId: Scalars['String'];
  timeline: GConversationTimelineContinuationTokenConnection;
  totalResolutionTimeInMinutes?: Maybe<Scalars['Float']>;
  totalSnoozedTimeInMinutes?: Maybe<Scalars['Float']>;
  updated: Scalars['DateTime'];
};


export type GConversationEntityTimelineArgs = {
  continuationToken?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type GConversationEvent = {
  __typename?: 'ConversationEvent';
  conversation: GConversationEntity;
  conversationId: Scalars['String'];
  eventType: GAppEventType;
  executingAgent?: Maybe<GAgentEntity>;
  metadata?: Maybe<GConversationEventMetaData>;
};

export type GConversationEventMetaData = GConversationAssignedMetaData | GConversationSnoozedMetaData | GConversationTagChangeMetaData | GConversationTransferredMetaData;

export type GConversationIndex = {
  __typename?: 'ConversationIndex';
  contact?: Maybe<GContactEntity>;
  contactId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  tags: Array<Scalars['String']>;
  teamId?: Maybe<Scalars['String']>;
};

export type GConversationNotFoundError = GUserError & {
  __typename?: 'ConversationNotFoundError';
  code: GUserErrorCode;
  message: Scalars['String'];
};

export type GConversationSnippetEntity = {
  __typename?: 'ConversationSnippetEntity';
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdByAgent?: Maybe<GAgentEntity>;
  deleted: Scalars['Boolean'];
  id: Scalars['String'];
  private: Scalars['Boolean'];
  restrictToChannels: Array<GConversationChannelItem>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GConversationSnippetNotFoundError = GUserError & {
  __typename?: 'ConversationSnippetNotFoundError';
  code: GUserErrorCode;
  message: Scalars['String'];
};

export type GConversationSnoozedMetaData = {
  __typename?: 'ConversationSnoozedMetaData';
  remindAt?: Maybe<Scalars['DateTime']>;
};

export enum GConversationStatusItem {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Snoozed = 'SNOOZED'
}

export type GConversationStatusModified = {
  __typename?: 'ConversationStatusModified';
  conversationId: Scalars['String'];
  fromAssignedAgentId?: Maybe<Scalars['String']>;
  fromAssignedTeamId?: Maybe<Scalars['String']>;
  fromStatus: GConversationStatusItem;
  tenantId: Scalars['String'];
  toAssignedAgentId?: Maybe<Scalars['String']>;
  toAssignedTeamId?: Maybe<Scalars['String']>;
  toStatus: GConversationStatusItem;
};

export type GConversationSummary = {
  __typename?: 'ConversationSummary';
  content: Scalars['String'];
  createdByAgent?: Maybe<GAgentEntity>;
  isOutdated: Scalars['Boolean'];
};

export type GConversationTagChangeMetaData = {
  __typename?: 'ConversationTagChangeMetaData';
  added: Array<Scalars['String']>;
  removed: Array<Scalars['String']>;
};

export type GConversationTimelineContinuationTokenConnection = {
  __typename?: 'ConversationTimelineContinuationTokenConnection';
  continuationToken?: Maybe<Scalars['String']>;
  items: Array<Maybe<GConversationTimelineEntity>>;
};

export type GConversationTimelineData = GConversationAgentComment | GConversationAgentMessage | GConversationBotMessage | GConversationBotSuggestion | GConversationContactMessage | GConversationEvent | GConversationSummary;

export type GConversationTimelineEntity = {
  __typename?: 'ConversationTimelineEntity';
  conversation: GConversationEntity;
  conversationId: Scalars['String'];
  data: GConversationTimelineData;
  id: Scalars['String'];
  linkedToTimelineId?: Maybe<Scalars['String']>;
  position: Scalars['Decimal'];
  timestamp: Scalars['DateTime'];
};

export type GConversationTimelineIndex = {
  __typename?: 'ConversationTimelineIndex';
  conversationId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  textPlain?: Maybe<Scalars['String']>;
};

export type GConversationTransferredMetaData = {
  __typename?: 'ConversationTransferredMetaData';
  fromChannel: GConversationChannelItem;
  fromContactAddress?: Maybe<GContactAddressEntity>;
  toChannel: GConversationChannelItem;
  toContactAddress?: Maybe<GContactAddressEntity>;
};

export type GCreateAddressInput = {
  address: Scalars['String'];
  contactId: Scalars['String'];
  type?: InputMaybe<GInputContactAddressTypeItem>;
};

export type GCreateAgentInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  role: GTenantRoleItem;
  teamIds: Array<Scalars['String']>;
};

export type GCreateAgentPayload = {
  __typename?: 'CreateAgentPayload';
  agent?: Maybe<GAgentEntity>;
};

export type GCreateAgentPushSubscriptionInput = {
  clientMode: GAgentPushSubscriptionClientModeItem;
  subscription: GCreateAgentPushSubscriptionSettingsInput;
};

export type GCreateAgentPushSubscriptionPayload = {
  __typename?: 'CreateAgentPushSubscriptionPayload';
  success?: Maybe<Scalars['Boolean']>;
};

export type GCreateAgentPushSubscriptionSettingsInput = {
  apn?: InputMaybe<GCreateAgentSubscriptionApnInput>;
  webPush?: InputMaybe<GCreateAgentPushSubscriptionWebPushInput>;
};

export type GCreateAgentPushSubscriptionWebPushInput = {
  auth: Scalars['String'];
  endpoint: Scalars['String'];
  p25dh: Scalars['String'];
};

export type GCreateAgentSubscriptionApnInput = {
  deviceToken: Scalars['String'];
};

export type GCreateChatChannelInput = {
  copySettingsFromConnectedServiceId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type GCreateChatChannelPayload = {
  __typename?: 'CreateChatChannelPayload';
  channel?: Maybe<GConnectedServiceChatEntity>;
};

export type GCreateContactAddressError = GContactAddressConflictError | GContactNotFoundError;

export type GCreateContactAddressInput = {
  address: Scalars['String'];
  type?: InputMaybe<GInputContactAddressTypeItem>;
};

export type GCreateContactAddressPayload = {
  __typename?: 'CreateContactAddressPayload';
  contactAddress?: Maybe<GContactAddressEntity>;
  errors?: Maybe<Array<GCreateContactAddressError>>;
};

export type GCreateContactError = GAgentNotFoundError | GContactAddressConflictError;

export type GCreateContactInput = {
  addresses: Array<GCreateContactAddressInput>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  tags: Array<Scalars['String']>;
};

export type GCreateContactPayload = {
  __typename?: 'CreateContactPayload';
  contact?: Maybe<GContactEntity>;
  errors?: Maybe<Array<GCreateContactError>>;
};

export type GCreateConversationAgentCommentError = GConversationNotFoundError;

export type GCreateConversationAgentCommentInput = {
  attachments: Array<Scalars['String']>;
  content: Scalars['String'];
  conversationId: Scalars['String'];
  linkedToTimelineId?: InputMaybe<Scalars['String']>;
};

export type GCreateConversationAgentCommentPayload = {
  __typename?: 'CreateConversationAgentCommentPayload';
  conversationTimeline?: Maybe<GConversationTimelineEntity>;
  errors?: Maybe<Array<GCreateConversationAgentCommentError>>;
};

export type GCreateConversationAgentMessageError = GConversationNotFoundError;

export type GCreateConversationAgentMessageInput = {
  attachments: Array<Scalars['String']>;
  content: Scalars['String'];
  conversationId: Scalars['String'];
  linkedToTimelineId?: InputMaybe<Scalars['String']>;
};

export type GCreateConversationAgentMessagePayload = {
  __typename?: 'CreateConversationAgentMessagePayload';
  conversationTimeline?: Maybe<GConversationTimelineEntity>;
  errors?: Maybe<Array<GCreateConversationAgentMessageError>>;
};

export type GCreateConversationError = GContactNotFoundError;

export type GCreateConversationInput = {
  assignToAgentId?: InputMaybe<Scalars['String']>;
  connectedServiceId: Scalars['String'];
  contactAddressId: Scalars['String'];
  contactId: Scalars['String'];
  description: Scalars['String'];
  done: Scalars['Boolean'];
  linkedToConversationId?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  remindAt?: InputMaybe<Scalars['DateTime']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  teamId?: InputMaybe<Scalars['String']>;
};

export type GCreateConversationPayload = {
  __typename?: 'CreateConversationPayload';
  conversation?: Maybe<GConversationEntity>;
  errors?: Maybe<Array<GCreateConversationError>>;
};

export type GCreateConversationSnippetInput = {
  content: Scalars['String'];
  private: Scalars['Boolean'];
  restrictToChannels: Array<GConversationChannelItem>;
  title: Scalars['String'];
};

export type GCreateConversationSnippetPayload = {
  __typename?: 'CreateConversationSnippetPayload';
  snippet?: Maybe<GConversationSnippetEntity>;
};

export type GCreateConversationSummaryError = GAssistantError | GConversationNotFoundError;

export type GCreateConversationSummaryInput = {
  conversationId: Scalars['String'];
};

export type GCreateConversationSummaryPayload = {
  __typename?: 'CreateConversationSummaryPayload';
  errors?: Maybe<Array<GCreateConversationSummaryError>>;
  summary?: Maybe<GConversationTimelineEntity>;
};

export type GCreateDemoConversationsPayload = {
  __typename?: 'CreateDemoConversationsPayload';
  conversations?: Maybe<Array<GConversationEntity>>;
};

export type GCreateEmailChannelInput = {
  emailLocalPart: Scalars['String'];
  teamId?: InputMaybe<Scalars['String']>;
};

export type GCreateEmailChannelPayload = {
  __typename?: 'CreateEmailChannelPayload';
  channel?: Maybe<GConnectedServiceEmailEntity>;
};

export type GCreateKnowledgeBaseArticleInput = {
  audience: GKnowledgeBaseArticleAudienceItem;
  draft: Scalars['Boolean'];
  questions: Array<Scalars['String']>;
  solution: Scalars['String'];
  title: Scalars['String'];
};

export type GCreateKnowledgeBaseArticlePayload = {
  __typename?: 'CreateKnowledgeBaseArticlePayload';
  knowledgeBaseArticle?: Maybe<GKnowledgeBaseArticleEntity>;
};

export type GCreateKnowledgeBaseArticleSuggestionsFromConversationError = GConversationNotFoundError;

export type GCreateKnowledgeBaseArticleSuggestionsFromConversationInput = {
  conversationId: Scalars['String'];
};

export type GCreateKnowledgeBaseArticleSuggestionsFromConversationPayload = {
  __typename?: 'CreateKnowledgeBaseArticleSuggestionsFromConversationPayload';
  articles?: Maybe<Array<GKnowledgeBaseArticleEntity>>;
  errors?: Maybe<Array<GCreateKnowledgeBaseArticleSuggestionsFromConversationError>>;
};

export type GCreateMessengerChannelInput = {
  accessToken: Scalars['String'];
  pageId: Scalars['String'];
  teamId?: InputMaybe<Scalars['String']>;
};

export type GCreateMessengerChannelPayload = {
  __typename?: 'CreateMessengerChannelPayload';
  channel?: Maybe<GConnectedServiceMessengerEntity>;
};

export type GCreateSmsSubNumberChannelInput = {
  smsPrefix?: InputMaybe<Scalars['String']>;
  smsSuffix?: InputMaybe<Scalars['String']>;
};

export type GCreateSmsSubNumberChannelPayload = {
  __typename?: 'CreateSmsSubNumberChannelPayload';
  channel?: Maybe<GConnectedServiceSmsSubNumberEntity>;
};

export type GCreateSmsVonageChannelInput = {
  country: GPhoneNumberCountry;
  smsPrefix?: InputMaybe<Scalars['String']>;
  smsSuffix?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['String']>;
};

export type GCreateSmsVonageChannelPayload = {
  __typename?: 'CreateSmsVonageChannelPayload';
  channel?: Maybe<GConnectedServiceVonageEntity>;
};

export type GCreateTeamError = GTeamAlreadyExistsError;

export type GCreateTeamInput = {
  emoji?: InputMaybe<Scalars['String']>;
  memberAgentIds: Array<Scalars['String']>;
  name: Scalars['String'];
};

export type GCreateTeamPayload = {
  __typename?: 'CreateTeamPayload';
  errors?: Maybe<Array<GCreateTeamError>>;
  team?: Maybe<GTeamEntity>;
};

export type GCreateTenantInput = {
  agent: GAgentDataInput;
  createInFrontegg?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  partnerId?: InputMaybe<Scalars['String']>;
  subdomain: Scalars['String'];
  tenantId: Scalars['String'];
};

export type GCreateTenantPayload = {
  __typename?: 'CreateTenantPayload';
  tenant?: Maybe<GTenantEntity>;
};

export type GDeleteAgentInput = {
  agentId: Scalars['String'];
};

export type GDeleteAgentPayload = {
  __typename?: 'DeleteAgentPayload';
  agent?: Maybe<GAgentEntity>;
};

export type GDeleteConversationSnippetError = GConversationSnippetNotFoundError;

export type GDeleteConversationSnippetInput = {
  id: Scalars['String'];
};

export type GDeleteConversationSnippetPayload = {
  __typename?: 'DeleteConversationSnippetPayload';
  errors?: Maybe<Array<GDeleteConversationSnippetError>>;
  snippet?: Maybe<GConversationSnippetEntity>;
};

export type GDeleteKnowledgeBaseArticleError = GKnowledgeBaseArticleIsPublishingError | GKnowledgeBaseArticleNotFoundError;

export type GDeleteKnowledgeBaseArticleInput = {
  id: Scalars['String'];
};

export type GDeleteKnowledgeBaseArticlePayload = {
  __typename?: 'DeleteKnowledgeBaseArticlePayload';
  article?: Maybe<GKnowledgeBaseArticleEntity>;
  errors?: Maybe<Array<GDeleteKnowledgeBaseArticleError>>;
};

export type GDeleteMessengerChannelInput = {
  connectedServiceId: Scalars['String'];
};

export type GDeleteMessengerChannelPayload = {
  __typename?: 'DeleteMessengerChannelPayload';
  channel?: Maybe<GConnectedServiceMessengerEntity>;
};

export type GDeleteTeamError = GTeamNotFoundError;

export type GDeleteTeamInput = {
  id: Scalars['String'];
};

export type GDeleteTeamPayload = {
  __typename?: 'DeleteTeamPayload';
  errors?: Maybe<Array<GDeleteTeamError>>;
  team?: Maybe<GTeamEntity>;
};

export type GEditContactError = GAgentNotFoundError | GContactAddressConflictError;

export type GEditContactInput = {
  input: GModifyContactInput;
};

export type GEditContactPayload = {
  __typename?: 'EditContactPayload';
  contact?: Maybe<GContactEntity>;
  errors?: Maybe<Array<GEditContactError>>;
};

export type GEditContactRemoveAddressInput = {
  contactAddressId: Scalars['String'];
};

export type GFacebookPageOptionsResult = {
  __typename?: 'FacebookPageOptionsResult';
  pageId: Scalars['String'];
  pageName: Scalars['String'];
};

export type GFixGrammarTextWithHtmlInput = {
  text: Scalars['String'];
};

export type GFixGrammarTextWithHtmlPayload = {
  __typename?: 'FixGrammarTextWithHtmlPayload';
  text: Scalars['String'];
};

export type GGetAgentConversationsFilterInput = {
  agentId?: InputMaybe<Array<Scalars['String']>>;
  status: GConversationStatusItem;
  teamId?: InputMaybe<Array<Scalars['String']>>;
  unassigned?: InputMaybe<Scalars['Boolean']>;
};

export type GGetAgentsFilterInput = {
  status?: InputMaybe<Array<GAgentStatusItem>>;
};

export type GGetAppEventsFilterInput = {
  agentId?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['String']>;
};

export type GGetConversationSnippetsPayload = {
  __typename?: 'GetConversationSnippetsPayload';
  continuationToken?: Maybe<Scalars['String']>;
  items: Array<GConversationSnippetEntity>;
};

export type GGetConversationTransferOptionsPayload = {
  __typename?: 'GetConversationTransferOptionsPayload';
  options: Array<GTransferOption>;
};

export type GGetKnowledgeBaseArticlesPayload = {
  __typename?: 'GetKnowledgeBaseArticlesPayload';
  continuationToken?: Maybe<Scalars['String']>;
  items: Array<GKnowledgeBaseArticleEntity>;
};

export type GImproveTextWithHtmlInput = {
  text: Scalars['String'];
};

export type GImproveTextWithHtmlPayload = {
  __typename?: 'ImproveTextWithHtmlPayload';
  text: Scalars['String'];
};

export enum GInputContactAddressTypeItem {
  ChatVisitorId = 'CHAT_VISITOR_ID',
  EmailAddress = 'EMAIL_ADDRESS',
  FacebookUserId = 'FACEBOOK_USER_ID',
  PhoneNumber = 'PHONE_NUMBER',
  Unknown = 'UNKNOWN'
}

export type GInvalidLanguageCodeError = GUserError & {
  __typename?: 'InvalidLanguageCodeError';
  code: GUserErrorCode;
  message: Scalars['String'];
};

export type GKeyValuePairOfStringAndIListOfString = {
  __typename?: 'KeyValuePairOfStringAndIListOfString';
  key: Scalars['String'];
  value: Array<Scalars['String']>;
};

export type GKeyValuePairOfStringAndInt64 = {
  __typename?: 'KeyValuePairOfStringAndInt64';
  key: Scalars['String'];
  value: Scalars['Long'];
};

export enum GKnowledgeBaseArticleAudienceItem {
  Internal = 'INTERNAL',
  Public = 'PUBLIC'
}

export type GKnowledgeBaseArticleEntity = {
  __typename?: 'KnowledgeBaseArticleEntity';
  audience: GKnowledgeBaseArticleAudienceItem;
  botReasoning?: Maybe<Scalars['String']>;
  botTopic?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  discardedFacts?: Maybe<Scalars['String']>;
  hasPublishingError: Scalars['Boolean'];
  id: Scalars['String'];
  isPublishing: Scalars['Boolean'];
  objective?: Maybe<Scalars['String']>;
  originalFacts?: Maybe<Scalars['String']>;
  questions: Array<Scalars['String']>;
  solution: Scalars['String'];
  status: GKnowledgeBaseArticleStatusItem;
  title: Scalars['String'];
  updated: Scalars['DateTime'];
};

export type GKnowledgeBaseArticleIsPublishingError = GUserError & {
  __typename?: 'KnowledgeBaseArticleIsPublishingError';
  code: GUserErrorCode;
  message: Scalars['String'];
};

export type GKnowledgeBaseArticleNotFoundError = GUserError & {
  __typename?: 'KnowledgeBaseArticleNotFoundError';
  code: GUserErrorCode;
  message: Scalars['String'];
};

export enum GKnowledgeBaseArticleStatusItem {
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  PendingApproval = 'PENDING_APPROVAL',
  Published = 'PUBLISHED',
  SuggestedByBot = 'SUGGESTED_BY_BOT',
  Unknown = 'UNKNOWN'
}

export type GKnowledgeBaseIndex = {
  __typename?: 'KnowledgeBaseIndex';
  audience?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastUpdated?: Maybe<Scalars['DateTime']>;
  solution?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type GKnowledgeBaseTenantSettingsEntity = {
  __typename?: 'KnowledgeBaseTenantSettingsEntity';
  approvalFlowEnabled: Scalars['Boolean'];
  articleLanguageIso639: Scalars['String'];
  id: Scalars['String'];
};

export enum GLocaleItem {
  English = 'ENGLISH',
  Norwegian = 'NORWEGIAN'
}

export type GMarkAllAgentNotificationsAsSeenError = GAgentNotificationNotFoundError;

export type GMarkAllAgentNotificationsAsSeenPayload = {
  __typename?: 'MarkAllAgentNotificationsAsSeenPayload';
  errors?: Maybe<Array<GMarkAllAgentNotificationsAsSeenError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum GMessageStatusItem {
  Cancelled = 'CANCELLED',
  Delivered = 'DELIVERED',
  Failed = 'FAILED',
  Seen = 'SEEN',
  Submitted = 'SUBMITTED'
}

export type GModifyAgentError = GAgentNotAuthorizedError | GAgentNotFoundError;

export type GModifyAgentInput = {
  agentId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<GLocaleItem>;
  role?: InputMaybe<GTenantRoleItem>;
  settings?: InputMaybe<GAgentSettingsInput>;
  workerId?: InputMaybe<Scalars['String']>;
};

export type GModifyAgentNotificationError = GAgentNotificationNotFoundError;

export type GModifyAgentNotificationInput = {
  agentNotificationId: Scalars['String'];
  seen?: InputMaybe<Scalars['Boolean']>;
};

export type GModifyAgentNotificationPayload = {
  __typename?: 'ModifyAgentNotificationPayload';
  agentNotification?: Maybe<GAgentNotificationEntity>;
  errors?: Maybe<Array<GModifyAgentNotificationError>>;
};

export type GModifyAgentNotificationSettingsInput = {
  conversationAgentMentioned?: InputMaybe<GAgentSettingsNotificationFlagsInput>;
  conversationAssignedAgentContactMessageCreated?: InputMaybe<GAgentSettingsNotificationFlagsInput>;
  conversationAssignedAgentCreatedByContact?: InputMaybe<GAgentSettingsNotificationFlagsInput>;
  conversationAssignedAgentUnSnoozed?: InputMaybe<GAgentSettingsNotificationFlagsInput>;
  conversationAssignedTeamContactMessageCreated?: InputMaybe<GAgentSettingsNotificationFlagsInput>;
  conversationAssignedTeamCreatedByContact?: InputMaybe<GAgentSettingsNotificationFlagsInput>;
  conversationAssignedTeamUnSnoozed?: InputMaybe<GAgentSettingsNotificationFlagsInput>;
  conversationAssignedToAgent?: InputMaybe<GAgentSettingsNotificationFlagsInput>;
  conversationAssignedToTeam?: InputMaybe<GAgentSettingsNotificationFlagsInput>;
  conversationUnassignedContactMessageCreated?: InputMaybe<GAgentSettingsNotificationFlagsInput>;
  conversationUnassignedCreatedByContact?: InputMaybe<GAgentSettingsNotificationFlagsInput>;
  conversationUnassignedUnSnoozed?: InputMaybe<GAgentSettingsNotificationFlagsInput>;
};

export type GModifyAgentNotificationSettingsPayload = {
  __typename?: 'ModifyAgentNotificationSettingsPayload';
  settings?: Maybe<GAgentNotificationSettingEntity>;
};

export type GModifyAgentPayload = {
  __typename?: 'ModifyAgentPayload';
  agent?: Maybe<GAgentEntity>;
  errors?: Maybe<Array<GModifyAgentError>>;
};

export type GModifyBotAssistantTenantSettingsError = GAgentNotAuthorizedError;

export type GModifyBotAssistantTenantSettingsInput = {
  defaultBehaviour?: InputMaybe<GBotAssistantBehaviourSettingsInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  minimumChunkRelevance?: InputMaybe<Scalars['Float']>;
  minimumObjectiveRelevance?: InputMaybe<Scalars['Float']>;
  minimumQuestionRelevance?: InputMaybe<Scalars['Float']>;
};

export type GModifyBotAssistantTenantSettingsPayload = {
  __typename?: 'ModifyBotAssistantTenantSettingsPayload';
  errors?: Maybe<Array<GModifyBotAssistantTenantSettingsError>>;
  settings?: Maybe<GBotAssistantTenantSettingsEntity>;
};

export type GModifyChatChannelInput = {
  behaviour?: InputMaybe<GWidgetConfigurationBehaviourInput>;
  conversation?: InputMaybe<GWidgetConfigurationConversationInput>;
  id: Scalars['String'];
  locale?: InputMaybe<GLocaleItem>;
  preChatSurvey?: InputMaybe<Array<GModifyChatChannelPreChatSurveyFieldsInput>>;
  teamId?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<GWidgetConfigurationTextInput>;
  theme?: InputMaybe<GWidgetConfigurationThemeInput>;
};

export type GModifyChatChannelPayload = {
  __typename?: 'ModifyChatChannelPayload';
  channel?: Maybe<GConnectedServiceChatEntity>;
};

export type GModifyChatChannelPreChatSurveyFieldsInput = {
  hint?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  options?: InputMaybe<Array<Scalars['String']>>;
  placeholder?: InputMaybe<Scalars['String']>;
  required: Scalars['Boolean'];
  targetEntity: GChatPreChatSurveyFieldTargetEntityType;
  type: GChatPreChatSurveyFieldType;
};

export type GModifyContactAddressInput = {
  add?: InputMaybe<Array<GModifyContactNewAddressInput>>;
  remove?: InputMaybe<Array<GEditContactRemoveAddressInput>>;
};

export type GModifyContactInput = {
  addresses?: InputMaybe<GModifyContactAddressInput>;
  contactId: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type GModifyContactNewAddressInput = {
  address: Scalars['String'];
  type?: InputMaybe<GInputContactAddressTypeItem>;
};

export type GModifyConversationError = GAgentIsNotAuthorizedForConversationError | GAgentNotFoundError | GConnectedServiceNotFoundError | GContactNotFoundError | GConversationNotFoundError | GTeamNotFoundError;

export type GModifyConversationInput = {
  assignToAgentId?: InputMaybe<Scalars['String']>;
  botAssistantMode?: InputMaybe<GConversationBotAssistantModeItem>;
  channelType?: InputMaybe<GConversationChannelItem>;
  connectedServiceId?: InputMaybe<Scalars['String']>;
  contactAddressId?: InputMaybe<Scalars['String']>;
  contactId?: InputMaybe<Scalars['String']>;
  conversationId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  remindAt?: InputMaybe<Scalars['String']>;
  remindAtTimeZone?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<GConversationStatusItem>;
  teamId?: InputMaybe<Scalars['String']>;
};

export type GModifyConversationPayload = {
  __typename?: 'ModifyConversationPayload';
  conversation?: Maybe<GConversationEntity>;
  errors?: Maybe<Array<GModifyConversationError>>;
  events?: Maybe<Array<GConversationTimelineEntity>>;
};

export type GModifyConversationSnippetError = GConversationSnippetNotFoundError;

export type GModifyConversationSnippetInput = {
  content?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  private?: InputMaybe<Scalars['Boolean']>;
  restrictToChannels?: InputMaybe<Array<GConversationChannelItem>>;
  title?: InputMaybe<Scalars['String']>;
};

export type GModifyConversationSnippetPayload = {
  __typename?: 'ModifyConversationSnippetPayload';
  errors?: Maybe<Array<GModifyConversationSnippetError>>;
  snippet?: Maybe<GConversationSnippetEntity>;
};

export type GModifyKnowledgeBaseArticleError = GKnowledgeBaseArticleIsPublishingError | GKnowledgeBaseArticleNotFoundError;

export type GModifyKnowledgeBaseArticleInput = {
  audience?: InputMaybe<GKnowledgeBaseArticleAudienceItem>;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  questions?: InputMaybe<Array<Scalars['String']>>;
  solution?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type GModifyKnowledgeBaseArticlePayload = {
  __typename?: 'ModifyKnowledgeBaseArticlePayload';
  errors?: Maybe<Array<GModifyKnowledgeBaseArticleError>>;
  knowledgeBaseArticle?: Maybe<GKnowledgeBaseArticleEntity>;
};

export type GModifyKnowledgeBaseTenantSettingsError = GAgentNotAuthorizedError | GInvalidLanguageCodeError;

export type GModifyKnowledgeBaseTenantSettingsInput = {
  approvalFlowEnabled?: InputMaybe<Scalars['Boolean']>;
  articleLanguageIso639?: InputMaybe<Scalars['String']>;
};

export type GModifyKnowledgeBaseTenantSettingsPayload = {
  __typename?: 'ModifyKnowledgeBaseTenantSettingsPayload';
  errors?: Maybe<Array<GModifyKnowledgeBaseTenantSettingsError>>;
  settings?: Maybe<GKnowledgeBaseTenantSettingsEntity>;
};

export type GModifyTeamError = GTeamNotFoundError;

export type GModifyTeamInput = {
  emoji?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  memberAgentIds?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
};

export type GModifyTeamPayload = {
  __typename?: 'ModifyTeamPayload';
  errors?: Maybe<Array<GModifyTeamError>>;
  team?: Maybe<GTeamEntity>;
};

export type GMutation = {
  __typename?: 'Mutation';
  agentStopWatchConversation: GAgentStopWatchConversationPayload;
  agentStoppedTypingInConversation: GAgentStoppedTypingInConversationPayload;
  agentTypingInConversation: GAgentTypingInConversationPayload;
  agentWatchConversation: GAgentWatchConversationPayload;
  createAgent: GCreateAgentPayload;
  createAgentPushSubscription: GCreateAgentPushSubscriptionPayload;
  createChatChannel: GCreateChatChannelPayload;
  createContact: GCreateContactPayload;
  createContactAddress: GCreateContactAddressPayload;
  createConversation: GCreateConversationPayload;
  createConversationAgentComment: GCreateConversationAgentCommentPayload;
  createConversationAgentMessage: GCreateConversationAgentMessagePayload;
  createConversationSnippet: GCreateConversationSnippetPayload;
  createConversationSummary: GCreateConversationSummaryPayload;
  createDemoConversations: GCreateDemoConversationsPayload;
  createEmailChannel: GCreateEmailChannelPayload;
  createKnowledgeBaseArticle: GCreateKnowledgeBaseArticlePayload;
  createKnowledgeBaseArticleSuggestionsFromConversation: GCreateKnowledgeBaseArticleSuggestionsFromConversationPayload;
  createMessengerChannel: GCreateMessengerChannelPayload;
  createSmsSubNumberChannel: GCreateSmsSubNumberChannelPayload;
  createSmsVonageChannel: GCreateSmsVonageChannelPayload;
  createTeam: GCreateTeamPayload;
  createTenant: GCreateTenantPayload;
  deleteAgent: GDeleteAgentPayload;
  deleteConversationSnippet: GDeleteConversationSnippetPayload;
  deleteKnowledgeBaseArticle: GDeleteKnowledgeBaseArticlePayload;
  deleteMessengerChannel: GDeleteMessengerChannelPayload;
  deleteTeam: GDeleteTeamPayload;
  editContact: GEditContactPayload;
  fixGrammarTextWithHtml: GFixGrammarTextWithHtmlPayload;
  improveTextWithHtml: GImproveTextWithHtmlPayload;
  markAllAgentNotificationsAsSeen: GMarkAllAgentNotificationsAsSeenPayload;
  modifyAgent: GModifyAgentPayload;
  modifyAgentNotification: GModifyAgentNotificationPayload;
  modifyAgentNotificationSettings: GModifyAgentNotificationSettingsPayload;
  modifyBotAssistantTenantSettings: GModifyBotAssistantTenantSettingsPayload;
  modifyChatChannel: GModifyChatChannelPayload;
  modifyConversation: GModifyConversationPayload;
  modifyConversationSnippet: GModifyConversationSnippetPayload;
  modifyKnowledgeBaseArticle: GModifyKnowledgeBaseArticlePayload;
  modifyKnowledgeBaseTenantSettings: GModifyKnowledgeBaseTenantSettingsPayload;
  modifyTeam: GModifyTeamPayload;
  setAgentAwayStatus: GSetAgentAwayStatusPayload;
  translateTextWithHtml: GTranslateTextWithHtmlPayload;
};


export type GMutationAgentStopWatchConversationArgs = {
  input: GAgentStopWatchConversationInput;
};


export type GMutationAgentStoppedTypingInConversationArgs = {
  input: GAgentStoppedTypingInConversationInput;
};


export type GMutationAgentTypingInConversationArgs = {
  input: GAgentTypingInConversationInput;
};


export type GMutationAgentWatchConversationArgs = {
  input: GAgentWatchConversationInput;
};


export type GMutationCreateAgentArgs = {
  input: GCreateAgentInput;
};


export type GMutationCreateAgentPushSubscriptionArgs = {
  input: GCreateAgentPushSubscriptionInput;
};


export type GMutationCreateChatChannelArgs = {
  input: GCreateChatChannelInput;
};


export type GMutationCreateContactArgs = {
  input: GCreateContactInput;
};


export type GMutationCreateContactAddressArgs = {
  input: GCreateAddressInput;
};


export type GMutationCreateConversationArgs = {
  input: GCreateConversationInput;
};


export type GMutationCreateConversationAgentCommentArgs = {
  input: GCreateConversationAgentCommentInput;
};


export type GMutationCreateConversationAgentMessageArgs = {
  input: GCreateConversationAgentMessageInput;
};


export type GMutationCreateConversationSnippetArgs = {
  input: GCreateConversationSnippetInput;
};


export type GMutationCreateConversationSummaryArgs = {
  input: GCreateConversationSummaryInput;
};


export type GMutationCreateEmailChannelArgs = {
  input: GCreateEmailChannelInput;
};


export type GMutationCreateKnowledgeBaseArticleArgs = {
  input: GCreateKnowledgeBaseArticleInput;
};


export type GMutationCreateKnowledgeBaseArticleSuggestionsFromConversationArgs = {
  input: GCreateKnowledgeBaseArticleSuggestionsFromConversationInput;
};


export type GMutationCreateMessengerChannelArgs = {
  input: GCreateMessengerChannelInput;
};


export type GMutationCreateSmsSubNumberChannelArgs = {
  input: GCreateSmsSubNumberChannelInput;
};


export type GMutationCreateSmsVonageChannelArgs = {
  input: GCreateSmsVonageChannelInput;
};


export type GMutationCreateTeamArgs = {
  input: GCreateTeamInput;
};


export type GMutationCreateTenantArgs = {
  input: GCreateTenantInput;
};


export type GMutationDeleteAgentArgs = {
  input: GDeleteAgentInput;
};


export type GMutationDeleteConversationSnippetArgs = {
  input: GDeleteConversationSnippetInput;
};


export type GMutationDeleteKnowledgeBaseArticleArgs = {
  input: GDeleteKnowledgeBaseArticleInput;
};


export type GMutationDeleteMessengerChannelArgs = {
  input: GDeleteMessengerChannelInput;
};


export type GMutationDeleteTeamArgs = {
  input: GDeleteTeamInput;
};


export type GMutationEditContactArgs = {
  input: GEditContactInput;
};


export type GMutationFixGrammarTextWithHtmlArgs = {
  input: GFixGrammarTextWithHtmlInput;
};


export type GMutationImproveTextWithHtmlArgs = {
  input: GImproveTextWithHtmlInput;
};


export type GMutationModifyAgentArgs = {
  input: GModifyAgentInput;
};


export type GMutationModifyAgentNotificationArgs = {
  input: GModifyAgentNotificationInput;
};


export type GMutationModifyAgentNotificationSettingsArgs = {
  input: GModifyAgentNotificationSettingsInput;
};


export type GMutationModifyBotAssistantTenantSettingsArgs = {
  input: GModifyBotAssistantTenantSettingsInput;
};


export type GMutationModifyChatChannelArgs = {
  input: GModifyChatChannelInput;
};


export type GMutationModifyConversationArgs = {
  input: GModifyConversationInput;
};


export type GMutationModifyConversationSnippetArgs = {
  input: GModifyConversationSnippetInput;
};


export type GMutationModifyKnowledgeBaseArticleArgs = {
  input: GModifyKnowledgeBaseArticleInput;
};


export type GMutationModifyKnowledgeBaseTenantSettingsArgs = {
  input: GModifyKnowledgeBaseTenantSettingsInput;
};


export type GMutationModifyTeamArgs = {
  input: GModifyTeamInput;
};


export type GMutationSetAgentAwayStatusArgs = {
  input: GSetAgentAwayStatusInput;
};


export type GMutationTranslateTextWithHtmlArgs = {
  input: GTranslateTextWithHtmlInput;
};

export enum GNameVariationItem {
  FirstNameAndLastNameInitial = 'FIRST_NAME_AND_LAST_NAME_INITIAL',
  FirstNameOnly = 'FIRST_NAME_ONLY',
  FullName = 'FULL_NAME',
  InitialsOnly = 'INITIALS_ONLY',
  LastNameOnly = 'LAST_NAME_ONLY'
}

export enum GNotificationEvent {
  ConversationAgentMentioned = 'CONVERSATION_AGENT_MENTIONED',
  ConversationAssignedAgentContactMessageCreated = 'CONVERSATION_ASSIGNED_AGENT_CONTACT_MESSAGE_CREATED',
  ConversationAssignedAgentCreatedByContact = 'CONVERSATION_ASSIGNED_AGENT_CREATED_BY_CONTACT',
  ConversationAssignedAgentUnSnoozed = 'CONVERSATION_ASSIGNED_AGENT_UN_SNOOZED',
  ConversationAssignedTeamContactMessageCreated = 'CONVERSATION_ASSIGNED_TEAM_CONTACT_MESSAGE_CREATED',
  ConversationAssignedTeamCreatedByContact = 'CONVERSATION_ASSIGNED_TEAM_CREATED_BY_CONTACT',
  ConversationAssignedTeamUnSnoozed = 'CONVERSATION_ASSIGNED_TEAM_UN_SNOOZED',
  ConversationAssignedToAgent = 'CONVERSATION_ASSIGNED_TO_AGENT',
  ConversationAssignedToTeam = 'CONVERSATION_ASSIGNED_TO_TEAM',
  ConversationUnassignedContactMessageCreated = 'CONVERSATION_UNASSIGNED_CONTACT_MESSAGE_CREATED',
  ConversationUnassignedCreatedByContact = 'CONVERSATION_UNASSIGNED_CREATED_BY_CONTACT',
  ConversationUnassignedUnSnoozed = 'CONVERSATION_UNASSIGNED_UN_SNOOZED',
  Unknown = 'UNKNOWN'
}

export type GPartnerEntity = {
  __typename?: 'PartnerEntity';
  id: Scalars['String'];
  name: Scalars['String'];
  whiteLabelProductName?: Maybe<Scalars['String']>;
};

export enum GPhoneNumberCountry {
  Es = 'ES',
  No = 'NO',
  Uk = 'UK',
  Us = 'US'
}

export type GQuery = {
  __typename?: 'Query';
  agentById: GAgentEntity;
  agentNotificationSettings: GAgentNotificationSettingEntity;
  agentNotifications: GAgentNotificationContinuationTokenConnection;
  agents: Array<GAgentEntity>;
  appEvents: Array<GAppEventByTenant>;
  botAssistantTenantSettings: GBotAssistantTenantSettingsEntity;
  channels: Array<GBaseConnectedServiceEntity>;
  chatChannelById: GConnectedServiceChatEntity;
  chatChannels: Array<GConnectedServiceChatEntity>;
  contactById: GContactEntity;
  contactConversations: GConversationContinuationTokenConnection;
  conversationById: GConversationEntity;
  conversationCount: GConversationCountPayload;
  conversationSnippetById: GConversationSnippetEntity;
  conversationSnippets: GGetConversationSnippetsPayload;
  conversationTransferOptions: GGetConversationTransferOptionsPayload;
  conversations: GConversationContinuationTokenConnection;
  emailChannels: Array<GConnectedServiceEmailEntity>;
  facebookPageOptions: Array<GFacebookPageOptionsResult>;
  knowledgeBaseArticleById: GKnowledgeBaseArticleEntity;
  knowledgeBaseArticles: GGetKnowledgeBaseArticlesPayload;
  knowledgeBaseTenantSettings: GKnowledgeBaseTenantSettingsEntity;
  me: GAgentEntity;
  messengerChannels: Array<GConnectedServiceMessengerEntity>;
  ping: Scalars['String'];
  searchContact: GSearchResultsPayloadOfContactIndex;
  searchConversation: GSearchResultsPayloadOfConversationIndex;
  searchConversationTimeline: GSearchResultsPayloadOfConversationTimelineIndex;
  searchKnowledgeBase: GSearchResultsPayloadOfKnowledgeBaseIndex;
  smsSubNumberChannels: Array<GConnectedServiceSmsSubNumberEntity>;
  smsVonageChannels: Array<GConnectedServiceVonageEntity>;
  tags: Array<GTagEntity>;
  teamById: GTeamEntity;
  teams: Array<GTeamEntity>;
  tenant?: Maybe<GTenantEntity>;
  unseenAgentNotificationCount: GUnseenAgentNotificationCountPayload;
};


export type GQueryAgentByIdArgs = {
  id: Scalars['String'];
};


export type GQueryAgentNotificationsArgs = {
  continuationToken?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type GQueryAgentsArgs = {
  filter?: InputMaybe<GGetAgentsFilterInput>;
};


export type GQueryAppEventsArgs = {
  filter: GGetAppEventsFilterInput;
  take?: InputMaybe<Scalars['Int']>;
};


export type GQueryChatChannelByIdArgs = {
  id: Scalars['String'];
};


export type GQueryContactByIdArgs = {
  id: Scalars['String'];
};


export type GQueryContactConversationsArgs = {
  contactId: Scalars['String'];
  continuationToken?: InputMaybe<Scalars['String']>;
  includeTotalCount?: InputMaybe<Scalars['Boolean']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type GQueryConversationByIdArgs = {
  id: Scalars['String'];
};


export type GQueryConversationSnippetByIdArgs = {
  id: Scalars['String'];
};


export type GQueryConversationSnippetsArgs = {
  continuationToken?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type GQueryConversationTransferOptionsArgs = {
  id: Scalars['String'];
};


export type GQueryConversationsArgs = {
  continuationToken?: InputMaybe<Scalars['String']>;
  filter: GGetAgentConversationsFilterInput;
  includeTotalCount?: InputMaybe<Scalars['Boolean']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type GQueryFacebookPageOptionsArgs = {
  accessToken: Scalars['String'];
};


export type GQueryKnowledgeBaseArticleByIdArgs = {
  id: Scalars['String'];
};


export type GQueryKnowledgeBaseArticlesArgs = {
  continuationToken?: InputMaybe<Scalars['String']>;
  statusFilter?: InputMaybe<Array<GKnowledgeBaseArticleStatusItem>>;
  take?: InputMaybe<Scalars['Int']>;
};


export type GQuerySearchContactArgs = {
  query: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type GQuerySearchConversationArgs = {
  query: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type GQuerySearchConversationTimelineArgs = {
  query: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type GQuerySearchKnowledgeBaseArgs = {
  query: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type GQueryTeamByIdArgs = {
  id: Scalars['String'];
};

export type GSearchResultOfContactIndex = {
  __typename?: 'SearchResultOfContactIndex';
  document?: Maybe<GContactIndex>;
  highlights?: Maybe<Array<GKeyValuePairOfStringAndIListOfString>>;
  score?: Maybe<Scalars['Float']>;
};

export type GSearchResultOfConversationIndex = {
  __typename?: 'SearchResultOfConversationIndex';
  document?: Maybe<GConversationIndex>;
  highlights?: Maybe<Array<GKeyValuePairOfStringAndIListOfString>>;
  score?: Maybe<Scalars['Float']>;
};

export type GSearchResultOfConversationTimelineIndex = {
  __typename?: 'SearchResultOfConversationTimelineIndex';
  document?: Maybe<GConversationTimelineIndex>;
  highlights?: Maybe<Array<GKeyValuePairOfStringAndIListOfString>>;
  score?: Maybe<Scalars['Float']>;
};

export type GSearchResultOfKnowledgeBaseIndex = {
  __typename?: 'SearchResultOfKnowledgeBaseIndex';
  document?: Maybe<GKnowledgeBaseIndex>;
  highlights?: Maybe<Array<GKeyValuePairOfStringAndIListOfString>>;
  score?: Maybe<Scalars['Float']>;
};

export type GSearchResultsPayloadOfContactIndex = {
  __typename?: 'SearchResultsPayloadOfContactIndex';
  results: Array<GSearchResultOfContactIndex>;
  totalResults?: Maybe<Scalars['Long']>;
};

export type GSearchResultsPayloadOfConversationIndex = {
  __typename?: 'SearchResultsPayloadOfConversationIndex';
  results: Array<GSearchResultOfConversationIndex>;
  totalResults?: Maybe<Scalars['Long']>;
};

export type GSearchResultsPayloadOfConversationTimelineIndex = {
  __typename?: 'SearchResultsPayloadOfConversationTimelineIndex';
  results: Array<GSearchResultOfConversationTimelineIndex>;
  totalResults?: Maybe<Scalars['Long']>;
};

export type GSearchResultsPayloadOfKnowledgeBaseIndex = {
  __typename?: 'SearchResultsPayloadOfKnowledgeBaseIndex';
  results: Array<GSearchResultOfKnowledgeBaseIndex>;
  totalResults?: Maybe<Scalars['Long']>;
};

export type GSetAgentAwayStatusError = GAgentNotAuthorizedError | GAgentNotFoundError;

export type GSetAgentAwayStatusInput = {
  input: GSetAwayStatusInput;
};

export type GSetAgentAwayStatusPayload = {
  __typename?: 'SetAgentAwayStatusPayload';
  agent?: Maybe<GAgentEntity>;
  errors?: Maybe<Array<GSetAgentAwayStatusError>>;
};

export type GSetAwayStatusInput = {
  agentId: Scalars['String'];
  away?: InputMaybe<Scalars['Boolean']>;
  awayFromPhone?: InputMaybe<Scalars['Boolean']>;
};

export type GSubscription = {
  __typename?: 'Subscription';
  onAgentCreated: GAgentEntity;
  onAgentModified: GAgentEntity;
  onAgentNotificationCreated: GAgentNotificationEntity;
  onAgentNotificationModified: GAgentNotificationEntity;
  onAgentNotificationSeenModified: GAgentNotificationSeenModified;
  onAgentPing: GAgentEntity;
  onAgentStoppedTypingInConversationById: GAgentStoppedTypingInConversation;
  onAgentStoppedTypingInConversationByTenantId: GAgentStoppedTypingInConversation;
  onAgentStoppedWatchingConversationById: GConversationAgentWatchEntity;
  onAgentStoppedWatchingConversationByTenantId: GConversationAgentWatchEntity;
  onAgentTypingInConversationById: GAgentTypingInConversation;
  onAgentTypingInConversationByTenantId: GAgentTypingInConversation;
  onAgentWatchingConversationById: GConversationAgentWatchEntity;
  onAgentWatchingConversationByTenantId: GConversationAgentWatchEntity;
  onAppEventCreated: GAppEventByTenant;
  onContactStoppedTypingInConversationById: GContactStoppedTypingInConversation;
  onContactStoppedTypingInConversationByTenantId: GContactStoppedTypingInConversation;
  onContactTypingInConversationById: GContactTypingInConversation;
  onContactTypingInConversationByTenantId: GContactTypingInConversation;
  onConversationCreated: GConversationEntity;
  onConversationModified: GConversationEntity;
  onConversationTimelineCreated: GConversationTimelineEntity;
  onConversationTimelineModified: GConversationTimelineEntity;
  onKnowledgeBaseArticleModified: GKnowledgeBaseArticleEntity;
  onMultiTenantConversationCreated: GConversationEntity;
  onMultiTenantConversationStatusModified: GConversationStatusModified;
  onTeamCreated: GTeamEntity;
  onTeamModified: GTeamEntity;
};


export type GSubscriptionOnAgentStoppedTypingInConversationByIdArgs = {
  conversationId: Scalars['String'];
};


export type GSubscriptionOnAgentStoppedWatchingConversationByIdArgs = {
  conversationId: Scalars['String'];
};


export type GSubscriptionOnAgentTypingInConversationByIdArgs = {
  conversationId: Scalars['String'];
};


export type GSubscriptionOnAgentWatchingConversationByIdArgs = {
  conversationId: Scalars['String'];
};


export type GSubscriptionOnContactStoppedTypingInConversationByIdArgs = {
  conversationId: Scalars['String'];
};


export type GSubscriptionOnContactTypingInConversationByIdArgs = {
  conversationId: Scalars['String'];
};


export type GSubscriptionOnConversationTimelineCreatedArgs = {
  conversationId: Scalars['String'];
};


export type GSubscriptionOnConversationTimelineModifiedArgs = {
  conversationId: Scalars['String'];
};


export type GSubscriptionOnKnowledgeBaseArticleModifiedArgs = {
  id: Scalars['String'];
};

export type GTagEntity = {
  __typename?: 'TagEntity';
  id: Scalars['String'];
  tag: Scalars['String'];
};

export type GTeamAlreadyExistsError = GUserError & {
  __typename?: 'TeamAlreadyExistsError';
  code: GUserErrorCode;
  message: Scalars['String'];
};

export type GTeamEntity = {
  __typename?: 'TeamEntity';
  agents: Array<GAgentEntity>;
  deleted: Scalars['Boolean'];
  emoji?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type GTeamNotFoundError = GUserError & {
  __typename?: 'TeamNotFoundError';
  code: GUserErrorCode;
  message: Scalars['String'];
};

export type GTenantEntity = {
  __typename?: 'TenantEntity';
  additionalAgentsPurchasedCount?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  emailChannelDomain: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  onboardingStatus: GTenantOnboardingStatus;
  partner?: Maybe<GPartnerEntity>;
  subdomain: Scalars['String'];
};

export type GTenantOnboardingStatus = {
  __typename?: 'TenantOnboardingStatus';
  hasAtLeastOneConversation: Scalars['Boolean'];
  hasInstalledWidgetOnWebsite: Scalars['Boolean'];
};

export enum GTenantRoleItem {
  Admin = 'ADMIN',
  Agent = 'AGENT',
  Manager = 'MANAGER',
  Unknown = 'UNKNOWN'
}

export type GTransferOption = {
  __typename?: 'TransferOption';
  addressOptions: Array<GContactAddressEntity>;
  channel: GConversationChannelItem;
  connectedServiceId: Scalars['String'];
};

export type GTranslateTextWithHtmlInput = {
  language: Scalars['String'];
  text: Scalars['String'];
};

export type GTranslateTextWithHtmlPayload = {
  __typename?: 'TranslateTextWithHtmlPayload';
  language: Scalars['String'];
  translation: Scalars['String'];
};

export type GUnseenAgentNotificationCountPayload = {
  __typename?: 'UnseenAgentNotificationCountPayload';
  count: Scalars['Int'];
};

export type GUserError = {
  code: GUserErrorCode;
  message: Scalars['String'];
};

export enum GUserErrorCode {
  AgentAlreadyExists = 'AGENT_ALREADY_EXISTS',
  AgentIsNotAuthorizedForConversation = 'AGENT_IS_NOT_AUTHORIZED_FOR_CONVERSATION',
  AgentIsNotAuthorizedForTeam = 'AGENT_IS_NOT_AUTHORIZED_FOR_TEAM',
  AgentIsNotAuthorizedToAddAgent = 'AGENT_IS_NOT_AUTHORIZED_TO_ADD_AGENT',
  AgentIsNotAuthorizedToRemoveAgent = 'AGENT_IS_NOT_AUTHORIZED_TO_REMOVE_AGENT',
  AgentNotificationNotFound = 'AGENT_NOTIFICATION_NOT_FOUND',
  AgentNotAuthorized = 'AGENT_NOT_AUTHORIZED',
  AgentNotFound = 'AGENT_NOT_FOUND',
  AssistantError = 'ASSISTANT_ERROR',
  ChatChannelNotFound = 'CHAT_CHANNEL_NOT_FOUND',
  ConnectedServiceNotFound = 'CONNECTED_SERVICE_NOT_FOUND',
  ContactAddressConflict = 'CONTACT_ADDRESS_CONFLICT',
  ContactAddressNotFound = 'CONTACT_ADDRESS_NOT_FOUND',
  ContactNotFound = 'CONTACT_NOT_FOUND',
  ConversationBotAssistantReActNotFound = 'CONVERSATION_BOT_ASSISTANT_RE_ACT_NOT_FOUND',
  ConversationHasNoConnectedService = 'CONVERSATION_HAS_NO_CONNECTED_SERVICE',
  ConversationNotFound = 'CONVERSATION_NOT_FOUND',
  ConversationSnippetNotFound = 'CONVERSATION_SNIPPET_NOT_FOUND',
  ConversationTimelineIsNotABotMessage = 'CONVERSATION_TIMELINE_IS_NOT_A_BOT_MESSAGE',
  ConversationTimelineIsNotABotSuggestion = 'CONVERSATION_TIMELINE_IS_NOT_A_BOT_SUGGESTION',
  ConversationTimelineNotFound = 'CONVERSATION_TIMELINE_NOT_FOUND',
  EmailChannelAlreadyExists = 'EMAIL_CHANNEL_ALREADY_EXISTS',
  Error = 'ERROR',
  InvalidLanguageCode = 'INVALID_LANGUAGE_CODE',
  KnowledgeBaseArticleIsPublishing = 'KNOWLEDGE_BASE_ARTICLE_IS_PUBLISHING',
  KnowledgeBaseArticleNotFound = 'KNOWLEDGE_BASE_ARTICLE_NOT_FOUND',
  MissingParameter = 'MISSING_PARAMETER',
  NoAgentsAvailableForChat = 'NO_AGENTS_AVAILABLE_FOR_CHAT',
  OnlyAdminCanModifyChannel = 'ONLY_ADMIN_CAN_MODIFY_CHANNEL',
  SmsChannelAlreadyExists = 'SMS_CHANNEL_ALREADY_EXISTS',
  TeamAlreadyExists = 'TEAM_ALREADY_EXISTS',
  TeamNotFound = 'TEAM_NOT_FOUND',
  TenantAlreadyExists = 'TENANT_ALREADY_EXISTS',
  TenantIsNotAuthorizedForTeam = 'TENANT_IS_NOT_AUTHORIZED_FOR_TEAM',
  TenantNotFound = 'TENANT_NOT_FOUND'
}

export enum GUserReleaseChannelItem {
  Beta = 'BETA',
  Latest = 'LATEST',
  Preview = 'PREVIEW'
}

export type GWidgetConfigurationBehaviour = {
  __typename?: 'WidgetConfigurationBehaviour';
  conversationStartMode: GConnectedServiceChatEntityConversationStartModeItem;
  operationMode: GConnectedServiceChatEntityOperationModeItem;
};

export type GWidgetConfigurationBehaviourInput = {
  conversationStartMode: GConnectedServiceChatEntityConversationStartModeItem;
  operationMode: GConnectedServiceChatEntityOperationModeItem;
};

export type GWidgetConfigurationChannel = {
  __typename?: 'WidgetConfigurationChannel';
  channel: GConversationChannelItem;
  offerStartDirect: Scalars['Boolean'];
  offerTransfer: Scalars['Boolean'];
  startDirectTarget?: Maybe<Scalars['String']>;
};

export type GWidgetConfigurationConversation = {
  __typename?: 'WidgetConfigurationConversation';
  agentNameVariation: GNameVariationItem;
  showAgentAvatar: Scalars['Boolean'];
  showAgentName: Scalars['Boolean'];
};

export type GWidgetConfigurationConversationInput = {
  agentNameVariation: GNameVariationItem;
  showAgentAvatar: Scalars['Boolean'];
  showAgentName: Scalars['Boolean'];
};

export type GWidgetConfigurationIframe = {
  __typename?: 'WidgetConfigurationIframe';
  borderRadius: Scalars['String'];
  bottomOffset: Scalars['String'];
  boxShadow: Scalars['String'];
  height: Scalars['String'];
  rightOffset: Scalars['String'];
  width: Scalars['String'];
};

export type GWidgetConfigurationPreChatSurveyField = {
  __typename?: 'WidgetConfigurationPreChatSurveyField';
  hint?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  label: Scalars['String'];
  options?: Maybe<Array<Scalars['String']>>;
  placeholder?: Maybe<Scalars['String']>;
  required: Scalars['Boolean'];
  targetEntity: GChatPreChatSurveyFieldTargetEntityType;
  type: GChatPreChatSurveyFieldType;
};

export type GWidgetConfigurationText = {
  __typename?: 'WidgetConfigurationText';
  noAgentsOnlineMessage?: Maybe<Scalars['String']>;
  preChatSurveyHeader?: Maybe<Scalars['String']>;
  preChatSurveySubHeader?: Maybe<Scalars['String']>;
  splashHeaderText?: Maybe<Scalars['String']>;
  splashSubHeaderText?: Maybe<Scalars['String']>;
  startMessage?: Maybe<Scalars['String']>;
};

export type GWidgetConfigurationTextInput = {
  noAgentsOnlineMessage?: InputMaybe<Scalars['String']>;
  preChatSurveyHeader?: InputMaybe<Scalars['String']>;
  preChatSurveySubHeader?: InputMaybe<Scalars['String']>;
  splashHeaderText?: InputMaybe<Scalars['String']>;
  splashSubHeaderText?: InputMaybe<Scalars['String']>;
  startMessage?: InputMaybe<Scalars['String']>;
};

export type GWidgetConfigurationTheme = {
  __typename?: 'WidgetConfigurationTheme';
  agentBubbleBackgroundColor: Scalars['String'];
  agentBubbleTextColor: Scalars['String'];
  appBackgroundColorFrom: Scalars['String'];
  appBackgroundColorTo: Scalars['String'];
  botBubbleBackgroundColor: Scalars['String'];
  botBubbleTextColor: Scalars['String'];
  buttonBackgroundColor: Scalars['String'];
  buttonBorderColor: Scalars['String'];
  buttonTextColor: Scalars['String'];
  contactBubbleBackgroundColor: Scalars['String'];
  contactBubbleTextColor: Scalars['String'];
  iconTextColor: Scalars['String'];
  inputBackgroundColor: Scalars['String'];
  inputBorderColor: Scalars['String'];
  inputTextColor: Scalars['String'];
  minimizedIconBackgroundColor: Scalars['String'];
  minimizedIconColor: Scalars['String'];
  primaryHoverColor: Scalars['String'];
  primaryTextColor: Scalars['String'];
  processingBubbleBackgroundColor: Scalars['String'];
  processingBubbleTextColor: Scalars['String'];
  topBackgroundColor: Scalars['String'];
  topTextColor: Scalars['String'];
};

export type GWidgetConfigurationThemeInput = {
  agentBubbleBackgroundColor: Scalars['String'];
  agentBubbleTextColor: Scalars['String'];
  appBackgroundColorFrom: Scalars['String'];
  appBackgroundColorTo: Scalars['String'];
  botBubbleBackgroundColor: Scalars['String'];
  botBubbleTextColor: Scalars['String'];
  buttonBackgroundColor: Scalars['String'];
  buttonBorderColor: Scalars['String'];
  buttonTextColor: Scalars['String'];
  contactBubbleBackgroundColor: Scalars['String'];
  contactBubbleTextColor: Scalars['String'];
  iconTextColor: Scalars['String'];
  inputBackgroundColor: Scalars['String'];
  inputBorderColor: Scalars['String'];
  inputTextColor: Scalars['String'];
  minimizedIconBackgroundColor: Scalars['String'];
  minimizedIconColor: Scalars['String'];
  primaryHoverColor: Scalars['String'];
  primaryTextColor: Scalars['String'];
  processingBubbleBackgroundColor: Scalars['String'];
  processingBubbleTextColor: Scalars['String'];
  topBackgroundColor: Scalars['String'];
  topTextColor: Scalars['String'];
};

export type GGlobalAgentWithStatusListFragment = { __typename?: 'AgentEntity', id: string, name: string, firstName: string, lastName: string, away: boolean, awayFromPhone?: boolean | null, workerId?: string | null, idle: boolean, perTenant: { __typename?: 'AgentByTenant', status: GAgentStatusItem, role: GTenantRoleItem } };

export type GGlobalTeamListFragment = { __typename?: 'TeamEntity', id: string, name: string, emoji?: string | null, deleted: boolean, agents: Array<{ __typename?: 'AgentEntity', id: string, name: string }> };

export type GGlobalTagListFragment = { __typename?: 'TagEntity', id: string, tag: string };

export type GGlobalConnectedServiceListFragment = { __typename?: 'BaseConnectedServiceEntity', id: string, status: GConnectedServiceStatusItem, type: GConnectedServiceItem, capabilities: Array<GConnectedServiceCapabilityItem> };

export type GGlobalSnippetListFragment = { __typename?: 'ConversationSnippetEntity', id: string, title: string, content: string, private: boolean, createdAt: any, updatedAt?: any | null, restrictToChannels: Array<GConversationChannelItem> };

export type GGlobalMeFragment = { __typename?: 'AgentEntity', id: string, email: string, locale: GLocaleItem, name: string, firstName: string, lastName: string, workerId?: string | null, settings: { __typename?: 'AgentSettings', autoAdvance: { __typename?: 'AgentSettingsAutoAdvance', action: GAutoAdvanceOptionItem } }, perTenant: { __typename?: 'AgentByTenant', isFirstAgentInTenant: boolean, role: GTenantRoleItem, teams: Array<{ __typename?: 'TeamEntity', id: string }> } };

export type GGlobalTenantFragment = { __typename?: 'TenantEntity', id: string, name: string, createdAt: any, additionalAgentsPurchasedCount?: number | null, subdomain: string, emailChannelDomain: string, onboardingStatus: { __typename?: 'TenantOnboardingStatus', hasInstalledWidgetOnWebsite: boolean, hasAtLeastOneConversation: boolean }, partner?: { __typename?: 'PartnerEntity', id: string, name: string, whiteLabelProductName?: string | null } | null };

export type GGlobalActiveConversationCountFragment = { __typename?: 'ConversationCountPayload', count: Array<{ __typename?: 'KeyValuePairOfStringAndInt64', key: string, value: any }> };

export type GGlobalUnseenAgentNotificationCountFragment = { __typename?: 'UnseenAgentNotificationCountPayload', count: number };

export type GAppInitQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GAppInitQueryQuery = { __typename?: 'Query', agents: Array<{ __typename?: 'AgentEntity', id: string, name: string, firstName: string, lastName: string, away: boolean, awayFromPhone?: boolean | null, workerId?: string | null, idle: boolean, perTenant: { __typename?: 'AgentByTenant', status: GAgentStatusItem, role: GTenantRoleItem } }>, tags: Array<{ __typename?: 'TagEntity', id: string, tag: string }>, channels: Array<{ __typename?: 'BaseConnectedServiceEntity', id: string, status: GConnectedServiceStatusItem, type: GConnectedServiceItem, capabilities: Array<GConnectedServiceCapabilityItem> }>, me: { __typename?: 'AgentEntity', id: string, email: string, locale: GLocaleItem, name: string, firstName: string, lastName: string, workerId?: string | null, settings: { __typename?: 'AgentSettings', autoAdvance: { __typename?: 'AgentSettingsAutoAdvance', action: GAutoAdvanceOptionItem } }, perTenant: { __typename?: 'AgentByTenant', isFirstAgentInTenant: boolean, role: GTenantRoleItem, teams: Array<{ __typename?: 'TeamEntity', id: string }> } }, teams: Array<{ __typename?: 'TeamEntity', id: string, name: string, emoji?: string | null, deleted: boolean, agents: Array<{ __typename?: 'AgentEntity', id: string, name: string }> }>, tenant?: { __typename?: 'TenantEntity', id: string, name: string, createdAt: any, additionalAgentsPurchasedCount?: number | null, subdomain: string, emailChannelDomain: string, onboardingStatus: { __typename?: 'TenantOnboardingStatus', hasInstalledWidgetOnWebsite: boolean, hasAtLeastOneConversation: boolean }, partner?: { __typename?: 'PartnerEntity', id: string, name: string, whiteLabelProductName?: string | null } | null } | null, conversationCount: { __typename?: 'ConversationCountPayload', count: Array<{ __typename?: 'KeyValuePairOfStringAndInt64', key: string, value: any }> }, unseenAgentNotificationCount: { __typename?: 'UnseenAgentNotificationCountPayload', count: number }, conversationSnippets: { __typename?: 'GetConversationSnippetsPayload', items: Array<{ __typename?: 'ConversationSnippetEntity', id: string, title: string, content: string, private: boolean, createdAt: any, updatedAt?: any | null, restrictToChannels: Array<GConversationChannelItem> }> } };

export type GOnAgentModifiedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GOnAgentModifiedSubscription = { __typename?: 'Subscription', onAgentModified: { __typename?: 'AgentEntity', id: string, name: string, firstName: string, lastName: string, away: boolean, awayFromPhone?: boolean | null, workerId?: string | null, idle: boolean, perTenant: { __typename?: 'AgentByTenant', status: GAgentStatusItem, role: GTenantRoleItem } } };

export type GOnAgentCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GOnAgentCreatedSubscription = { __typename?: 'Subscription', onAgentCreated: { __typename?: 'AgentEntity', id: string, name: string, firstName: string, lastName: string, away: boolean, awayFromPhone?: boolean | null, workerId?: string | null, idle: boolean, perTenant: { __typename?: 'AgentByTenant', status: GAgentStatusItem, role: GTenantRoleItem } } };

export type GOnTeamModifiedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GOnTeamModifiedSubscription = { __typename?: 'Subscription', onTeamModified: { __typename?: 'TeamEntity', deleted: boolean, id: string, name: string, emoji?: string | null, agents: Array<{ __typename?: 'AgentEntity', id: string, name: string }> } };

export type GOnTeamCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GOnTeamCreatedSubscription = { __typename?: 'Subscription', onTeamCreated: { __typename?: 'TeamEntity', id: string, name: string, emoji?: string | null, deleted: boolean, agents: Array<{ __typename?: 'AgentEntity', id: string, name: string }> } };

export type GAgentNotificationConversationFragment = { __typename?: 'ConversationEntity', id: string, description?: string | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null };

export type GAgentNotificationConversationTimelineFragment = { __typename?: 'ConversationTimelineEntity', id: string, conversationId: string, data: { __typename: 'ConversationAgentComment', content: string } | { __typename: 'ConversationAgentMessage' } | { __typename: 'ConversationBotMessage' } | { __typename: 'ConversationBotSuggestion' } | { __typename: 'ConversationContactMessage', content: string } | { __typename: 'ConversationEvent' } | { __typename: 'ConversationSummary' } };

export type GAgentNotificationFragment = { __typename?: 'AgentNotificationEntity', id: string, seen: boolean, eventType: GNotificationEvent, timestamp: any, generatedByAgent?: { __typename?: 'AgentEntity', id: string, name: string, firstName: string } | null, conversation?: { __typename?: 'ConversationEntity', id: string, description?: string | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null } | null, conversationTimeline?: { __typename?: 'ConversationTimelineEntity', id: string, conversationId: string, data: { __typename: 'ConversationAgentComment', content: string } | { __typename: 'ConversationAgentMessage' } | { __typename: 'ConversationBotMessage' } | { __typename: 'ConversationBotSuggestion' } | { __typename: 'ConversationContactMessage', content: string } | { __typename: 'ConversationEvent' } | { __typename: 'ConversationSummary' } } | null };

export type GGetAgentNotificationsQueryVariables = Exact<{
  continuationToken?: InputMaybe<Scalars['String']>;
  take: Scalars['Int'];
}>;


export type GGetAgentNotificationsQuery = { __typename?: 'Query', agentNotifications: { __typename?: 'AgentNotificationContinuationTokenConnection', continuationToken?: string | null, items: Array<{ __typename?: 'AgentNotificationEntity', id: string, seen: boolean, eventType: GNotificationEvent, timestamp: any, generatedByAgent?: { __typename?: 'AgentEntity', id: string, name: string, firstName: string } | null, conversation?: { __typename?: 'ConversationEntity', id: string, description?: string | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null } | null, conversationTimeline?: { __typename?: 'ConversationTimelineEntity', id: string, conversationId: string, data: { __typename: 'ConversationAgentComment', content: string } | { __typename: 'ConversationAgentMessage' } | { __typename: 'ConversationBotMessage' } | { __typename: 'ConversationBotSuggestion' } | { __typename: 'ConversationContactMessage', content: string } | { __typename: 'ConversationEvent' } | { __typename: 'ConversationSummary' } } | null } | null> } };

export type GMarkAgentNotificationAsSeenMutationVariables = Exact<{
  agentNotificationId: Scalars['String'];
}>;


export type GMarkAgentNotificationAsSeenMutation = { __typename?: 'Mutation', modifyAgentNotification: { __typename?: 'ModifyAgentNotificationPayload', agentNotification?: { __typename?: 'AgentNotificationEntity', id: string, seen: boolean, eventType: GNotificationEvent, timestamp: any, generatedByAgent?: { __typename?: 'AgentEntity', id: string, name: string, firstName: string } | null, conversation?: { __typename?: 'ConversationEntity', id: string, description?: string | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null } | null, conversationTimeline?: { __typename?: 'ConversationTimelineEntity', id: string, conversationId: string, data: { __typename: 'ConversationAgentComment', content: string } | { __typename: 'ConversationAgentMessage' } | { __typename: 'ConversationBotMessage' } | { __typename: 'ConversationBotSuggestion' } | { __typename: 'ConversationContactMessage', content: string } | { __typename: 'ConversationEvent' } | { __typename: 'ConversationSummary' } } | null } | null } };

export type GMarkAllAgentNotificationsAsSeenMutationVariables = Exact<{ [key: string]: never; }>;


export type GMarkAllAgentNotificationsAsSeenMutation = { __typename?: 'Mutation', markAllAgentNotificationsAsSeen: { __typename?: 'MarkAllAgentNotificationsAsSeenPayload', success?: boolean | null } };

export type GOnAgentNotificationCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GOnAgentNotificationCreatedSubscription = { __typename?: 'Subscription', onAgentNotificationCreated: { __typename?: 'AgentNotificationEntity', id: string, seen: boolean, eventType: GNotificationEvent, timestamp: any, generatedByAgent?: { __typename?: 'AgentEntity', id: string, name: string, firstName: string } | null, conversation?: { __typename?: 'ConversationEntity', id: string, description?: string | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null } | null, conversationTimeline?: { __typename?: 'ConversationTimelineEntity', id: string, conversationId: string, data: { __typename: 'ConversationAgentComment', content: string } | { __typename: 'ConversationAgentMessage' } | { __typename: 'ConversationBotMessage' } | { __typename: 'ConversationBotSuggestion' } | { __typename: 'ConversationContactMessage', content: string } | { __typename: 'ConversationEvent' } | { __typename: 'ConversationSummary' } } | null } };

export type GOnAgentNotificationModifiedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GOnAgentNotificationModifiedSubscription = { __typename?: 'Subscription', onAgentNotificationModified: { __typename?: 'AgentNotificationEntity', id: string, seen: boolean, eventType: GNotificationEvent, timestamp: any, generatedByAgent?: { __typename?: 'AgentEntity', id: string, name: string, firstName: string } | null, conversation?: { __typename?: 'ConversationEntity', id: string, description?: string | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null } | null, conversationTimeline?: { __typename?: 'ConversationTimelineEntity', id: string, conversationId: string, data: { __typename: 'ConversationAgentComment', content: string } | { __typename: 'ConversationAgentMessage' } | { __typename: 'ConversationBotMessage' } | { __typename: 'ConversationBotSuggestion' } | { __typename: 'ConversationContactMessage', content: string } | { __typename: 'ConversationEvent' } | { __typename: 'ConversationSummary' } } | null } };

export type GAgentNotificationSettingFlagsFragment = { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean };

export type GAgentNotificationSettingFragment = { __typename?: 'AgentNotificationSettingEntity', conversationUnassignedUnSnoozed: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAssignedAgentUnSnoozed: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAssignedTeamUnSnoozed: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationUnassignedContactMessageCreated: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAssignedAgentContactMessageCreated: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAssignedTeamContactMessageCreated: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAgentMentioned: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAssignedToAgent: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAssignedToTeam: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationUnassignedCreatedByContact: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAssignedAgentCreatedByContact: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAssignedTeamCreatedByContact: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean } };

export type GGetAgentNotificationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GGetAgentNotificationSettingsQuery = { __typename?: 'Query', agentNotificationSettings: { __typename?: 'AgentNotificationSettingEntity', conversationUnassignedUnSnoozed: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAssignedAgentUnSnoozed: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAssignedTeamUnSnoozed: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationUnassignedContactMessageCreated: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAssignedAgentContactMessageCreated: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAssignedTeamContactMessageCreated: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAgentMentioned: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAssignedToAgent: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAssignedToTeam: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationUnassignedCreatedByContact: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAssignedAgentCreatedByContact: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAssignedTeamCreatedByContact: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean } } };

export type GModifyAgentNotificationSettingsMutationVariables = Exact<{
  input: GModifyAgentNotificationSettingsInput;
}>;


export type GModifyAgentNotificationSettingsMutation = { __typename?: 'Mutation', modifyAgentNotificationSettings: { __typename?: 'ModifyAgentNotificationSettingsPayload', settings?: { __typename?: 'AgentNotificationSettingEntity', conversationUnassignedUnSnoozed: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAssignedAgentUnSnoozed: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAssignedTeamUnSnoozed: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationUnassignedContactMessageCreated: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAssignedAgentContactMessageCreated: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAssignedTeamContactMessageCreated: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAgentMentioned: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAssignedToAgent: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAssignedToTeam: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationUnassignedCreatedByContact: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAssignedAgentCreatedByContact: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean }, conversationAssignedTeamCreatedByContact: { __typename?: 'AgentSettingsNotificationFlags', inApp: boolean, preferDesktop: boolean, pushNotification: boolean, pushNotificationWhenAway: boolean } } | null } };

export type GOnAgentNotificationSeenModifiedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GOnAgentNotificationSeenModifiedSubscription = { __typename?: 'Subscription', onAgentNotificationSeenModified: { __typename?: 'AgentNotificationSeenModified', fromSeen: boolean, toSeen: boolean } };

export type GSetAgentAwayStatusMutationVariables = Exact<{
  input: GSetAgentAwayStatusInput;
}>;


export type GSetAgentAwayStatusMutation = { __typename?: 'Mutation', setAgentAwayStatus: { __typename?: 'SetAgentAwayStatusPayload', agent?: { __typename?: 'AgentEntity', id: string, away: boolean, awayFromPhone?: boolean | null } | null, errors?: Array<{ __typename: 'AgentNotAuthorizedError', message: string, code: GUserErrorCode } | { __typename: 'AgentNotFoundError', message: string, code: GUserErrorCode }> | null } };

export type GAgentPingSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GAgentPingSubscription = { __typename?: 'Subscription', onAgentPing: { __typename: 'AgentEntity' } };

export type GAppEventConversationAgentMessageFragment = { __typename?: 'ConversationAgentMessage', content: string, conversation: { __typename?: 'ConversationEntity', id: string, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null } }, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null };

export type GAppEventConversationAgentCommentFragment = { __typename?: 'ConversationAgentComment', content: string, conversation: { __typename?: 'ConversationEntity', id: string, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null } }, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string } | null };

export type GAppEventConversationContactMessageFragment = { __typename?: 'ConversationContactMessage', content: string, conversation: { __typename?: 'ConversationEntity', id: string, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null } } };

export type GAppEventConversationBotSuggestionFragment = { __typename?: 'ConversationBotSuggestion', content: string, conversation: { __typename?: 'ConversationEntity', id: string, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null } } };

export type GAppEventConversationBotMessageFragment = { __typename?: 'ConversationBotMessage', content: string, conversation: { __typename?: 'ConversationEntity', id: string, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null } } };

export type GAppEventConversationEventFragment = { __typename?: 'ConversationEvent', conversation: { __typename?: 'ConversationEntity', id: string, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null } }, executingAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string } | null, metadata?: { __typename: 'ConversationAssignedMetaData', previousAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string } | null, newAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string } | null, previousTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null, newTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null } | { __typename: 'ConversationSnoozedMetaData', remindAt?: any | null } | { __typename: 'ConversationTagChangeMetaData' } | { __typename: 'ConversationTransferredMetaData' } | null };

export type GAppEventFragment = { __typename: 'AppEventByTenant', id: string, eventType: GAppEventType, timestamp: any, eventData?: { __typename: 'ConversationAgentComment', content: string, conversation: { __typename?: 'ConversationEntity', id: string, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null } }, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string } | null } | { __typename: 'ConversationAgentMessage', content: string, conversation: { __typename?: 'ConversationEntity', id: string, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null } }, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null } | { __typename: 'ConversationBotMessage', content: string, conversation: { __typename?: 'ConversationEntity', id: string, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null } } } | { __typename: 'ConversationBotSuggestion', content: string, conversation: { __typename?: 'ConversationEntity', id: string, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null } } } | { __typename: 'ConversationContactMessage', content: string, conversation: { __typename?: 'ConversationEntity', id: string, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null } } } | { __typename: 'ConversationEvent', conversation: { __typename?: 'ConversationEntity', id: string, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null } }, executingAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string } | null, metadata?: { __typename: 'ConversationAssignedMetaData', previousAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string } | null, newAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string } | null, previousTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null, newTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null } | { __typename: 'ConversationSnoozedMetaData', remindAt?: any | null } | { __typename: 'ConversationTagChangeMetaData' } | { __typename: 'ConversationTransferredMetaData' } | null } | null };

export type GGetAppEventsQueryVariables = Exact<{
  take: Scalars['Int'];
  filter: GGetAppEventsFilterInput;
}>;


export type GGetAppEventsQuery = { __typename?: 'Query', appEvents: Array<{ __typename: 'AppEventByTenant', id: string, eventType: GAppEventType, timestamp: any, eventData?: { __typename: 'ConversationAgentComment', content: string, conversation: { __typename?: 'ConversationEntity', id: string, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null } }, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string } | null } | { __typename: 'ConversationAgentMessage', content: string, conversation: { __typename?: 'ConversationEntity', id: string, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null } }, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null } | { __typename: 'ConversationBotMessage', content: string, conversation: { __typename?: 'ConversationEntity', id: string, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null } } } | { __typename: 'ConversationBotSuggestion', content: string, conversation: { __typename?: 'ConversationEntity', id: string, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null } } } | { __typename: 'ConversationContactMessage', content: string, conversation: { __typename?: 'ConversationEntity', id: string, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null } } } | { __typename: 'ConversationEvent', conversation: { __typename?: 'ConversationEntity', id: string, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null } }, executingAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string } | null, metadata?: { __typename: 'ConversationAssignedMetaData', previousAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string } | null, newAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string } | null, previousTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null, newTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null } | { __typename: 'ConversationSnoozedMetaData', remindAt?: any | null } | { __typename: 'ConversationTagChangeMetaData' } | { __typename: 'ConversationTransferredMetaData' } | null } | null }> };

export type GOnAgentTypingInConversationByTenantIdSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GOnAgentTypingInConversationByTenantIdSubscription = { __typename?: 'Subscription', onAgentTypingInConversationByTenantId: { __typename?: 'AgentTypingInConversation', conversationId: string, typingId: string, sequence: number, content: string, isFullContent: boolean, agentId: string } };

export type GOnAgentStoppedTypingInConversationByTenantIdSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GOnAgentStoppedTypingInConversationByTenantIdSubscription = { __typename?: 'Subscription', onAgentStoppedTypingInConversationByTenantId: { __typename?: 'AgentStoppedTypingInConversation', conversationId: string, typingId: string, agentId: string } };

export type GOnContactTypingInConversationByTenantIdSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GOnContactTypingInConversationByTenantIdSubscription = { __typename?: 'Subscription', onContactTypingInConversationByTenantId: { __typename?: 'ContactTypingInConversation', conversationId: string, content: string, contactId: string, sequence: number, isFullContent: boolean } };

export type GOnContactStoppedTypingInConversationByTenantIdSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GOnContactStoppedTypingInConversationByTenantIdSubscription = { __typename?: 'Subscription', onContactStoppedTypingInConversationByTenantId: { __typename?: 'ContactStoppedTypingInConversation', conversationId: string, contactId: string } };

export type GOnAgentWatchingConversationByTenantIdSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GOnAgentWatchingConversationByTenantIdSubscription = { __typename?: 'Subscription', onAgentWatchingConversationByTenantId: { __typename?: 'ConversationAgentWatchEntity', conversationId: string, agentId: string } };

export type GOnAgentStoppedWatchingConversationByTenantIdSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GOnAgentStoppedWatchingConversationByTenantIdSubscription = { __typename?: 'Subscription', onAgentStoppedWatchingConversationByTenantId: { __typename?: 'ConversationAgentWatchEntity', conversationId: string, agentId: string } };

export type GOnAppEventCreatedByTenantIdSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GOnAppEventCreatedByTenantIdSubscription = { __typename?: 'Subscription', onAppEventCreated: { __typename: 'AppEventByTenant', id: string, eventType: GAppEventType, timestamp: any, eventData?: { __typename: 'ConversationAgentComment', content: string, conversation: { __typename?: 'ConversationEntity', id: string, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null } }, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string } | null } | { __typename: 'ConversationAgentMessage', content: string, conversation: { __typename?: 'ConversationEntity', id: string, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null } }, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null } | { __typename: 'ConversationBotMessage', content: string, conversation: { __typename?: 'ConversationEntity', id: string, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null } } } | { __typename: 'ConversationBotSuggestion', content: string, conversation: { __typename?: 'ConversationEntity', id: string, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null } } } | { __typename: 'ConversationContactMessage', content: string, conversation: { __typename?: 'ConversationEntity', id: string, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null } } } | { __typename: 'ConversationEvent', conversation: { __typename?: 'ConversationEntity', id: string, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null } }, executingAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string } | null, metadata?: { __typename: 'ConversationAssignedMetaData', previousAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string } | null, newAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string } | null, previousTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null, newTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null } | { __typename: 'ConversationSnoozedMetaData', remindAt?: any | null } | { __typename: 'ConversationTagChangeMetaData' } | { __typename: 'ConversationTransferredMetaData' } | null } | null } };

export type GCreateContactMutationVariables = Exact<{
  input: GCreateContactInput;
}>;


export type GCreateContactMutation = { __typename?: 'Mutation', createContact: { __typename?: 'CreateContactPayload', contact?: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null, address: Array<{ __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem }> } | null, errors?: Array<{ __typename?: 'AgentNotFoundError', code: GUserErrorCode, message: string } | { __typename?: 'ContactAddressConflictError', code: GUserErrorCode, message: string, conflicts: Array<{ __typename?: 'ContactAddressAlreadyUsedError', type: GInputContactAddressTypeItem, address: string }> }> | null } };

export type GGetContactByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GGetContactByIdQuery = { __typename?: 'Query', contactById: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null, address: Array<{ __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem }> } };

export type GGetContactConversationsQueryVariables = Exact<{
  take: Scalars['Int'];
  continuationToken?: InputMaybe<Scalars['String']>;
  contactId: Scalars['String'];
  includeTotalCount: Scalars['Boolean'];
}>;


export type GGetContactConversationsQuery = { __typename?: 'Query', contactConversations: { __typename?: 'ConversationContinuationTokenConnection', continuationToken?: string | null, totalCount?: number | null, items: Array<{ __typename?: 'ConversationEntity', id: string, description?: string | null, updated: any, started: any, botAssistantMode: GConversationBotAssistantModeItem, status: GConversationStatusItem, lastMessageContent?: string | null, isDemoContent?: boolean | null, currentChannel: GConversationChannelItem, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, assignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null, currentContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string } | null }> } };

export type GContactEntityFragment = { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null, address: Array<{ __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem }> };

export type GConversationSnippetFragment = { __typename?: 'ConversationSnippetEntity', id: string, title: string, content: string, deleted: boolean, private: boolean, createdAt: any, updatedAt?: any | null, restrictToChannels: Array<GConversationChannelItem>, createdByAgent?: { __typename?: 'AgentEntity', id: string, name: string } | null };

export type GCreateConversationSnippetMutationVariables = Exact<{
  input: GCreateConversationSnippetInput;
}>;


export type GCreateConversationSnippetMutation = { __typename?: 'Mutation', createConversationSnippet: { __typename?: 'CreateConversationSnippetPayload', snippet?: { __typename?: 'ConversationSnippetEntity', id: string, title: string, content: string, deleted: boolean, private: boolean, createdAt: any, updatedAt?: any | null, restrictToChannels: Array<GConversationChannelItem>, createdByAgent?: { __typename?: 'AgentEntity', id: string, name: string } | null } | null } };

export type GModifyConversationSnippetMutationVariables = Exact<{
  input: GModifyConversationSnippetInput;
}>;


export type GModifyConversationSnippetMutation = { __typename?: 'Mutation', modifyConversationSnippet: { __typename?: 'ModifyConversationSnippetPayload', snippet?: { __typename?: 'ConversationSnippetEntity', id: string, title: string, content: string, deleted: boolean, private: boolean, createdAt: any, updatedAt?: any | null, restrictToChannels: Array<GConversationChannelItem>, createdByAgent?: { __typename?: 'AgentEntity', id: string, name: string } | null } | null, errors?: Array<{ __typename: 'ConversationSnippetNotFoundError' }> | null } };

export type GDeleteConversationSnippetMutationVariables = Exact<{
  input: GDeleteConversationSnippetInput;
}>;


export type GDeleteConversationSnippetMutation = { __typename?: 'Mutation', deleteConversationSnippet: { __typename?: 'DeleteConversationSnippetPayload', snippet?: { __typename?: 'ConversationSnippetEntity', id: string, title: string, content: string, deleted: boolean, private: boolean, createdAt: any, updatedAt?: any | null, restrictToChannels: Array<GConversationChannelItem>, createdByAgent?: { __typename?: 'AgentEntity', id: string, name: string } | null } | null, errors?: Array<{ __typename: 'ConversationSnippetNotFoundError' }> | null } };

export type GGetConversationSnippetsQueryVariables = Exact<{
  take: Scalars['Int'];
  continuationToken?: InputMaybe<Scalars['String']>;
}>;


export type GGetConversationSnippetsQuery = { __typename?: 'Query', conversationSnippets: { __typename?: 'GetConversationSnippetsPayload', continuationToken?: string | null, items: Array<{ __typename?: 'ConversationSnippetEntity', id: string, title: string, content: string, deleted: boolean, private: boolean, createdAt: any, updatedAt?: any | null, restrictToChannels: Array<GConversationChannelItem>, createdByAgent?: { __typename?: 'AgentEntity', id: string, name: string } | null }> } };

export type GGetSnippetByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GGetSnippetByIdQuery = { __typename?: 'Query', conversationSnippetById: { __typename?: 'ConversationSnippetEntity', id: string, title: string, content: string, deleted: boolean, private: boolean, createdAt: any, updatedAt?: any | null, restrictToChannels: Array<GConversationChannelItem>, createdByAgent?: { __typename?: 'AgentEntity', id: string, name: string } | null } };

export type GOnActiveConversationCountConversationStatusModifiedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GOnActiveConversationCountConversationStatusModifiedSubscription = { __typename?: 'Subscription', onMultiTenantConversationStatusModified: { __typename?: 'ConversationStatusModified', tenantId: string, fromStatus: GConversationStatusItem, toStatus: GConversationStatusItem, fromAssignedAgentId?: string | null, toAssignedAgentId?: string | null, fromAssignedTeamId?: string | null, toAssignedTeamId?: string | null } };

export type GOnActiveConversationCountConversationCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GOnActiveConversationCountConversationCreatedSubscription = { __typename?: 'Subscription', onMultiTenantConversationCreated: { __typename?: 'ConversationEntity', tenantId: string, status: GConversationStatusItem, assignee?: { __typename?: 'AgentEntity', id: string } | null, team?: { __typename?: 'TeamEntity', id: string } | null } };

export type GCreateConversationAgentCommentMutationVariables = Exact<{
  conversationId: Scalars['String'];
  content: Scalars['String'];
  attachments: Array<Scalars['String']> | Scalars['String'];
  linkedToTimelineId?: InputMaybe<Scalars['String']>;
}>;


export type GCreateConversationAgentCommentMutation = { __typename?: 'Mutation', createConversationAgentComment: { __typename?: 'CreateConversationAgentCommentPayload', conversationTimeline?: { __typename?: 'ConversationTimelineEntity', id: string, conversationId: string, timestamp: any, position: any, linkedToTimelineId?: string | null, data: { __typename: 'ConversationAgentComment', content: string, contentIsTruncated: boolean, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationAgentMessage', content: string, contentIsTruncated: boolean, status: GMessageStatusItem, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationBotMessage', content: string } | { __typename: 'ConversationBotSuggestion', content: string, botResponseResult: GBotResponseResultItem, aiModel: GAiModelItem, actionableTasks: Array<{ __typename?: 'BotActionableTask', task?: string | null, queries: Array<string | null>, specificity: number, answerResult: GBotActionableAnswerResultItem, kbMatches: Array<{ __typename?: 'BotActionableTaskKbMatch', vectorSearchScore: number, aiRelevanceCheck: boolean, knowledgeBaseArticle: { __typename?: 'KnowledgeBaseArticleEntity', title: string } }> }> } | { __typename: 'ConversationContactMessage', content: string, contentIsTruncated: boolean, botIsProcessing: boolean, aiModelsProcessing: Array<GAiModelItem>, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, contactAddress: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem }, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationEvent', eventType: GAppEventType, executingAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, metadata?: { __typename?: 'ConversationAssignedMetaData', previousAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, newAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, previousTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null, newTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null } | { __typename?: 'ConversationSnoozedMetaData', remindAt?: any | null } | { __typename?: 'ConversationTagChangeMetaData' } | { __typename?: 'ConversationTransferredMetaData', fromChannel: GConversationChannelItem, toChannel: GConversationChannelItem, fromContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null, toContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null } | null } | { __typename: 'ConversationSummary', content: string, isOutdated: boolean, createdByAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null } } | null, errors?: Array<{ __typename?: 'ConversationNotFoundError', code: GUserErrorCode, message: string }> | null } };

export type GCreateConversationAgentMessageMutationVariables = Exact<{
  conversationId: Scalars['String'];
  content: Scalars['String'];
  attachments: Array<Scalars['String']> | Scalars['String'];
  linkedToTimelineId?: InputMaybe<Scalars['String']>;
}>;


export type GCreateConversationAgentMessageMutation = { __typename?: 'Mutation', createConversationAgentMessage: { __typename?: 'CreateConversationAgentMessagePayload', conversationTimeline?: { __typename?: 'ConversationTimelineEntity', id: string, conversationId: string, timestamp: any, position: any, linkedToTimelineId?: string | null, data: { __typename: 'ConversationAgentComment', content: string, contentIsTruncated: boolean, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationAgentMessage', content: string, contentIsTruncated: boolean, status: GMessageStatusItem, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationBotMessage', content: string } | { __typename: 'ConversationBotSuggestion', content: string, botResponseResult: GBotResponseResultItem, aiModel: GAiModelItem, actionableTasks: Array<{ __typename?: 'BotActionableTask', task?: string | null, queries: Array<string | null>, specificity: number, answerResult: GBotActionableAnswerResultItem, kbMatches: Array<{ __typename?: 'BotActionableTaskKbMatch', vectorSearchScore: number, aiRelevanceCheck: boolean, knowledgeBaseArticle: { __typename?: 'KnowledgeBaseArticleEntity', title: string } }> }> } | { __typename: 'ConversationContactMessage', content: string, contentIsTruncated: boolean, botIsProcessing: boolean, aiModelsProcessing: Array<GAiModelItem>, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, contactAddress: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem }, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationEvent', eventType: GAppEventType, executingAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, metadata?: { __typename?: 'ConversationAssignedMetaData', previousAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, newAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, previousTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null, newTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null } | { __typename?: 'ConversationSnoozedMetaData', remindAt?: any | null } | { __typename?: 'ConversationTagChangeMetaData' } | { __typename?: 'ConversationTransferredMetaData', fromChannel: GConversationChannelItem, toChannel: GConversationChannelItem, fromContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null, toContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null } | null } | { __typename: 'ConversationSummary', content: string, isOutdated: boolean, createdByAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null } } | null, errors?: Array<{ __typename?: 'ConversationNotFoundError', code: GUserErrorCode, message: string }> | null } };

export type GAgentIsTypingInConversationMutationVariables = Exact<{
  input: GAgentTypingInConversationInput;
}>;


export type GAgentIsTypingInConversationMutation = { __typename?: 'Mutation', agentTypingInConversation: { __typename?: 'AgentTypingInConversationPayload', typingId?: string | null, accessKey?: string | null, errors?: Array<{ __typename?: 'AgentIsNotAuthorizedForConversationError', code: GUserErrorCode, message: string }> | null } };

export type GAgentStoppedTypingInConversationMutationVariables = Exact<{
  input: GAgentStoppedTypingInConversationInput;
}>;


export type GAgentStoppedTypingInConversationMutation = { __typename?: 'Mutation', agentStoppedTypingInConversation: { __typename?: 'AgentStoppedTypingInConversationPayload', typingId?: string | null, errors?: Array<{ __typename?: 'AgentIsNotAuthorizedForConversationError', code: GUserErrorCode, message: string }> | null } };

export type GModifyConversationBotAssistantModeMutationVariables = Exact<{
  conversationId: Scalars['String'];
  mode: GConversationBotAssistantModeItem;
}>;


export type GModifyConversationBotAssistantModeMutation = { __typename?: 'Mutation', modifyConversation: { __typename?: 'ModifyConversationPayload', conversation?: { __typename?: 'ConversationEntity', id: string, description?: string | null, updated: any, started: any, botAssistantMode: GConversationBotAssistantModeItem, status: GConversationStatusItem, lastMessageContent?: string | null, isDemoContent?: boolean | null, currentChannel: GConversationChannelItem, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, assignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null, currentContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string } | null } | null, events?: Array<{ __typename?: 'ConversationTimelineEntity', id: string, conversationId: string, timestamp: any, position: any, linkedToTimelineId?: string | null, data: { __typename: 'ConversationAgentComment', content: string, contentIsTruncated: boolean, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationAgentMessage', content: string, contentIsTruncated: boolean, status: GMessageStatusItem, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationBotMessage', content: string } | { __typename: 'ConversationBotSuggestion', content: string, botResponseResult: GBotResponseResultItem, aiModel: GAiModelItem, actionableTasks: Array<{ __typename?: 'BotActionableTask', task?: string | null, queries: Array<string | null>, specificity: number, answerResult: GBotActionableAnswerResultItem, kbMatches: Array<{ __typename?: 'BotActionableTaskKbMatch', vectorSearchScore: number, aiRelevanceCheck: boolean, knowledgeBaseArticle: { __typename?: 'KnowledgeBaseArticleEntity', title: string } }> }> } | { __typename: 'ConversationContactMessage', content: string, contentIsTruncated: boolean, botIsProcessing: boolean, aiModelsProcessing: Array<GAiModelItem>, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, contactAddress: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem }, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationEvent', eventType: GAppEventType, executingAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, metadata?: { __typename?: 'ConversationAssignedMetaData', previousAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, newAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, previousTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null, newTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null } | { __typename?: 'ConversationSnoozedMetaData', remindAt?: any | null } | { __typename?: 'ConversationTagChangeMetaData' } | { __typename?: 'ConversationTransferredMetaData', fromChannel: GConversationChannelItem, toChannel: GConversationChannelItem, fromContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null, toContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null } | null } | { __typename: 'ConversationSummary', content: string, isOutdated: boolean, createdByAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null } }> | null, errors?: Array<{ __typename?: 'AgentIsNotAuthorizedForConversationError', code: GUserErrorCode, message: string } | { __typename?: 'AgentNotFoundError', code: GUserErrorCode, message: string } | { __typename?: 'ConnectedServiceNotFoundError', code: GUserErrorCode, message: string } | { __typename?: 'ContactNotFoundError', code: GUserErrorCode, message: string } | { __typename?: 'ConversationNotFoundError', code: GUserErrorCode, message: string } | { __typename?: 'TeamNotFoundError', code: GUserErrorCode, message: string }> | null } };

export type GModifyConversationAssignMutationVariables = Exact<{
  conversationId: Scalars['String'];
  assignToTeamId?: InputMaybe<Scalars['String']>;
  assignToAgentId?: InputMaybe<Scalars['String']>;
}>;


export type GModifyConversationAssignMutation = { __typename?: 'Mutation', modifyConversation: { __typename?: 'ModifyConversationPayload', conversation?: { __typename?: 'ConversationEntity', id: string, description?: string | null, updated: any, started: any, botAssistantMode: GConversationBotAssistantModeItem, status: GConversationStatusItem, lastMessageContent?: string | null, isDemoContent?: boolean | null, currentChannel: GConversationChannelItem, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, assignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null, currentContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string } | null } | null, events?: Array<{ __typename?: 'ConversationTimelineEntity', id: string, conversationId: string, timestamp: any, position: any, linkedToTimelineId?: string | null, data: { __typename: 'ConversationAgentComment', content: string, contentIsTruncated: boolean, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationAgentMessage', content: string, contentIsTruncated: boolean, status: GMessageStatusItem, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationBotMessage', content: string } | { __typename: 'ConversationBotSuggestion', content: string, botResponseResult: GBotResponseResultItem, aiModel: GAiModelItem, actionableTasks: Array<{ __typename?: 'BotActionableTask', task?: string | null, queries: Array<string | null>, specificity: number, answerResult: GBotActionableAnswerResultItem, kbMatches: Array<{ __typename?: 'BotActionableTaskKbMatch', vectorSearchScore: number, aiRelevanceCheck: boolean, knowledgeBaseArticle: { __typename?: 'KnowledgeBaseArticleEntity', title: string } }> }> } | { __typename: 'ConversationContactMessage', content: string, contentIsTruncated: boolean, botIsProcessing: boolean, aiModelsProcessing: Array<GAiModelItem>, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, contactAddress: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem }, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationEvent', eventType: GAppEventType, executingAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, metadata?: { __typename?: 'ConversationAssignedMetaData', previousAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, newAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, previousTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null, newTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null } | { __typename?: 'ConversationSnoozedMetaData', remindAt?: any | null } | { __typename?: 'ConversationTagChangeMetaData' } | { __typename?: 'ConversationTransferredMetaData', fromChannel: GConversationChannelItem, toChannel: GConversationChannelItem, fromContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null, toContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null } | null } | { __typename: 'ConversationSummary', content: string, isOutdated: boolean, createdByAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null } }> | null, errors?: Array<{ __typename?: 'AgentIsNotAuthorizedForConversationError', code: GUserErrorCode, message: string } | { __typename?: 'AgentNotFoundError', code: GUserErrorCode, message: string } | { __typename?: 'ConnectedServiceNotFoundError', code: GUserErrorCode, message: string } | { __typename?: 'ContactNotFoundError', code: GUserErrorCode, message: string } | { __typename?: 'ConversationNotFoundError', code: GUserErrorCode, message: string } | { __typename?: 'TeamNotFoundError', code: GUserErrorCode, message: string }> | null } };

export type GCreateConversationMutationVariables = Exact<{
  input: GCreateConversationInput;
}>;


export type GCreateConversationMutation = { __typename?: 'Mutation', createConversation: { __typename?: 'CreateConversationPayload', conversation?: { __typename?: 'ConversationEntity', id: string, description?: string | null, updated: any, started: any, botAssistantMode: GConversationBotAssistantModeItem, status: GConversationStatusItem, lastMessageContent?: string | null, isDemoContent?: boolean | null, currentChannel: GConversationChannelItem, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, assignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null, currentContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string } | null } | null, errors?: Array<{ __typename?: 'ContactNotFoundError', code: GUserErrorCode, message: string }> | null } };

export type GConversationByIdFragment = { __typename?: 'ConversationEntity', id: string, description?: string | null, status: GConversationStatusItem, botAssistantMode: GConversationBotAssistantModeItem, currentChannel: GConversationChannelItem, isDemoContent?: boolean | null, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, currentContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null, assignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string } | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null, timeline: { __typename?: 'ConversationTimelineContinuationTokenConnection', continuationToken?: string | null, items: Array<{ __typename?: 'ConversationTimelineEntity', id: string, conversationId: string, timestamp: any, position: any, linkedToTimelineId?: string | null, data: { __typename: 'ConversationAgentComment', content: string, contentIsTruncated: boolean, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationAgentMessage', content: string, contentIsTruncated: boolean, status: GMessageStatusItem, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationBotMessage', content: string } | { __typename: 'ConversationBotSuggestion', content: string, botResponseResult: GBotResponseResultItem, aiModel: GAiModelItem, actionableTasks: Array<{ __typename?: 'BotActionableTask', task?: string | null, queries: Array<string | null>, specificity: number, answerResult: GBotActionableAnswerResultItem, kbMatches: Array<{ __typename?: 'BotActionableTaskKbMatch', vectorSearchScore: number, aiRelevanceCheck: boolean, knowledgeBaseArticle: { __typename?: 'KnowledgeBaseArticleEntity', title: string } }> }> } | { __typename: 'ConversationContactMessage', content: string, contentIsTruncated: boolean, botIsProcessing: boolean, aiModelsProcessing: Array<GAiModelItem>, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, contactAddress: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem }, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationEvent', eventType: GAppEventType, executingAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, metadata?: { __typename?: 'ConversationAssignedMetaData', previousAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, newAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, previousTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null, newTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null } | { __typename?: 'ConversationSnoozedMetaData', remindAt?: any | null } | { __typename?: 'ConversationTagChangeMetaData' } | { __typename?: 'ConversationTransferredMetaData', fromChannel: GConversationChannelItem, toChannel: GConversationChannelItem, fromContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null, toContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null } | null } | { __typename: 'ConversationSummary', content: string, isOutdated: boolean, createdByAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null } } | null> } };

export type GConversationByIdQueryVariables = Exact<{
  id: Scalars['String'];
  take: Scalars['Int'];
}>;


export type GConversationByIdQuery = { __typename?: 'Query', conversationById: { __typename?: 'ConversationEntity', id: string, description?: string | null, status: GConversationStatusItem, botAssistantMode: GConversationBotAssistantModeItem, currentChannel: GConversationChannelItem, isDemoContent?: boolean | null, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, currentContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null, assignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string } | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null, timeline: { __typename?: 'ConversationTimelineContinuationTokenConnection', continuationToken?: string | null, items: Array<{ __typename?: 'ConversationTimelineEntity', id: string, conversationId: string, timestamp: any, position: any, linkedToTimelineId?: string | null, data: { __typename: 'ConversationAgentComment', content: string, contentIsTruncated: boolean, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationAgentMessage', content: string, contentIsTruncated: boolean, status: GMessageStatusItem, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationBotMessage', content: string } | { __typename: 'ConversationBotSuggestion', content: string, botResponseResult: GBotResponseResultItem, aiModel: GAiModelItem, actionableTasks: Array<{ __typename?: 'BotActionableTask', task?: string | null, queries: Array<string | null>, specificity: number, answerResult: GBotActionableAnswerResultItem, kbMatches: Array<{ __typename?: 'BotActionableTaskKbMatch', vectorSearchScore: number, aiRelevanceCheck: boolean, knowledgeBaseArticle: { __typename?: 'KnowledgeBaseArticleEntity', title: string } }> }> } | { __typename: 'ConversationContactMessage', content: string, contentIsTruncated: boolean, botIsProcessing: boolean, aiModelsProcessing: Array<GAiModelItem>, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, contactAddress: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem }, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationEvent', eventType: GAppEventType, executingAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, metadata?: { __typename?: 'ConversationAssignedMetaData', previousAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, newAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, previousTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null, newTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null } | { __typename?: 'ConversationSnoozedMetaData', remindAt?: any | null } | { __typename?: 'ConversationTagChangeMetaData' } | { __typename?: 'ConversationTransferredMetaData', fromChannel: GConversationChannelItem, toChannel: GConversationChannelItem, fromContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null, toContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null } | null } | { __typename: 'ConversationSummary', content: string, isOutdated: boolean, createdByAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null } } | null> } } };

export type GConversationByIdLoadMoreQueryVariables = Exact<{
  id: Scalars['String'];
  take: Scalars['Int'];
  continuationToken?: InputMaybe<Scalars['String']>;
}>;


export type GConversationByIdLoadMoreQuery = { __typename?: 'Query', conversationById: { __typename?: 'ConversationEntity', timeline: { __typename?: 'ConversationTimelineContinuationTokenConnection', continuationToken?: string | null, items: Array<{ __typename?: 'ConversationTimelineEntity', id: string, conversationId: string, timestamp: any, position: any, linkedToTimelineId?: string | null, data: { __typename: 'ConversationAgentComment', content: string, contentIsTruncated: boolean, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationAgentMessage', content: string, contentIsTruncated: boolean, status: GMessageStatusItem, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationBotMessage', content: string } | { __typename: 'ConversationBotSuggestion', content: string, botResponseResult: GBotResponseResultItem, aiModel: GAiModelItem, actionableTasks: Array<{ __typename?: 'BotActionableTask', task?: string | null, queries: Array<string | null>, specificity: number, answerResult: GBotActionableAnswerResultItem, kbMatches: Array<{ __typename?: 'BotActionableTaskKbMatch', vectorSearchScore: number, aiRelevanceCheck: boolean, knowledgeBaseArticle: { __typename?: 'KnowledgeBaseArticleEntity', title: string } }> }> } | { __typename: 'ConversationContactMessage', content: string, contentIsTruncated: boolean, botIsProcessing: boolean, aiModelsProcessing: Array<GAiModelItem>, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, contactAddress: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem }, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationEvent', eventType: GAppEventType, executingAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, metadata?: { __typename?: 'ConversationAssignedMetaData', previousAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, newAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, previousTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null, newTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null } | { __typename?: 'ConversationSnoozedMetaData', remindAt?: any | null } | { __typename?: 'ConversationTagChangeMetaData' } | { __typename?: 'ConversationTransferredMetaData', fromChannel: GConversationChannelItem, toChannel: GConversationChannelItem, fromContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null, toContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null } | null } | { __typename: 'ConversationSummary', content: string, isOutdated: boolean, createdByAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null } } | null> } } };

export type GModifyConversationStatusMutationVariables = Exact<{
  conversationId: Scalars['String'];
  status?: InputMaybe<GConversationStatusItem>;
}>;


export type GModifyConversationStatusMutation = { __typename?: 'Mutation', modifyConversation: { __typename?: 'ModifyConversationPayload', conversation?: { __typename?: 'ConversationEntity', id: string, description?: string | null, updated: any, started: any, botAssistantMode: GConversationBotAssistantModeItem, status: GConversationStatusItem, lastMessageContent?: string | null, isDemoContent?: boolean | null, currentChannel: GConversationChannelItem, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, assignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null, currentContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string } | null } | null, events?: Array<{ __typename?: 'ConversationTimelineEntity', id: string, conversationId: string, timestamp: any, position: any, linkedToTimelineId?: string | null, data: { __typename: 'ConversationAgentComment', content: string, contentIsTruncated: boolean, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationAgentMessage', content: string, contentIsTruncated: boolean, status: GMessageStatusItem, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationBotMessage', content: string } | { __typename: 'ConversationBotSuggestion', content: string, botResponseResult: GBotResponseResultItem, aiModel: GAiModelItem, actionableTasks: Array<{ __typename?: 'BotActionableTask', task?: string | null, queries: Array<string | null>, specificity: number, answerResult: GBotActionableAnswerResultItem, kbMatches: Array<{ __typename?: 'BotActionableTaskKbMatch', vectorSearchScore: number, aiRelevanceCheck: boolean, knowledgeBaseArticle: { __typename?: 'KnowledgeBaseArticleEntity', title: string } }> }> } | { __typename: 'ConversationContactMessage', content: string, contentIsTruncated: boolean, botIsProcessing: boolean, aiModelsProcessing: Array<GAiModelItem>, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, contactAddress: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem }, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationEvent', eventType: GAppEventType, executingAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, metadata?: { __typename?: 'ConversationAssignedMetaData', previousAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, newAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, previousTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null, newTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null } | { __typename?: 'ConversationSnoozedMetaData', remindAt?: any | null } | { __typename?: 'ConversationTagChangeMetaData' } | { __typename?: 'ConversationTransferredMetaData', fromChannel: GConversationChannelItem, toChannel: GConversationChannelItem, fromContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null, toContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null } | null } | { __typename: 'ConversationSummary', content: string, isOutdated: boolean, createdByAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null } }> | null, errors?: Array<{ __typename?: 'AgentIsNotAuthorizedForConversationError', code: GUserErrorCode, message: string } | { __typename?: 'AgentNotFoundError', code: GUserErrorCode, message: string } | { __typename?: 'ConnectedServiceNotFoundError', code: GUserErrorCode, message: string } | { __typename?: 'ContactNotFoundError', code: GUserErrorCode, message: string } | { __typename?: 'ConversationNotFoundError', code: GUserErrorCode, message: string } | { __typename?: 'TeamNotFoundError', code: GUserErrorCode, message: string }> | null } };

export type GAgentWatchConversationMutationVariables = Exact<{
  conversationId: Scalars['String'];
}>;


export type GAgentWatchConversationMutation = { __typename?: 'Mutation', agentWatchConversation: { __typename?: 'AgentWatchConversationPayload', success?: boolean | null } };

export type GAgentStopWatchConversationMutationVariables = Exact<{
  conversationId: Scalars['String'];
}>;


export type GAgentStopWatchConversationMutation = { __typename?: 'Mutation', agentStopWatchConversation: { __typename?: 'AgentStopWatchConversationPayload', success?: boolean | null } };

export type GCreateConversationSummaryMutationVariables = Exact<{
  conversationId: Scalars['String'];
}>;


export type GCreateConversationSummaryMutation = { __typename?: 'Mutation', createConversationSummary: { __typename?: 'CreateConversationSummaryPayload', summary?: { __typename?: 'ConversationTimelineEntity', id: string, conversationId: string, timestamp: any, position: any, linkedToTimelineId?: string | null, data: { __typename: 'ConversationAgentComment', content: string, contentIsTruncated: boolean, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationAgentMessage', content: string, contentIsTruncated: boolean, status: GMessageStatusItem, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationBotMessage', content: string } | { __typename: 'ConversationBotSuggestion', content: string, botResponseResult: GBotResponseResultItem, aiModel: GAiModelItem, actionableTasks: Array<{ __typename?: 'BotActionableTask', task?: string | null, queries: Array<string | null>, specificity: number, answerResult: GBotActionableAnswerResultItem, kbMatches: Array<{ __typename?: 'BotActionableTaskKbMatch', vectorSearchScore: number, aiRelevanceCheck: boolean, knowledgeBaseArticle: { __typename?: 'KnowledgeBaseArticleEntity', title: string } }> }> } | { __typename: 'ConversationContactMessage', content: string, contentIsTruncated: boolean, botIsProcessing: boolean, aiModelsProcessing: Array<GAiModelItem>, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, contactAddress: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem }, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationEvent', eventType: GAppEventType, executingAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, metadata?: { __typename?: 'ConversationAssignedMetaData', previousAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, newAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, previousTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null, newTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null } | { __typename?: 'ConversationSnoozedMetaData', remindAt?: any | null } | { __typename?: 'ConversationTagChangeMetaData' } | { __typename?: 'ConversationTransferredMetaData', fromChannel: GConversationChannelItem, toChannel: GConversationChannelItem, fromContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null, toContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null } | null } | { __typename: 'ConversationSummary', content: string, isOutdated: boolean, createdByAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null } } | null, errors?: Array<{ __typename?: 'AssistantError', message: string, code: GUserErrorCode } | { __typename?: 'ConversationNotFoundError', message: string, code: GUserErrorCode }> | null } };

export type GOnConversationTimelineCreatedSubscriptionVariables = Exact<{
  conversationId: Scalars['String'];
}>;


export type GOnConversationTimelineCreatedSubscription = { __typename?: 'Subscription', onConversationTimelineCreated: { __typename?: 'ConversationTimelineEntity', id: string, conversationId: string, timestamp: any, position: any, linkedToTimelineId?: string | null, data: { __typename: 'ConversationAgentComment', content: string, contentIsTruncated: boolean, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationAgentMessage', content: string, contentIsTruncated: boolean, status: GMessageStatusItem, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationBotMessage', content: string } | { __typename: 'ConversationBotSuggestion', content: string, botResponseResult: GBotResponseResultItem, aiModel: GAiModelItem, actionableTasks: Array<{ __typename?: 'BotActionableTask', task?: string | null, queries: Array<string | null>, specificity: number, answerResult: GBotActionableAnswerResultItem, kbMatches: Array<{ __typename?: 'BotActionableTaskKbMatch', vectorSearchScore: number, aiRelevanceCheck: boolean, knowledgeBaseArticle: { __typename?: 'KnowledgeBaseArticleEntity', title: string } }> }> } | { __typename: 'ConversationContactMessage', content: string, contentIsTruncated: boolean, botIsProcessing: boolean, aiModelsProcessing: Array<GAiModelItem>, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, contactAddress: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem }, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationEvent', eventType: GAppEventType, executingAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, metadata?: { __typename?: 'ConversationAssignedMetaData', previousAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, newAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, previousTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null, newTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null } | { __typename?: 'ConversationSnoozedMetaData', remindAt?: any | null } | { __typename?: 'ConversationTagChangeMetaData' } | { __typename?: 'ConversationTransferredMetaData', fromChannel: GConversationChannelItem, toChannel: GConversationChannelItem, fromContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null, toContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null } | null } | { __typename: 'ConversationSummary', content: string, isOutdated: boolean, createdByAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null } } };

export type GOnConversationTimelineModifiedSubscriptionVariables = Exact<{
  conversationId: Scalars['String'];
}>;


export type GOnConversationTimelineModifiedSubscription = { __typename?: 'Subscription', onConversationTimelineModified: { __typename?: 'ConversationTimelineEntity', id: string, conversationId: string, timestamp: any, position: any, linkedToTimelineId?: string | null, data: { __typename: 'ConversationAgentComment', content: string, contentIsTruncated: boolean, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationAgentMessage', content: string, contentIsTruncated: boolean, status: GMessageStatusItem, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationBotMessage', content: string } | { __typename: 'ConversationBotSuggestion', content: string, botResponseResult: GBotResponseResultItem, aiModel: GAiModelItem, actionableTasks: Array<{ __typename?: 'BotActionableTask', task?: string | null, queries: Array<string | null>, specificity: number, answerResult: GBotActionableAnswerResultItem, kbMatches: Array<{ __typename?: 'BotActionableTaskKbMatch', vectorSearchScore: number, aiRelevanceCheck: boolean, knowledgeBaseArticle: { __typename?: 'KnowledgeBaseArticleEntity', title: string } }> }> } | { __typename: 'ConversationContactMessage', content: string, contentIsTruncated: boolean, botIsProcessing: boolean, aiModelsProcessing: Array<GAiModelItem>, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, contactAddress: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem }, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationEvent', eventType: GAppEventType, executingAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, metadata?: { __typename?: 'ConversationAssignedMetaData', previousAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, newAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, previousTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null, newTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null } | { __typename?: 'ConversationSnoozedMetaData', remindAt?: any | null } | { __typename?: 'ConversationTagChangeMetaData' } | { __typename?: 'ConversationTransferredMetaData', fromChannel: GConversationChannelItem, toChannel: GConversationChannelItem, fromContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null, toContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null } | null } | { __typename: 'ConversationSummary', content: string, isOutdated: boolean, createdByAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null } } };

export type GOnAgentTypingInConversationByIdSubscriptionVariables = Exact<{
  conversationId: Scalars['String'];
}>;


export type GOnAgentTypingInConversationByIdSubscription = { __typename?: 'Subscription', onAgentTypingInConversationById: { __typename?: 'AgentTypingInConversation', conversationId: string, typingId: string, sequence: number, content: string, isFullContent: boolean, agentId: string } };

export type GOnAgentStoppedTypingInConversationByIdSubscriptionVariables = Exact<{
  conversationId: Scalars['String'];
}>;


export type GOnAgentStoppedTypingInConversationByIdSubscription = { __typename?: 'Subscription', onAgentStoppedTypingInConversationById: { __typename?: 'AgentStoppedTypingInConversation', conversationId: string, typingId: string, agentId: string } };

export type GOnContactTypingInConversationByIdSubscriptionVariables = Exact<{
  conversationId: Scalars['String'];
}>;


export type GOnContactTypingInConversationByIdSubscription = { __typename?: 'Subscription', onContactTypingInConversationById: { __typename?: 'ContactTypingInConversation', conversationId: string, contactId: string, sequence: number, content: string, isFullContent: boolean } };

export type GOnContactStoppedTypingInConversationByIdSubscriptionVariables = Exact<{
  conversationId: Scalars['String'];
}>;


export type GOnContactStoppedTypingInConversationByIdSubscription = { __typename?: 'Subscription', onContactStoppedTypingInConversationById: { __typename?: 'ContactStoppedTypingInConversation', conversationId: string, contactId: string } };

export type GGetConversationsQueryVariables = Exact<{
  take: Scalars['Int'];
  continuationToken?: InputMaybe<Scalars['String']>;
  filter: GGetAgentConversationsFilterInput;
  includeTotalCount: Scalars['Boolean'];
}>;


export type GGetConversationsQuery = { __typename?: 'Query', conversations: { __typename?: 'ConversationContinuationTokenConnection', continuationToken?: string | null, totalCount?: number | null, items: Array<{ __typename?: 'ConversationEntity', id: string, description?: string | null, updated: any, started: any, botAssistantMode: GConversationBotAssistantModeItem, status: GConversationStatusItem, lastMessageContent?: string | null, isDemoContent?: boolean | null, currentChannel: GConversationChannelItem, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, assignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null, currentContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string } | null }> } };

export type GGetConversationsLoadMoreQueryVariables = Exact<{
  take: Scalars['Int'];
  continuationToken?: InputMaybe<Scalars['String']>;
  filter: GGetAgentConversationsFilterInput;
}>;


export type GGetConversationsLoadMoreQuery = { __typename?: 'Query', conversations: { __typename?: 'ConversationContinuationTokenConnection', continuationToken?: string | null, items: Array<{ __typename?: 'ConversationEntity', id: string, description?: string | null, updated: any, started: any, botAssistantMode: GConversationBotAssistantModeItem, status: GConversationStatusItem, lastMessageContent?: string | null, isDemoContent?: boolean | null, currentChannel: GConversationChannelItem, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, assignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null, currentContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string } | null }> } };

export type GModifyConversationMutationVariables = Exact<{
  input: GModifyConversationInput;
}>;


export type GModifyConversationMutation = { __typename?: 'Mutation', modifyConversation: { __typename?: 'ModifyConversationPayload', conversation?: { __typename?: 'ConversationEntity', id: string, description?: string | null, updated: any, started: any, botAssistantMode: GConversationBotAssistantModeItem, status: GConversationStatusItem, lastMessageContent?: string | null, isDemoContent?: boolean | null, currentChannel: GConversationChannelItem, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, assignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null, currentContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string } | null } | null, errors?: Array<{ __typename?: 'AgentIsNotAuthorizedForConversationError', code: GUserErrorCode, message: string } | { __typename?: 'AgentNotFoundError', code: GUserErrorCode, message: string } | { __typename?: 'ConnectedServiceNotFoundError', code: GUserErrorCode, message: string } | { __typename?: 'ContactNotFoundError', code: GUserErrorCode, message: string } | { __typename?: 'ConversationNotFoundError', code: GUserErrorCode, message: string } | { __typename?: 'TeamNotFoundError', code: GUserErrorCode, message: string }> | null } };

export type GCreateDemoConversationsMutationVariables = Exact<{ [key: string]: never; }>;


export type GCreateDemoConversationsMutation = { __typename?: 'Mutation', createDemoConversations: { __typename?: 'CreateDemoConversationsPayload', conversations?: Array<{ __typename?: 'ConversationEntity', id: string, description?: string | null, updated: any, started: any, botAssistantMode: GConversationBotAssistantModeItem, status: GConversationStatusItem, lastMessageContent?: string | null, isDemoContent?: boolean | null, currentChannel: GConversationChannelItem, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, assignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null, currentContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string } | null }> | null } };

export type GOnConversationCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GOnConversationCreatedSubscription = { __typename?: 'Subscription', onConversationCreated: { __typename?: 'ConversationEntity', id: string, description?: string | null, updated: any, started: any, botAssistantMode: GConversationBotAssistantModeItem, status: GConversationStatusItem, lastMessageContent?: string | null, isDemoContent?: boolean | null, currentChannel: GConversationChannelItem, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, assignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null, currentContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string } | null } };

export type GOnConversationModifiedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GOnConversationModifiedSubscription = { __typename?: 'Subscription', onConversationModified: { __typename?: 'ConversationEntity', id: string, description?: string | null, updated: any, started: any, botAssistantMode: GConversationBotAssistantModeItem, status: GConversationStatusItem, lastMessageContent?: string | null, isDemoContent?: boolean | null, currentChannel: GConversationChannelItem, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, assignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null, currentContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string } | null } };

export type GModifyConversationSnoozeMutationVariables = Exact<{
  conversationId: Scalars['String'];
  remindAt: Scalars['String'];
  remindAtTimeZone: Scalars['String'];
}>;


export type GModifyConversationSnoozeMutation = { __typename?: 'Mutation', modifyConversation: { __typename?: 'ModifyConversationPayload', conversation?: { __typename?: 'ConversationEntity', id: string, description?: string | null, updated: any, started: any, botAssistantMode: GConversationBotAssistantModeItem, status: GConversationStatusItem, lastMessageContent?: string | null, isDemoContent?: boolean | null, currentChannel: GConversationChannelItem, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, assignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null, currentContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string } | null } | null, events?: Array<{ __typename?: 'ConversationTimelineEntity', id: string, conversationId: string, timestamp: any, position: any, linkedToTimelineId?: string | null, data: { __typename: 'ConversationAgentComment', content: string, contentIsTruncated: boolean, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationAgentMessage', content: string, contentIsTruncated: boolean, status: GMessageStatusItem, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationBotMessage', content: string } | { __typename: 'ConversationBotSuggestion', content: string, botResponseResult: GBotResponseResultItem, aiModel: GAiModelItem, actionableTasks: Array<{ __typename?: 'BotActionableTask', task?: string | null, queries: Array<string | null>, specificity: number, answerResult: GBotActionableAnswerResultItem, kbMatches: Array<{ __typename?: 'BotActionableTaskKbMatch', vectorSearchScore: number, aiRelevanceCheck: boolean, knowledgeBaseArticle: { __typename?: 'KnowledgeBaseArticleEntity', title: string } }> }> } | { __typename: 'ConversationContactMessage', content: string, contentIsTruncated: boolean, botIsProcessing: boolean, aiModelsProcessing: Array<GAiModelItem>, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, contactAddress: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem }, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationEvent', eventType: GAppEventType, executingAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, metadata?: { __typename?: 'ConversationAssignedMetaData', previousAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, newAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, previousTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null, newTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null } | { __typename?: 'ConversationSnoozedMetaData', remindAt?: any | null } | { __typename?: 'ConversationTagChangeMetaData' } | { __typename?: 'ConversationTransferredMetaData', fromChannel: GConversationChannelItem, toChannel: GConversationChannelItem, fromContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null, toContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null } | null } | { __typename: 'ConversationSummary', content: string, isOutdated: boolean, createdByAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null } }> | null, errors?: Array<{ __typename?: 'AgentIsNotAuthorizedForConversationError', code: GUserErrorCode, message: string } | { __typename?: 'AgentNotFoundError', code: GUserErrorCode, message: string } | { __typename?: 'ConnectedServiceNotFoundError', code: GUserErrorCode, message: string } | { __typename?: 'ContactNotFoundError', code: GUserErrorCode, message: string } | { __typename?: 'ConversationNotFoundError', code: GUserErrorCode, message: string } | { __typename?: 'TeamNotFoundError', code: GUserErrorCode, message: string }> | null } };

export type GTransferConversationOptionsQueryVariables = Exact<{
  conversationId: Scalars['String'];
}>;


export type GTransferConversationOptionsQuery = { __typename?: 'Query', conversationTransferOptions: { __typename?: 'GetConversationTransferOptionsPayload', options: Array<{ __typename?: 'TransferOption', channel: GConversationChannelItem, connectedServiceId: string, addressOptions: Array<{ __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem }> }> } };

export type GCreateContactAddressMutationVariables = Exact<{
  input: GCreateAddressInput;
}>;


export type GCreateContactAddressMutation = { __typename?: 'Mutation', createContactAddress: { __typename?: 'CreateContactAddressPayload', contactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null, errors?: Array<{ __typename: 'ContactAddressConflictError', message: string, code: GUserErrorCode, conflicts: Array<{ __typename?: 'ContactAddressAlreadyUsedError', address: string, type: GInputContactAddressTypeItem, contactId: string }> } | { __typename: 'ContactNotFoundError' }> | null } };

export type GGetConversationViewTeamsAndAgentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GGetConversationViewTeamsAndAgentsQuery = { __typename?: 'Query', agents: Array<{ __typename?: 'AgentEntity', id: string, firstName: string, lastName: string }>, teams: Array<{ __typename?: 'TeamEntity', id: string, name: string, emoji?: string | null }> };

export type GConversationAttachmentFragment = { __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any };

export type GConversationTimelineAgentFragment = { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string };

export type GConversationTimelineFragment = { __typename?: 'ConversationTimelineEntity', id: string, conversationId: string, timestamp: any, position: any, linkedToTimelineId?: string | null, data: { __typename: 'ConversationAgentComment', content: string, contentIsTruncated: boolean, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationAgentMessage', content: string, contentIsTruncated: boolean, status: GMessageStatusItem, agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationBotMessage', content: string } | { __typename: 'ConversationBotSuggestion', content: string, botResponseResult: GBotResponseResultItem, aiModel: GAiModelItem, actionableTasks: Array<{ __typename?: 'BotActionableTask', task?: string | null, queries: Array<string | null>, specificity: number, answerResult: GBotActionableAnswerResultItem, kbMatches: Array<{ __typename?: 'BotActionableTaskKbMatch', vectorSearchScore: number, aiRelevanceCheck: boolean, knowledgeBaseArticle: { __typename?: 'KnowledgeBaseArticleEntity', title: string } }> }> } | { __typename: 'ConversationContactMessage', content: string, contentIsTruncated: boolean, botIsProcessing: boolean, aiModelsProcessing: Array<GAiModelItem>, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, contactAddress: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem }, attachments: Array<{ __typename?: 'ConversationAttachment', previewUrl: string, downloadUrl: string, contentType: string, filename: string, size: any }> } | { __typename: 'ConversationEvent', eventType: GAppEventType, executingAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, metadata?: { __typename?: 'ConversationAssignedMetaData', previousAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, newAssignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, previousTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null, newTeam?: { __typename?: 'TeamEntity', id: string, name: string } | null } | { __typename?: 'ConversationSnoozedMetaData', remindAt?: any | null } | { __typename?: 'ConversationTagChangeMetaData' } | { __typename?: 'ConversationTransferredMetaData', fromChannel: GConversationChannelItem, toChannel: GConversationChannelItem, fromContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null, toContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string, addressType: GInputContactAddressTypeItem } | null } | null } | { __typename: 'ConversationSummary', content: string, isOutdated: boolean, createdByAgent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null } };

export type GConversationsFragment = { __typename?: 'ConversationEntity', id: string, description?: string | null, updated: any, started: any, botAssistantMode: GConversationBotAssistantModeItem, status: GConversationStatusItem, lastMessageContent?: string | null, isDemoContent?: boolean | null, currentChannel: GConversationChannelItem, contact: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null }, assignee?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string, name: string } | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null, currentContactAddress?: { __typename?: 'ContactAddressEntity', id: string, address: string } | null };

export type GGetTeamsAndAgentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GGetTeamsAndAgentsQuery = { __typename?: 'Query', agents: Array<{ __typename?: 'AgentEntity', id: string, firstName: string, lastName: string }>, teams: Array<{ __typename?: 'TeamEntity', id: string, name: string, emoji?: string | null }> };

export type GCreateKnowledgeBaseArticleMutationVariables = Exact<{
  title: Scalars['String'];
  solution: Scalars['String'];
  audience: GKnowledgeBaseArticleAudienceItem;
  draft: Scalars['Boolean'];
  questions: Array<Scalars['String']> | Scalars['String'];
}>;


export type GCreateKnowledgeBaseArticleMutation = { __typename?: 'Mutation', createKnowledgeBaseArticle: { __typename?: 'CreateKnowledgeBaseArticlePayload', knowledgeBaseArticle?: { __typename?: 'KnowledgeBaseArticleEntity', id: string } | null } };

export type GKnowledgeBaseArticleDisplayFragment = { __typename?: 'KnowledgeBaseArticleEntity', id: string, title: string, objective?: string | null, solution: string, questions: Array<string>, updated: any };

export type GGetKnowledgeBaseArticleDisplayByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GGetKnowledgeBaseArticleDisplayByIdQuery = { __typename?: 'Query', knowledgeBaseArticleById: { __typename?: 'KnowledgeBaseArticleEntity', id: string, title: string, objective?: string | null, solution: string, questions: Array<string>, updated: any } };

export type GKnowledgeBaseArticlesFragment = { __typename?: 'KnowledgeBaseArticleEntity', id: string, title: string, updated: any, solution: string };

export type GGetKnowledgeBaseArticlesQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  continuationToken?: InputMaybe<Scalars['String']>;
  statusFilter?: InputMaybe<Array<GKnowledgeBaseArticleStatusItem> | GKnowledgeBaseArticleStatusItem>;
}>;


export type GGetKnowledgeBaseArticlesQuery = { __typename?: 'Query', knowledgeBaseArticles: { __typename?: 'GetKnowledgeBaseArticlesPayload', continuationToken?: string | null, items: Array<{ __typename?: 'KnowledgeBaseArticleEntity', id: string, title: string, updated: any, solution: string }> } };

export type GGetKnowledgeBaseArticleModifyByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GGetKnowledgeBaseArticleModifyByIdQuery = { __typename?: 'Query', knowledgeBaseArticleById: { __typename?: 'KnowledgeBaseArticleEntity', id: string, title: string, objective?: string | null, solution: string, questions: Array<string>, audience: GKnowledgeBaseArticleAudienceItem, status: GKnowledgeBaseArticleStatusItem, updated: any, isPublishing: boolean } };

export type GKnowledgeBaseTenantSettingsFragment = { __typename?: 'KnowledgeBaseTenantSettingsEntity', id: string, articleLanguageIso639: string, approvalFlowEnabled: boolean };

export type GGetKnowledgeBaseTenantSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GGetKnowledgeBaseTenantSettingsQuery = { __typename?: 'Query', knowledgeBaseTenantSettings: { __typename?: 'KnowledgeBaseTenantSettingsEntity', id: string, articleLanguageIso639: string, approvalFlowEnabled: boolean } };

export type GModifyKnowledgeBaseTenantSettingsMutationVariables = Exact<{
  input: GModifyKnowledgeBaseTenantSettingsInput;
}>;


export type GModifyKnowledgeBaseTenantSettingsMutation = { __typename?: 'Mutation', modifyKnowledgeBaseTenantSettings: { __typename?: 'ModifyKnowledgeBaseTenantSettingsPayload', settings?: { __typename?: 'KnowledgeBaseTenantSettingsEntity', id: string, articleLanguageIso639: string, approvalFlowEnabled: boolean } | null, errors?: Array<{ __typename: 'AgentNotAuthorizedError' } | { __typename: 'InvalidLanguageCodeError' }> | null } };

export type GKnowledgeBaseArticleModifyFragment = { __typename?: 'KnowledgeBaseArticleEntity', id: string, title: string, objective?: string | null, solution: string, questions: Array<string>, audience: GKnowledgeBaseArticleAudienceItem, status: GKnowledgeBaseArticleStatusItem, updated: any, isPublishing: boolean };

export type GModifyKnowledgeBaseArticleMutationVariables = Exact<{
  input: GModifyKnowledgeBaseArticleInput;
}>;


export type GModifyKnowledgeBaseArticleMutation = { __typename?: 'Mutation', modifyKnowledgeBaseArticle: { __typename?: 'ModifyKnowledgeBaseArticlePayload', knowledgeBaseArticle?: { __typename?: 'KnowledgeBaseArticleEntity', id: string, title: string, objective?: string | null, solution: string, questions: Array<string>, audience: GKnowledgeBaseArticleAudienceItem, status: GKnowledgeBaseArticleStatusItem, updated: any, isPublishing: boolean } | null, errors?: Array<{ __typename: 'KnowledgeBaseArticleIsPublishingError', code: GUserErrorCode, message: string } | { __typename: 'KnowledgeBaseArticleNotFoundError' }> | null } };

export type GCreateKnowledgeBaseArticleSuggestionsFromConversationMutationVariables = Exact<{
  input: GCreateKnowledgeBaseArticleSuggestionsFromConversationInput;
}>;


export type GCreateKnowledgeBaseArticleSuggestionsFromConversationMutation = { __typename?: 'Mutation', createKnowledgeBaseArticleSuggestionsFromConversation: { __typename?: 'CreateKnowledgeBaseArticleSuggestionsFromConversationPayload', articles?: Array<{ __typename?: 'KnowledgeBaseArticleEntity', id: string, title: string }> | null } };

export type GDeleteKnowledgeBaseArticleMutationVariables = Exact<{
  input: GDeleteKnowledgeBaseArticleInput;
}>;


export type GDeleteKnowledgeBaseArticleMutation = { __typename?: 'Mutation', deleteKnowledgeBaseArticle: { __typename?: 'DeleteKnowledgeBaseArticlePayload', article?: { __typename?: 'KnowledgeBaseArticleEntity', id: string, title: string, objective?: string | null, solution: string, questions: Array<string>, audience: GKnowledgeBaseArticleAudienceItem, status: GKnowledgeBaseArticleStatusItem, updated: any, isPublishing: boolean } | null, errors?: Array<{ __typename: 'KnowledgeBaseArticleIsPublishingError', message: string, code: GUserErrorCode } | { __typename: 'KnowledgeBaseArticleNotFoundError', message: string, code: GUserErrorCode }> | null } };

export type GOnKnowledgeBaseArticleModifiedSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;


export type GOnKnowledgeBaseArticleModifiedSubscription = { __typename?: 'Subscription', onKnowledgeBaseArticleModified: { __typename?: 'KnowledgeBaseArticleEntity', id: string, title: string, objective?: string | null, solution: string, questions: Array<string>, audience: GKnowledgeBaseArticleAudienceItem, status: GKnowledgeBaseArticleStatusItem, updated: any, isPublishing: boolean } };

export type GCreateAgentPushSubscriptionMutationVariables = Exact<{
  input: GCreateAgentPushSubscriptionInput;
}>;


export type GCreateAgentPushSubscriptionMutation = { __typename?: 'Mutation', createAgentPushSubscription: { __typename?: 'CreateAgentPushSubscriptionPayload', success?: boolean | null } };

export type GConversationTimelineSearchQueryVariables = Exact<{
  query: Scalars['String'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GConversationTimelineSearchQuery = { __typename?: 'Query', searchConversationTimeline: { __typename?: 'SearchResultsPayloadOfConversationTimelineIndex', totalResults?: any | null, results: Array<{ __typename?: 'SearchResultOfConversationTimelineIndex', score?: number | null, document?: { __typename?: 'ConversationTimelineIndex', id: string, textPlain?: string | null, conversationId?: string | null } | null, highlights?: Array<{ __typename?: 'KeyValuePairOfStringAndIListOfString', key: string, value: Array<string> }> | null }> } };

export type GConversationSearchQueryVariables = Exact<{
  query: Scalars['String'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GConversationSearchQuery = { __typename?: 'Query', searchConversation: { __typename?: 'SearchResultsPayloadOfConversationIndex', totalResults?: any | null, results: Array<{ __typename?: 'SearchResultOfConversationIndex', score?: number | null, document?: { __typename?: 'ConversationIndex', id: string, description?: string | null, teamId?: string | null, tags: Array<string>, contact?: { __typename?: 'ContactEntity', id: string, firstName?: string | null, lastName?: string | null } | null } | null, highlights?: Array<{ __typename?: 'KeyValuePairOfStringAndIListOfString', key: string, value: Array<string> }> | null }> } };

export type GContactSearchQueryVariables = Exact<{
  query: Scalars['String'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GContactSearchQuery = { __typename?: 'Query', searchContact: { __typename?: 'SearchResultsPayloadOfContactIndex', totalResults?: any | null, results: Array<{ __typename?: 'SearchResultOfContactIndex', score?: number | null, document?: { __typename?: 'ContactIndex', id: string, firstName?: string | null, lastName?: string | null, tags: Array<string>, addresses: Array<{ __typename?: 'ContactAddressIndex', id: string, address: string, addressType: string }> } | null, highlights?: Array<{ __typename?: 'KeyValuePairOfStringAndIListOfString', key: string, value: Array<string> }> | null }> } };

export type GKnowledgeBaseSearchQueryVariables = Exact<{
  query: Scalars['String'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GKnowledgeBaseSearchQuery = { __typename?: 'Query', searchKnowledgeBase: { __typename?: 'SearchResultsPayloadOfKnowledgeBaseIndex', totalResults?: any | null, results: Array<{ __typename?: 'SearchResultOfKnowledgeBaseIndex', score?: number | null, document?: { __typename?: 'KnowledgeBaseIndex', id: string, status?: string | null, audience?: string | null, title?: string | null, solution?: string | null } | null, highlights?: Array<{ __typename?: 'KeyValuePairOfStringAndIListOfString', key: string, value: Array<string> }> | null }> } };

export type GAgentCreateMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  role: GTenantRoleItem;
  teamIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GAgentCreateMutation = { __typename?: 'Mutation', createAgent: { __typename?: 'CreateAgentPayload', agent?: { __typename?: 'AgentEntity', id: string, firstName: string, lastName: string } | null } };

export type GAgentListQueryVariables = Exact<{
  filter: GGetAgentsFilterInput;
}>;


export type GAgentListQuery = { __typename?: 'Query', agents: Array<{ __typename?: 'AgentEntity', id: string, email: string, name: string, firstName: string, lastName: string, away: boolean, awayFromPhone?: boolean | null, workerId?: string | null, idle: boolean, perTenant: { __typename?: 'AgentByTenant', role: GTenantRoleItem, status: GAgentStatusItem, teams: Array<{ __typename?: 'TeamEntity', id: string, name: string, emoji?: string | null }> } }> };

export type GAgentDeleteMutationVariables = Exact<{
  input: GDeleteAgentInput;
}>;


export type GAgentDeleteMutation = { __typename?: 'Mutation', deleteAgent: { __typename?: 'DeleteAgentPayload', agent?: { __typename?: 'AgentEntity', id: string } | null } };

export type GAgentByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GAgentByIdQuery = { __typename?: 'Query', agentById: { __typename?: 'AgentEntity', id: string, email: string, name: string, firstName: string, lastName: string, away: boolean, awayFromPhone?: boolean | null, locale: GLocaleItem, workerId?: string | null, idle: boolean, perTenant: { __typename?: 'AgentByTenant', role: GTenantRoleItem, status: GAgentStatusItem, teams: Array<{ __typename?: 'TeamEntity', id: string, name: string, emoji?: string | null }> } } };

export type GModifyAgentMutationVariables = Exact<{
  input: GModifyAgentInput;
}>;


export type GModifyAgentMutation = { __typename?: 'Mutation', modifyAgent: { __typename?: 'ModifyAgentPayload', agent?: { __typename?: 'AgentEntity', id: string, away: boolean, awayFromPhone?: boolean | null, settings: { __typename?: 'AgentSettings', autoAdvance: { __typename?: 'AgentSettingsAutoAdvance', action: GAutoAdvanceOptionItem } } } | null, errors?: Array<{ __typename: 'AgentNotAuthorizedError', message: string, code: GUserErrorCode } | { __typename: 'AgentNotFoundError', message: string, code: GUserErrorCode }> | null } };

export type GBotAssistantTenantSettingsFragment = { __typename?: 'BotAssistantTenantSettingsEntity', id: string, isEnabled: boolean, minimumChunkRelevance: number, minimumObjectiveRelevance: number, minimumQuestionRelevance: number, defaultBehaviourSettings: { __typename?: 'BotAssistantBehaviourSettings', splitActionableTasks: boolean, canUseExternalFacts: boolean, defaultBotAssistantMode: GConversationBotAssistantModeItem } };

export type GGetBotAssistantTenantSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GGetBotAssistantTenantSettingsQuery = { __typename?: 'Query', botAssistantTenantSettings: { __typename?: 'BotAssistantTenantSettingsEntity', id: string, isEnabled: boolean, minimumChunkRelevance: number, minimumObjectiveRelevance: number, minimumQuestionRelevance: number, defaultBehaviourSettings: { __typename?: 'BotAssistantBehaviourSettings', splitActionableTasks: boolean, canUseExternalFacts: boolean, defaultBotAssistantMode: GConversationBotAssistantModeItem } } };

export type GModifyBotAssistantTenantSettingsMutationVariables = Exact<{
  input: GModifyBotAssistantTenantSettingsInput;
}>;


export type GModifyBotAssistantTenantSettingsMutation = { __typename?: 'Mutation', modifyBotAssistantTenantSettings: { __typename?: 'ModifyBotAssistantTenantSettingsPayload', settings?: { __typename?: 'BotAssistantTenantSettingsEntity', id: string, isEnabled: boolean, minimumChunkRelevance: number, minimumObjectiveRelevance: number, minimumQuestionRelevance: number, defaultBehaviourSettings: { __typename?: 'BotAssistantBehaviourSettings', splitActionableTasks: boolean, canUseExternalFacts: boolean, defaultBotAssistantMode: GConversationBotAssistantModeItem } } | null, errors?: Array<{ __typename: 'AgentNotAuthorizedError' }> | null } };

export type GChatChannelDataFragment = { __typename?: 'ConnectedServiceChatEntity', id: string, status: GConnectedServiceStatusItem, locale: GLocaleItem, codeInstalled: boolean, embedCode: string, team?: { __typename?: 'TeamEntity', id: string, name: string } | null, preChatSurveyFields?: Array<{ __typename?: 'WidgetConfigurationPreChatSurveyField', type: GChatPreChatSurveyFieldType, id: string, label: string, placeholder?: string | null, hint?: string | null, required: boolean, targetEntity: GChatPreChatSurveyFieldTargetEntityType, options?: Array<string> | null }> | null, channels?: Array<{ __typename?: 'WidgetConfigurationChannel', channel: GConversationChannelItem, offerTransfer: boolean, offerStartDirect: boolean, startDirectTarget?: string | null }> | null, behaviour: { __typename?: 'WidgetConfigurationBehaviour', operationMode: GConnectedServiceChatEntityOperationModeItem, conversationStartMode: GConnectedServiceChatEntityConversationStartModeItem }, conversationSettings: { __typename?: 'WidgetConfigurationConversation', showAgentAvatar: boolean, showAgentName: boolean, agentNameVariation: GNameVariationItem }, text: { __typename?: 'WidgetConfigurationText', startMessage?: string | null, noAgentsOnlineMessage?: string | null, preChatSurveyHeader?: string | null, preChatSurveySubHeader?: string | null, splashHeaderText?: string | null, splashSubHeaderText?: string | null }, theme: { __typename?: 'WidgetConfigurationTheme', appBackgroundColorFrom: string, appBackgroundColorTo: string, primaryTextColor: string, primaryHoverColor: string, buttonBackgroundColor: string, buttonTextColor: string, buttonBorderColor: string, iconTextColor: string, inputBackgroundColor: string, inputTextColor: string, inputBorderColor: string, minimizedIconBackgroundColor: string, minimizedIconColor: string, topBackgroundColor: string, topTextColor: string, agentBubbleBackgroundColor: string, agentBubbleTextColor: string, botBubbleBackgroundColor: string, botBubbleTextColor: string, contactBubbleBackgroundColor: string, contactBubbleTextColor: string, processingBubbleBackgroundColor: string, processingBubbleTextColor: string } };

export type GChatChannelListQueryVariables = Exact<{ [key: string]: never; }>;


export type GChatChannelListQuery = { __typename?: 'Query', chatChannels: Array<{ __typename?: 'ConnectedServiceChatEntity', id: string, status: GConnectedServiceStatusItem, locale: GLocaleItem, codeInstalled: boolean, embedCode: string, team?: { __typename?: 'TeamEntity', id: string, name: string } | null, preChatSurveyFields?: Array<{ __typename?: 'WidgetConfigurationPreChatSurveyField', type: GChatPreChatSurveyFieldType, id: string, label: string, placeholder?: string | null, hint?: string | null, required: boolean, targetEntity: GChatPreChatSurveyFieldTargetEntityType, options?: Array<string> | null }> | null, channels?: Array<{ __typename?: 'WidgetConfigurationChannel', channel: GConversationChannelItem, offerTransfer: boolean, offerStartDirect: boolean, startDirectTarget?: string | null }> | null, behaviour: { __typename?: 'WidgetConfigurationBehaviour', operationMode: GConnectedServiceChatEntityOperationModeItem, conversationStartMode: GConnectedServiceChatEntityConversationStartModeItem }, conversationSettings: { __typename?: 'WidgetConfigurationConversation', showAgentAvatar: boolean, showAgentName: boolean, agentNameVariation: GNameVariationItem }, text: { __typename?: 'WidgetConfigurationText', startMessage?: string | null, noAgentsOnlineMessage?: string | null, preChatSurveyHeader?: string | null, preChatSurveySubHeader?: string | null, splashHeaderText?: string | null, splashSubHeaderText?: string | null }, theme: { __typename?: 'WidgetConfigurationTheme', appBackgroundColorFrom: string, appBackgroundColorTo: string, primaryTextColor: string, primaryHoverColor: string, buttonBackgroundColor: string, buttonTextColor: string, buttonBorderColor: string, iconTextColor: string, inputBackgroundColor: string, inputTextColor: string, inputBorderColor: string, minimizedIconBackgroundColor: string, minimizedIconColor: string, topBackgroundColor: string, topTextColor: string, agentBubbleBackgroundColor: string, agentBubbleTextColor: string, botBubbleBackgroundColor: string, botBubbleTextColor: string, contactBubbleBackgroundColor: string, contactBubbleTextColor: string, processingBubbleBackgroundColor: string, processingBubbleTextColor: string } }> };

export type GChatChannelByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GChatChannelByIdQuery = { __typename?: 'Query', chatChannelById: { __typename?: 'ConnectedServiceChatEntity', id: string, status: GConnectedServiceStatusItem, locale: GLocaleItem, codeInstalled: boolean, embedCode: string, team?: { __typename?: 'TeamEntity', id: string, name: string } | null, preChatSurveyFields?: Array<{ __typename?: 'WidgetConfigurationPreChatSurveyField', type: GChatPreChatSurveyFieldType, id: string, label: string, placeholder?: string | null, hint?: string | null, required: boolean, targetEntity: GChatPreChatSurveyFieldTargetEntityType, options?: Array<string> | null }> | null, channels?: Array<{ __typename?: 'WidgetConfigurationChannel', channel: GConversationChannelItem, offerTransfer: boolean, offerStartDirect: boolean, startDirectTarget?: string | null }> | null, behaviour: { __typename?: 'WidgetConfigurationBehaviour', operationMode: GConnectedServiceChatEntityOperationModeItem, conversationStartMode: GConnectedServiceChatEntityConversationStartModeItem }, conversationSettings: { __typename?: 'WidgetConfigurationConversation', showAgentAvatar: boolean, showAgentName: boolean, agentNameVariation: GNameVariationItem }, text: { __typename?: 'WidgetConfigurationText', startMessage?: string | null, noAgentsOnlineMessage?: string | null, preChatSurveyHeader?: string | null, preChatSurveySubHeader?: string | null, splashHeaderText?: string | null, splashSubHeaderText?: string | null }, theme: { __typename?: 'WidgetConfigurationTheme', appBackgroundColorFrom: string, appBackgroundColorTo: string, primaryTextColor: string, primaryHoverColor: string, buttonBackgroundColor: string, buttonTextColor: string, buttonBorderColor: string, iconTextColor: string, inputBackgroundColor: string, inputTextColor: string, inputBorderColor: string, minimizedIconBackgroundColor: string, minimizedIconColor: string, topBackgroundColor: string, topTextColor: string, agentBubbleBackgroundColor: string, agentBubbleTextColor: string, botBubbleBackgroundColor: string, botBubbleTextColor: string, contactBubbleBackgroundColor: string, contactBubbleTextColor: string, processingBubbleBackgroundColor: string, processingBubbleTextColor: string } } };

export type GCreateChatChannelMutationVariables = Exact<{
  input: GCreateChatChannelInput;
}>;


export type GCreateChatChannelMutation = { __typename?: 'Mutation', createChatChannel: { __typename?: 'CreateChatChannelPayload', channel?: { __typename?: 'ConnectedServiceChatEntity', id: string, status: GConnectedServiceStatusItem, locale: GLocaleItem, codeInstalled: boolean, embedCode: string, team?: { __typename?: 'TeamEntity', id: string, name: string } | null, preChatSurveyFields?: Array<{ __typename?: 'WidgetConfigurationPreChatSurveyField', type: GChatPreChatSurveyFieldType, id: string, label: string, placeholder?: string | null, hint?: string | null, required: boolean, targetEntity: GChatPreChatSurveyFieldTargetEntityType, options?: Array<string> | null }> | null, channels?: Array<{ __typename?: 'WidgetConfigurationChannel', channel: GConversationChannelItem, offerTransfer: boolean, offerStartDirect: boolean, startDirectTarget?: string | null }> | null, behaviour: { __typename?: 'WidgetConfigurationBehaviour', operationMode: GConnectedServiceChatEntityOperationModeItem, conversationStartMode: GConnectedServiceChatEntityConversationStartModeItem }, conversationSettings: { __typename?: 'WidgetConfigurationConversation', showAgentAvatar: boolean, showAgentName: boolean, agentNameVariation: GNameVariationItem }, text: { __typename?: 'WidgetConfigurationText', startMessage?: string | null, noAgentsOnlineMessage?: string | null, preChatSurveyHeader?: string | null, preChatSurveySubHeader?: string | null, splashHeaderText?: string | null, splashSubHeaderText?: string | null }, theme: { __typename?: 'WidgetConfigurationTheme', appBackgroundColorFrom: string, appBackgroundColorTo: string, primaryTextColor: string, primaryHoverColor: string, buttonBackgroundColor: string, buttonTextColor: string, buttonBorderColor: string, iconTextColor: string, inputBackgroundColor: string, inputTextColor: string, inputBorderColor: string, minimizedIconBackgroundColor: string, minimizedIconColor: string, topBackgroundColor: string, topTextColor: string, agentBubbleBackgroundColor: string, agentBubbleTextColor: string, botBubbleBackgroundColor: string, botBubbleTextColor: string, contactBubbleBackgroundColor: string, contactBubbleTextColor: string, processingBubbleBackgroundColor: string, processingBubbleTextColor: string } } | null } };

export type GModifyChatChannelMutationVariables = Exact<{
  input: GModifyChatChannelInput;
}>;


export type GModifyChatChannelMutation = { __typename?: 'Mutation', modifyChatChannel: { __typename?: 'ModifyChatChannelPayload', channel?: { __typename?: 'ConnectedServiceChatEntity', id: string, status: GConnectedServiceStatusItem, locale: GLocaleItem, codeInstalled: boolean, embedCode: string, team?: { __typename?: 'TeamEntity', id: string, name: string } | null, preChatSurveyFields?: Array<{ __typename?: 'WidgetConfigurationPreChatSurveyField', type: GChatPreChatSurveyFieldType, id: string, label: string, placeholder?: string | null, hint?: string | null, required: boolean, targetEntity: GChatPreChatSurveyFieldTargetEntityType, options?: Array<string> | null }> | null, channels?: Array<{ __typename?: 'WidgetConfigurationChannel', channel: GConversationChannelItem, offerTransfer: boolean, offerStartDirect: boolean, startDirectTarget?: string | null }> | null, behaviour: { __typename?: 'WidgetConfigurationBehaviour', operationMode: GConnectedServiceChatEntityOperationModeItem, conversationStartMode: GConnectedServiceChatEntityConversationStartModeItem }, conversationSettings: { __typename?: 'WidgetConfigurationConversation', showAgentAvatar: boolean, showAgentName: boolean, agentNameVariation: GNameVariationItem }, text: { __typename?: 'WidgetConfigurationText', startMessage?: string | null, noAgentsOnlineMessage?: string | null, preChatSurveyHeader?: string | null, preChatSurveySubHeader?: string | null, splashHeaderText?: string | null, splashSubHeaderText?: string | null }, theme: { __typename?: 'WidgetConfigurationTheme', appBackgroundColorFrom: string, appBackgroundColorTo: string, primaryTextColor: string, primaryHoverColor: string, buttonBackgroundColor: string, buttonTextColor: string, buttonBorderColor: string, iconTextColor: string, inputBackgroundColor: string, inputTextColor: string, inputBorderColor: string, minimizedIconBackgroundColor: string, minimizedIconColor: string, topBackgroundColor: string, topTextColor: string, agentBubbleBackgroundColor: string, agentBubbleTextColor: string, botBubbleBackgroundColor: string, botBubbleTextColor: string, contactBubbleBackgroundColor: string, contactBubbleTextColor: string, processingBubbleBackgroundColor: string, processingBubbleTextColor: string } } | null } };

export type GCreateEmailChannelMutationVariables = Exact<{
  input: GCreateEmailChannelInput;
}>;


export type GCreateEmailChannelMutation = { __typename?: 'Mutation', createEmailChannel: { __typename?: 'CreateEmailChannelPayload', channel?: { __typename?: 'ConnectedServiceEmailEntity', id: string, status: GConnectedServiceStatusItem, emailLocalPart: string, email?: string | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null } | null } };

export type GEmailChannelListQueryVariables = Exact<{ [key: string]: never; }>;


export type GEmailChannelListQuery = { __typename?: 'Query', emailChannels: Array<{ __typename?: 'ConnectedServiceEmailEntity', id: string, status: GConnectedServiceStatusItem, emailLocalPart: string, email?: string | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null }> };

export type GEmailChannelItemFragment = { __typename?: 'ConnectedServiceEmailEntity', id: string, status: GConnectedServiceStatusItem, emailLocalPart: string, email?: string | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null };

export type GMessengerChannelListQueryVariables = Exact<{ [key: string]: never; }>;


export type GMessengerChannelListQuery = { __typename?: 'Query', messengerChannels: Array<{ __typename?: 'ConnectedServiceMessengerEntity', id: string, status: GConnectedServiceStatusItem, facebookPageId: string, facebookPageName: string, team?: { __typename?: 'TeamEntity', id: string, name: string } | null }> };

export type GMessengerPageOptionsListQueryVariables = Exact<{
  accessToken: Scalars['String'];
}>;


export type GMessengerPageOptionsListQuery = { __typename?: 'Query', facebookPageOptions: Array<{ __typename?: 'FacebookPageOptionsResult', pageId: string, pageName: string }> };

export type GCreateMessengerChannelMutationVariables = Exact<{
  input: GCreateMessengerChannelInput;
}>;


export type GCreateMessengerChannelMutation = { __typename?: 'Mutation', createMessengerChannel: { __typename?: 'CreateMessengerChannelPayload', channel?: { __typename?: 'ConnectedServiceMessengerEntity', id: string, status: GConnectedServiceStatusItem, facebookPageId: string, facebookPageName: string, team?: { __typename?: 'TeamEntity', id: string, name: string } | null } | null } };

export type GDeleteMessengerChannelMutationVariables = Exact<{
  input: GDeleteMessengerChannelInput;
}>;


export type GDeleteMessengerChannelMutation = { __typename?: 'Mutation', deleteMessengerChannel: { __typename?: 'DeleteMessengerChannelPayload', channel?: { __typename?: 'ConnectedServiceMessengerEntity', id: string, status: GConnectedServiceStatusItem, facebookPageId: string, facebookPageName: string, team?: { __typename?: 'TeamEntity', id: string, name: string } | null } | null } };

export type GMessengerChannelItemFragment = { __typename?: 'ConnectedServiceMessengerEntity', id: string, status: GConnectedServiceStatusItem, facebookPageId: string, facebookPageName: string, team?: { __typename?: 'TeamEntity', id: string, name: string } | null };

export type GSmsSubNumberChannelFragment = { __typename?: 'ConnectedServiceSmsSubNumberEntity', id: string, status: GConnectedServiceStatusItem, smsPrefixText?: string | null, smsSuffixText?: string | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null };

export type GVonageChannelFragment = { __typename?: 'ConnectedServiceVonageEntity', id: string, status: GConnectedServiceStatusItem, smsPrefixText?: string | null, smsSuffixText?: string | null, hasWhatsAppCapability: boolean, hasSmsCapability: boolean, isPendingWhatsAppSetup: boolean, linkedPhoneNumber?: string | null, conversationMessageWindowInHours: number, team?: { __typename?: 'TeamEntity', id: string, name: string } | null };

export type GSmsChannelListQueryVariables = Exact<{ [key: string]: never; }>;


export type GSmsChannelListQuery = { __typename?: 'Query', smsSubNumberChannels: Array<{ __typename?: 'ConnectedServiceSmsSubNumberEntity', id: string, status: GConnectedServiceStatusItem, smsPrefixText?: string | null, smsSuffixText?: string | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null }>, smsVonageChannels: Array<{ __typename?: 'ConnectedServiceVonageEntity', id: string, status: GConnectedServiceStatusItem, smsPrefixText?: string | null, smsSuffixText?: string | null, hasWhatsAppCapability: boolean, hasSmsCapability: boolean, isPendingWhatsAppSetup: boolean, linkedPhoneNumber?: string | null, conversationMessageWindowInHours: number, team?: { __typename?: 'TeamEntity', id: string, name: string } | null }> };

export type GCreateSmsSubNumberChannelMutationVariables = Exact<{
  input: GCreateSmsSubNumberChannelInput;
}>;


export type GCreateSmsSubNumberChannelMutation = { __typename?: 'Mutation', createSmsSubNumberChannel: { __typename?: 'CreateSmsSubNumberChannelPayload', channel?: { __typename?: 'ConnectedServiceSmsSubNumberEntity', id: string, status: GConnectedServiceStatusItem, smsPrefixText?: string | null, smsSuffixText?: string | null, team?: { __typename?: 'TeamEntity', id: string, name: string } | null } | null } };

export type GCreateSmsVonageChannelMutationVariables = Exact<{
  input: GCreateSmsVonageChannelInput;
}>;


export type GCreateSmsVonageChannelMutation = { __typename?: 'Mutation', createSmsVonageChannel: { __typename?: 'CreateSmsVonageChannelPayload', channel?: { __typename?: 'ConnectedServiceVonageEntity', id: string, status: GConnectedServiceStatusItem, smsPrefixText?: string | null, smsSuffixText?: string | null, hasWhatsAppCapability: boolean, hasSmsCapability: boolean, isPendingWhatsAppSetup: boolean, linkedPhoneNumber?: string | null, conversationMessageWindowInHours: number, team?: { __typename?: 'TeamEntity', id: string, name: string } | null } | null } };

export type GCreateTeamMutationVariables = Exact<{
  input: GCreateTeamInput;
}>;


export type GCreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'CreateTeamPayload', team?: { __typename?: 'TeamEntity', id: string, name: string } | null } };

export type GDeleteTeamMutationVariables = Exact<{
  input: GDeleteTeamInput;
}>;


export type GDeleteTeamMutation = { __typename?: 'Mutation', deleteTeam: { __typename?: 'DeleteTeamPayload', team?: { __typename?: 'TeamEntity', id: string } | null } };

export type GGetTeamByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GGetTeamByIdQuery = { __typename?: 'Query', teamById: { __typename?: 'TeamEntity', id: string, name: string, emoji?: string | null, agents: Array<{ __typename?: 'AgentEntity', id: string }> } };

export type GModifyTeamMutationVariables = Exact<{
  input: GModifyTeamInput;
}>;


export type GModifyTeamMutation = { __typename?: 'Mutation', modifyTeam: { __typename?: 'ModifyTeamPayload', team?: { __typename?: 'TeamEntity', id: string, name: string, emoji?: string | null } | null } };

export type GTranslateTextWithHtmlMutationVariables = Exact<{
  text: Scalars['String'];
  language: Scalars['String'];
}>;


export type GTranslateTextWithHtmlMutation = { __typename?: 'Mutation', translateTextWithHtml: { __typename?: 'TranslateTextWithHtmlPayload', translation: string } };

export type GFixGrammarTextWithHtmlMutationVariables = Exact<{
  text: Scalars['String'];
}>;


export type GFixGrammarTextWithHtmlMutation = { __typename?: 'Mutation', fixGrammarTextWithHtml: { __typename?: 'FixGrammarTextWithHtmlPayload', text: string } };

export type GImproveTextWithHtmlMutationVariables = Exact<{
  text: Scalars['String'];
}>;


export type GImproveTextWithHtmlMutation = { __typename?: 'Mutation', improveTextWithHtml: { __typename?: 'ImproveTextWithHtmlPayload', text: string } };

type GUserError_AgentIsNotAuthorizedForConversationError_Fragment = { __typename?: 'AgentIsNotAuthorizedForConversationError', code: GUserErrorCode, message: string };

type GUserError_AgentNotAuthorizedError_Fragment = { __typename?: 'AgentNotAuthorizedError', code: GUserErrorCode, message: string };

type GUserError_AgentNotFoundError_Fragment = { __typename?: 'AgentNotFoundError', code: GUserErrorCode, message: string };

type GUserError_AgentNotificationNotFoundError_Fragment = { __typename?: 'AgentNotificationNotFoundError', code: GUserErrorCode, message: string };

type GUserError_AssistantError_Fragment = { __typename?: 'AssistantError', code: GUserErrorCode, message: string };

type GUserError_ConnectedServiceNotFoundError_Fragment = { __typename?: 'ConnectedServiceNotFoundError', code: GUserErrorCode, message: string };

type GUserError_ContactAddressConflictError_Fragment = { __typename?: 'ContactAddressConflictError', code: GUserErrorCode, message: string };

type GUserError_ContactNotFoundError_Fragment = { __typename?: 'ContactNotFoundError', code: GUserErrorCode, message: string };

type GUserError_ConversationNotFoundError_Fragment = { __typename?: 'ConversationNotFoundError', code: GUserErrorCode, message: string };

type GUserError_ConversationSnippetNotFoundError_Fragment = { __typename?: 'ConversationSnippetNotFoundError', code: GUserErrorCode, message: string };

type GUserError_InvalidLanguageCodeError_Fragment = { __typename?: 'InvalidLanguageCodeError', code: GUserErrorCode, message: string };

type GUserError_KnowledgeBaseArticleIsPublishingError_Fragment = { __typename?: 'KnowledgeBaseArticleIsPublishingError', code: GUserErrorCode, message: string };

type GUserError_KnowledgeBaseArticleNotFoundError_Fragment = { __typename?: 'KnowledgeBaseArticleNotFoundError', code: GUserErrorCode, message: string };

type GUserError_TeamAlreadyExistsError_Fragment = { __typename?: 'TeamAlreadyExistsError', code: GUserErrorCode, message: string };

type GUserError_TeamNotFoundError_Fragment = { __typename?: 'TeamNotFoundError', code: GUserErrorCode, message: string };

export type GUserErrorFragment = GUserError_AgentIsNotAuthorizedForConversationError_Fragment | GUserError_AgentNotAuthorizedError_Fragment | GUserError_AgentNotFoundError_Fragment | GUserError_AgentNotificationNotFoundError_Fragment | GUserError_AssistantError_Fragment | GUserError_ConnectedServiceNotFoundError_Fragment | GUserError_ContactAddressConflictError_Fragment | GUserError_ContactNotFoundError_Fragment | GUserError_ConversationNotFoundError_Fragment | GUserError_ConversationSnippetNotFoundError_Fragment | GUserError_InvalidLanguageCodeError_Fragment | GUserError_KnowledgeBaseArticleIsPublishingError_Fragment | GUserError_KnowledgeBaseArticleNotFoundError_Fragment | GUserError_TeamAlreadyExistsError_Fragment | GUserError_TeamNotFoundError_Fragment;

export const GlobalAgentWithStatusListFragmentDoc = gql`
    fragment globalAgentWithStatusList on AgentEntity {
  id
  name
  firstName
  lastName
  away
  awayFromPhone
  workerId
  idle
  perTenant {
    status
    role
  }
}
    `;
export const GlobalTeamListFragmentDoc = gql`
    fragment globalTeamList on TeamEntity {
  id
  name
  emoji
  deleted
  agents {
    id
    name
  }
}
    `;
export const GlobalTagListFragmentDoc = gql`
    fragment globalTagList on TagEntity {
  id
  tag
}
    `;
export const GlobalConnectedServiceListFragmentDoc = gql`
    fragment globalConnectedServiceList on BaseConnectedServiceEntity {
  id
  status
  type
  capabilities
}
    `;
export const GlobalSnippetListFragmentDoc = gql`
    fragment globalSnippetList on ConversationSnippetEntity {
  id
  title
  content
  private
  createdAt
  updatedAt
  restrictToChannels
}
    `;
export const GlobalMeFragmentDoc = gql`
    fragment globalMe on AgentEntity {
  id
  email
  locale
  name
  firstName
  lastName
  workerId
  settings {
    autoAdvance {
      action
    }
  }
  perTenant {
    isFirstAgentInTenant
    role
    teams {
      id
    }
  }
}
    `;
export const GlobalTenantFragmentDoc = gql`
    fragment globalTenant on TenantEntity {
  id
  name
  createdAt
  additionalAgentsPurchasedCount
  subdomain
  emailChannelDomain
  onboardingStatus {
    hasInstalledWidgetOnWebsite
    hasAtLeastOneConversation
  }
  partner {
    id
    name
    whiteLabelProductName
  }
}
    `;
export const GlobalActiveConversationCountFragmentDoc = gql`
    fragment globalActiveConversationCount on ConversationCountPayload {
  count {
    key
    value
  }
}
    `;
export const GlobalUnseenAgentNotificationCountFragmentDoc = gql`
    fragment globalUnseenAgentNotificationCount on UnseenAgentNotificationCountPayload {
  count
}
    `;
export const AgentNotificationConversationFragmentDoc = gql`
    fragment agentNotificationConversation on ConversationEntity {
  id
  description
  team {
    id
    name
  }
}
    `;
export const AgentNotificationConversationTimelineFragmentDoc = gql`
    fragment agentNotificationConversationTimeline on ConversationTimelineEntity {
  id
  conversationId
  data {
    __typename
    ... on ConversationAgentComment {
      content
    }
    ... on ConversationContactMessage {
      content
    }
  }
}
    `;
export const AgentNotificationFragmentDoc = gql`
    fragment agentNotification on AgentNotificationEntity {
  id
  seen
  eventType
  timestamp
  generatedByAgent {
    id
    name
    firstName
  }
  conversation {
    ...agentNotificationConversation
  }
  conversationTimeline {
    ...agentNotificationConversationTimeline
  }
}
    ${AgentNotificationConversationFragmentDoc}
${AgentNotificationConversationTimelineFragmentDoc}`;
export const AgentNotificationSettingFlagsFragmentDoc = gql`
    fragment agentNotificationSettingFlags on AgentSettingsNotificationFlags {
  inApp
  preferDesktop
  pushNotification
  pushNotificationWhenAway
}
    `;
export const AgentNotificationSettingFragmentDoc = gql`
    fragment agentNotificationSetting on AgentNotificationSettingEntity {
  conversationUnassignedUnSnoozed {
    ...agentNotificationSettingFlags
  }
  conversationAssignedAgentUnSnoozed {
    ...agentNotificationSettingFlags
  }
  conversationAssignedTeamUnSnoozed {
    ...agentNotificationSettingFlags
  }
  conversationUnassignedContactMessageCreated {
    ...agentNotificationSettingFlags
  }
  conversationAssignedAgentContactMessageCreated {
    ...agentNotificationSettingFlags
  }
  conversationAssignedTeamContactMessageCreated {
    ...agentNotificationSettingFlags
  }
  conversationAgentMentioned {
    ...agentNotificationSettingFlags
  }
  conversationAssignedToAgent {
    ...agentNotificationSettingFlags
  }
  conversationAssignedToTeam {
    ...agentNotificationSettingFlags
  }
  conversationUnassignedCreatedByContact {
    ...agentNotificationSettingFlags
  }
  conversationAssignedAgentCreatedByContact {
    ...agentNotificationSettingFlags
  }
  conversationAssignedTeamCreatedByContact {
    ...agentNotificationSettingFlags
  }
}
    ${AgentNotificationSettingFlagsFragmentDoc}`;
export const AppEventConversationAgentMessageFragmentDoc = gql`
    fragment appEventConversationAgentMessage on ConversationAgentMessage {
  conversation {
    id
    contact {
      id
      firstName
      lastName
    }
  }
  agent {
    id
    firstName
    lastName
    name
  }
  content
}
    `;
export const AppEventConversationAgentCommentFragmentDoc = gql`
    fragment appEventConversationAgentComment on ConversationAgentComment {
  conversation {
    id
    contact {
      id
      firstName
      lastName
    }
  }
  agent {
    id
    firstName
    lastName
  }
  content
}
    `;
export const AppEventConversationContactMessageFragmentDoc = gql`
    fragment appEventConversationContactMessage on ConversationContactMessage {
  conversation {
    id
    contact {
      id
      firstName
      lastName
    }
  }
  content
}
    `;
export const AppEventConversationBotSuggestionFragmentDoc = gql`
    fragment appEventConversationBotSuggestion on ConversationBotSuggestion {
  conversation {
    id
    contact {
      id
      firstName
      lastName
    }
  }
  content
}
    `;
export const AppEventConversationBotMessageFragmentDoc = gql`
    fragment appEventConversationBotMessage on ConversationBotMessage {
  conversation {
    id
    contact {
      id
      firstName
      lastName
    }
  }
  content
}
    `;
export const AppEventConversationEventFragmentDoc = gql`
    fragment appEventConversationEvent on ConversationEvent {
  conversation {
    id
    contact {
      id
      firstName
      lastName
    }
  }
  executingAgent {
    id
    firstName
    lastName
  }
  metadata {
    __typename
    ... on ConversationAssignedMetaData {
      previousAssignee {
        id
        firstName
        lastName
      }
      newAssignee {
        id
        firstName
        lastName
      }
      previousTeam {
        id
        name
      }
      newTeam {
        id
        name
      }
    }
    ... on ConversationSnoozedMetaData {
      remindAt
    }
  }
}
    `;
export const AppEventFragmentDoc = gql`
    fragment appEvent on AppEventByTenant {
  id
  __typename
  eventType
  timestamp
  eventData {
    __typename
    ... on ConversationAgentMessage {
      ...appEventConversationAgentMessage
    }
    ... on ConversationAgentComment {
      ...appEventConversationAgentComment
    }
    ... on ConversationContactMessage {
      ...appEventConversationContactMessage
    }
    ... on ConversationBotSuggestion {
      ...appEventConversationBotSuggestion
    }
    ... on ConversationBotMessage {
      ...appEventConversationBotMessage
    }
    ... on ConversationEvent {
      ...appEventConversationEvent
    }
  }
}
    ${AppEventConversationAgentMessageFragmentDoc}
${AppEventConversationAgentCommentFragmentDoc}
${AppEventConversationContactMessageFragmentDoc}
${AppEventConversationBotSuggestionFragmentDoc}
${AppEventConversationBotMessageFragmentDoc}
${AppEventConversationEventFragmentDoc}`;
export const ContactEntityFragmentDoc = gql`
    fragment contactEntity on ContactEntity {
  id
  firstName
  lastName
  address {
    id
    address
    addressType
  }
}
    `;
export const ConversationSnippetFragmentDoc = gql`
    fragment conversationSnippet on ConversationSnippetEntity {
  id
  title
  content
  deleted
  private
  createdAt
  updatedAt
  restrictToChannels
  createdByAgent {
    id
    name
  }
}
    `;
export const ConversationTimelineAgentFragmentDoc = gql`
    fragment conversationTimelineAgent on AgentEntity {
  id
  firstName
  lastName
  name
}
    `;
export const ConversationAttachmentFragmentDoc = gql`
    fragment conversationAttachment on ConversationAttachment {
  previewUrl
  downloadUrl
  contentType
  filename
  size
}
    `;
export const ConversationTimelineFragmentDoc = gql`
    fragment conversationTimeline on ConversationTimelineEntity {
  id
  conversationId
  timestamp
  position
  linkedToTimelineId
  data {
    __typename
    ... on ConversationSummary {
      content
      isOutdated
      createdByAgent {
        ...conversationTimelineAgent
      }
    }
    ... on ConversationAgentMessage {
      content
      contentIsTruncated
      status
      agent {
        ...conversationTimelineAgent
      }
      attachments {
        ...conversationAttachment
      }
    }
    ... on ConversationAgentComment {
      content
      contentIsTruncated
      agent {
        ...conversationTimelineAgent
      }
      attachments {
        ...conversationAttachment
      }
    }
    ... on ConversationContactMessage {
      content
      contentIsTruncated
      botIsProcessing
      aiModelsProcessing
      contact {
        id
        firstName
        lastName
      }
      contactAddress {
        id
        address
        addressType
      }
      attachments {
        ...conversationAttachment
      }
    }
    ... on ConversationBotMessage {
      content
    }
    ... on ConversationBotSuggestion {
      content
      botResponseResult
      aiModel
      actionableTasks {
        task
        queries
        specificity
        answerResult
        kbMatches {
          knowledgeBaseArticle {
            title
          }
          vectorSearchScore
          aiRelevanceCheck
        }
      }
    }
    ... on ConversationEvent {
      eventType
      executingAgent {
        ...conversationTimelineAgent
      }
      metadata {
        ... on ConversationAssignedMetaData {
          previousAssignee {
            ...conversationTimelineAgent
          }
          newAssignee {
            ...conversationTimelineAgent
          }
          previousTeam {
            id
            name
          }
          newTeam {
            id
            name
          }
        }
        ... on ConversationSnoozedMetaData {
          remindAt
        }
        ... on ConversationTransferredMetaData {
          fromChannel
          toChannel
          fromContactAddress {
            id
            address
            addressType
          }
          toContactAddress {
            id
            address
            addressType
          }
        }
      }
    }
  }
}
    ${ConversationTimelineAgentFragmentDoc}
${ConversationAttachmentFragmentDoc}`;
export const ConversationByIdFragmentDoc = gql`
    fragment conversationById on ConversationEntity {
  id
  description
  status
  botAssistantMode
  currentChannel
  isDemoContent
  contact {
    id
    firstName
    lastName
  }
  currentContactAddress {
    id
    address
    addressType
  }
  assignee {
    id
    firstName
    lastName
  }
  team {
    id
    name
  }
  timeline(take: $take) {
    items {
      ...conversationTimeline
    }
    continuationToken
  }
}
    ${ConversationTimelineFragmentDoc}`;
export const ConversationsFragmentDoc = gql`
    fragment conversations on ConversationEntity {
  id
  description
  updated
  started
  botAssistantMode
  status
  lastMessageContent
  isDemoContent
  contact {
    id
    firstName
    lastName
  }
  currentChannel
  assignee {
    ...conversationTimelineAgent
  }
  team {
    id
    name
  }
  currentContactAddress {
    id
    address
  }
}
    ${ConversationTimelineAgentFragmentDoc}`;
export const KnowledgeBaseArticleDisplayFragmentDoc = gql`
    fragment knowledgeBaseArticleDisplay on KnowledgeBaseArticleEntity {
  id
  title
  objective
  solution
  questions
  updated
}
    `;
export const KnowledgeBaseArticlesFragmentDoc = gql`
    fragment knowledgeBaseArticles on KnowledgeBaseArticleEntity {
  id
  title
  updated
  solution
}
    `;
export const KnowledgeBaseTenantSettingsFragmentDoc = gql`
    fragment knowledgeBaseTenantSettings on KnowledgeBaseTenantSettingsEntity {
  id
  articleLanguageIso639
  approvalFlowEnabled
}
    `;
export const KnowledgeBaseArticleModifyFragmentDoc = gql`
    fragment knowledgeBaseArticleModify on KnowledgeBaseArticleEntity {
  id
  title
  objective
  solution
  questions
  audience
  status
  updated
  questions
  isPublishing
}
    `;
export const BotAssistantTenantSettingsFragmentDoc = gql`
    fragment botAssistantTenantSettings on BotAssistantTenantSettingsEntity {
  id
  isEnabled
  minimumChunkRelevance
  minimumObjectiveRelevance
  minimumQuestionRelevance
  defaultBehaviourSettings {
    splitActionableTasks
    canUseExternalFacts
    defaultBotAssistantMode
  }
}
    `;
export const ChatChannelDataFragmentDoc = gql`
    fragment chatChannelData on ConnectedServiceChatEntity {
  id
  status
  team {
    id
    name
  }
  preChatSurveyFields {
    type
    id
    label
    placeholder
    hint
    required
    targetEntity
    options
  }
  channels {
    channel
    offerTransfer
    offerStartDirect
    startDirectTarget
  }
  locale
  behaviour {
    operationMode
    conversationStartMode
  }
  conversationSettings {
    showAgentAvatar
    showAgentName
    agentNameVariation
  }
  text {
    startMessage
    noAgentsOnlineMessage
    preChatSurveyHeader
    preChatSurveySubHeader
    splashHeaderText
    splashSubHeaderText
  }
  theme {
    appBackgroundColorFrom
    appBackgroundColorTo
    primaryTextColor
    primaryHoverColor
    buttonBackgroundColor
    buttonTextColor
    buttonBorderColor
    iconTextColor
    inputBackgroundColor
    inputTextColor
    inputBorderColor
    minimizedIconBackgroundColor
    minimizedIconColor
    topBackgroundColor
    topTextColor
    agentBubbleBackgroundColor
    agentBubbleTextColor
    botBubbleBackgroundColor
    botBubbleTextColor
    contactBubbleBackgroundColor
    contactBubbleTextColor
    processingBubbleBackgroundColor
    processingBubbleTextColor
  }
  codeInstalled
  embedCode
}
    `;
export const EmailChannelItemFragmentDoc = gql`
    fragment emailChannelItem on ConnectedServiceEmailEntity {
  id
  status
  emailLocalPart
  email
  team {
    id
    name
  }
}
    `;
export const MessengerChannelItemFragmentDoc = gql`
    fragment messengerChannelItem on ConnectedServiceMessengerEntity {
  id
  status
  facebookPageId
  facebookPageName
  team {
    id
    name
  }
}
    `;
export const SmsSubNumberChannelFragmentDoc = gql`
    fragment smsSubNumberChannel on ConnectedServiceSmsSubNumberEntity {
  id
  status
  team {
    id
    name
  }
  smsPrefixText
  smsSuffixText
}
    `;
export const VonageChannelFragmentDoc = gql`
    fragment vonageChannel on ConnectedServiceVonageEntity {
  id
  status
  team {
    id
    name
  }
  smsPrefixText
  smsSuffixText
  hasWhatsAppCapability
  hasSmsCapability
  isPendingWhatsAppSetup
  linkedPhoneNumber
  conversationMessageWindowInHours
}
    `;
export const UserErrorFragmentDoc = gql`
    fragment userError on UserError {
  code
  message
}
    `;
export const AppInitQueryDocument = gql`
    query AppInitQuery {
  agents {
    ...globalAgentWithStatusList
  }
  tags {
    ...globalTagList
  }
  channels {
    ...globalConnectedServiceList
  }
  me {
    ...globalMe
  }
  teams {
    ...globalTeamList
  }
  tenant {
    ...globalTenant
  }
  conversationCount {
    ...globalActiveConversationCount
  }
  unseenAgentNotificationCount {
    ...globalUnseenAgentNotificationCount
  }
  conversationSnippets {
    items {
      ...globalSnippetList
    }
  }
}
    ${GlobalAgentWithStatusListFragmentDoc}
${GlobalTagListFragmentDoc}
${GlobalConnectedServiceListFragmentDoc}
${GlobalMeFragmentDoc}
${GlobalTeamListFragmentDoc}
${GlobalTenantFragmentDoc}
${GlobalActiveConversationCountFragmentDoc}
${GlobalUnseenAgentNotificationCountFragmentDoc}
${GlobalSnippetListFragmentDoc}`;
export const OnAgentModifiedDocument = gql`
    subscription OnAgentModified {
  onAgentModified {
    ...globalAgentWithStatusList
  }
}
    ${GlobalAgentWithStatusListFragmentDoc}`;
export const OnAgentCreatedDocument = gql`
    subscription OnAgentCreated {
  onAgentCreated {
    ...globalAgentWithStatusList
  }
}
    ${GlobalAgentWithStatusListFragmentDoc}`;
export const OnTeamModifiedDocument = gql`
    subscription OnTeamModified {
  onTeamModified {
    ...globalTeamList
    deleted
  }
}
    ${GlobalTeamListFragmentDoc}`;
export const OnTeamCreatedDocument = gql`
    subscription OnTeamCreated {
  onTeamCreated {
    ...globalTeamList
  }
}
    ${GlobalTeamListFragmentDoc}`;
export const GetAgentNotificationsDocument = gql`
    query GetAgentNotifications($continuationToken: String, $take: Int!) {
  agentNotifications(continuationToken: $continuationToken, take: $take) {
    items {
      ...agentNotification
    }
    continuationToken
  }
}
    ${AgentNotificationFragmentDoc}`;
export const MarkAgentNotificationAsSeenDocument = gql`
    mutation MarkAgentNotificationAsSeen($agentNotificationId: String!) {
  modifyAgentNotification(
    input: {agentNotificationId: $agentNotificationId, seen: true}
  ) {
    agentNotification {
      ...agentNotification
    }
  }
}
    ${AgentNotificationFragmentDoc}`;
export const MarkAllAgentNotificationsAsSeenDocument = gql`
    mutation MarkAllAgentNotificationsAsSeen {
  markAllAgentNotificationsAsSeen {
    success
  }
}
    `;
export const OnAgentNotificationCreatedDocument = gql`
    subscription OnAgentNotificationCreated {
  onAgentNotificationCreated {
    ...agentNotification
  }
}
    ${AgentNotificationFragmentDoc}`;
export const OnAgentNotificationModifiedDocument = gql`
    subscription OnAgentNotificationModified {
  onAgentNotificationModified {
    ...agentNotification
  }
}
    ${AgentNotificationFragmentDoc}`;
export const GetAgentNotificationSettingsDocument = gql`
    query GetAgentNotificationSettings {
  agentNotificationSettings {
    ...agentNotificationSetting
  }
}
    ${AgentNotificationSettingFragmentDoc}`;
export const ModifyAgentNotificationSettingsDocument = gql`
    mutation ModifyAgentNotificationSettings($input: ModifyAgentNotificationSettingsInput!) {
  modifyAgentNotificationSettings(input: $input) {
    settings {
      ...agentNotificationSetting
    }
  }
}
    ${AgentNotificationSettingFragmentDoc}`;
export const OnAgentNotificationSeenModifiedDocument = gql`
    subscription OnAgentNotificationSeenModified {
  onAgentNotificationSeenModified {
    fromSeen
    toSeen
  }
}
    `;
export const SetAgentAwayStatusDocument = gql`
    mutation SetAgentAwayStatus($input: SetAgentAwayStatusInput!) {
  setAgentAwayStatus(input: $input) {
    agent {
      id
      away
      awayFromPhone
    }
    errors {
      __typename
      ... on AgentNotAuthorizedError {
        message
        code
      }
      ... on AgentNotFoundError {
        message
        code
      }
    }
  }
}
    `;
export const AgentPingDocument = gql`
    subscription AgentPing {
  onAgentPing {
    __typename
  }
}
    `;
export const GetAppEventsDocument = gql`
    query GetAppEvents($take: Int!, $filter: GetAppEventsFilterInput!) {
  appEvents(take: $take, filter: $filter) {
    ...appEvent
  }
}
    ${AppEventFragmentDoc}`;
export const OnAgentTypingInConversationByTenantIdDocument = gql`
    subscription OnAgentTypingInConversationByTenantId {
  onAgentTypingInConversationByTenantId {
    conversationId
    typingId
    sequence
    content
    isFullContent
    agentId
  }
}
    `;
export const OnAgentStoppedTypingInConversationByTenantIdDocument = gql`
    subscription OnAgentStoppedTypingInConversationByTenantId {
  onAgentStoppedTypingInConversationByTenantId {
    conversationId
    typingId
    agentId
  }
}
    `;
export const OnContactTypingInConversationByTenantIdDocument = gql`
    subscription OnContactTypingInConversationByTenantId {
  onContactTypingInConversationByTenantId {
    conversationId
    content
    contactId
    sequence
    isFullContent
  }
}
    `;
export const OnContactStoppedTypingInConversationByTenantIdDocument = gql`
    subscription OnContactStoppedTypingInConversationByTenantId {
  onContactStoppedTypingInConversationByTenantId {
    conversationId
    contactId
  }
}
    `;
export const OnAgentWatchingConversationByTenantIdDocument = gql`
    subscription OnAgentWatchingConversationByTenantId {
  onAgentWatchingConversationByTenantId {
    conversationId
    agentId
  }
}
    `;
export const OnAgentStoppedWatchingConversationByTenantIdDocument = gql`
    subscription OnAgentStoppedWatchingConversationByTenantId {
  onAgentStoppedWatchingConversationByTenantId {
    conversationId
    agentId
  }
}
    `;
export const OnAppEventCreatedByTenantIdDocument = gql`
    subscription OnAppEventCreatedByTenantId {
  onAppEventCreated {
    ...appEvent
  }
}
    ${AppEventFragmentDoc}`;
export const CreateContactDocument = gql`
    mutation CreateContact($input: CreateContactInput!) {
  createContact(input: $input) {
    contact {
      ...contactEntity
    }
    errors {
      ... on ContactAddressConflictError {
        code
        message
        conflicts {
          type
          address
        }
      }
      ... on UserError {
        ...userError
      }
    }
  }
}
    ${ContactEntityFragmentDoc}
${UserErrorFragmentDoc}`;
export const GetContactByIdDocument = gql`
    query GetContactById($id: String!) {
  contactById(id: $id) {
    ...contactEntity
  }
}
    ${ContactEntityFragmentDoc}`;
export const GetContactConversationsDocument = gql`
    query GetContactConversations($take: Int!, $continuationToken: String, $contactId: String!, $includeTotalCount: Boolean!) {
  contactConversations(
    take: $take
    continuationToken: $continuationToken
    contactId: $contactId
    includeTotalCount: $includeTotalCount
  ) {
    items {
      ...conversations
    }
    continuationToken
    totalCount
  }
}
    ${ConversationsFragmentDoc}`;
export const CreateConversationSnippetDocument = gql`
    mutation CreateConversationSnippet($input: CreateConversationSnippetInput!) {
  createConversationSnippet(input: $input) {
    snippet {
      ...conversationSnippet
    }
  }
}
    ${ConversationSnippetFragmentDoc}`;
export const ModifyConversationSnippetDocument = gql`
    mutation ModifyConversationSnippet($input: ModifyConversationSnippetInput!) {
  modifyConversationSnippet(input: $input) {
    snippet {
      ...conversationSnippet
    }
    errors {
      __typename
    }
  }
}
    ${ConversationSnippetFragmentDoc}`;
export const DeleteConversationSnippetDocument = gql`
    mutation DeleteConversationSnippet($input: DeleteConversationSnippetInput!) {
  deleteConversationSnippet(input: $input) {
    snippet {
      ...conversationSnippet
    }
    errors {
      __typename
    }
  }
}
    ${ConversationSnippetFragmentDoc}`;
export const GetConversationSnippetsDocument = gql`
    query GetConversationSnippets($take: Int!, $continuationToken: String) {
  conversationSnippets(take: $take, continuationToken: $continuationToken) {
    items {
      ...conversationSnippet
    }
    continuationToken
  }
}
    ${ConversationSnippetFragmentDoc}`;
export const GetSnippetByIdDocument = gql`
    query GetSnippetById($id: String!) {
  conversationSnippetById(id: $id) {
    ...conversationSnippet
  }
}
    ${ConversationSnippetFragmentDoc}`;
export const OnActiveConversationCountConversationStatusModifiedDocument = gql`
    subscription OnActiveConversationCountConversationStatusModified {
  onMultiTenantConversationStatusModified {
    tenantId
    fromStatus
    toStatus
    fromAssignedAgentId
    toAssignedAgentId
    fromAssignedTeamId
    toAssignedTeamId
  }
}
    `;
export const OnActiveConversationCountConversationCreatedDocument = gql`
    subscription OnActiveConversationCountConversationCreated {
  onMultiTenantConversationCreated {
    tenantId
    status
    assignee {
      id
    }
    team {
      id
    }
  }
}
    `;
export const CreateConversationAgentCommentDocument = gql`
    mutation CreateConversationAgentComment($conversationId: String!, $content: String!, $attachments: [String!]!, $linkedToTimelineId: String) {
  createConversationAgentComment(
    input: {conversationId: $conversationId, content: $content, linkedToTimelineId: $linkedToTimelineId, attachments: $attachments}
  ) {
    conversationTimeline {
      ...conversationTimeline
    }
    errors {
      ... on UserError {
        ...userError
      }
    }
  }
}
    ${ConversationTimelineFragmentDoc}
${UserErrorFragmentDoc}`;
export const CreateConversationAgentMessageDocument = gql`
    mutation CreateConversationAgentMessage($conversationId: String!, $content: String!, $attachments: [String!]!, $linkedToTimelineId: String) {
  createConversationAgentMessage(
    input: {conversationId: $conversationId, content: $content, attachments: $attachments, linkedToTimelineId: $linkedToTimelineId}
  ) {
    conversationTimeline {
      ...conversationTimeline
    }
    errors {
      ... on UserError {
        ...userError
      }
    }
  }
}
    ${ConversationTimelineFragmentDoc}
${UserErrorFragmentDoc}`;
export const AgentIsTypingInConversationDocument = gql`
    mutation AgentIsTypingInConversation($input: AgentTypingInConversationInput!) {
  agentTypingInConversation(input: $input) {
    typingId
    accessKey
    errors {
      ... on UserError {
        ...userError
      }
    }
  }
}
    ${UserErrorFragmentDoc}`;
export const AgentStoppedTypingInConversationDocument = gql`
    mutation AgentStoppedTypingInConversation($input: AgentStoppedTypingInConversationInput!) {
  agentStoppedTypingInConversation(input: $input) {
    typingId
    errors {
      ... on UserError {
        ...userError
      }
    }
  }
}
    ${UserErrorFragmentDoc}`;
export const ModifyConversationBotAssistantModeDocument = gql`
    mutation ModifyConversationBotAssistantMode($conversationId: String!, $mode: ConversationBotAssistantModeItem!) {
  modifyConversation(
    input: {conversationId: $conversationId, botAssistantMode: $mode}
  ) {
    conversation {
      ...conversations
    }
    events {
      ...conversationTimeline
    }
    errors {
      ... on UserError {
        ...userError
      }
    }
  }
}
    ${ConversationsFragmentDoc}
${ConversationTimelineFragmentDoc}
${UserErrorFragmentDoc}`;
export const ModifyConversationAssignDocument = gql`
    mutation ModifyConversationAssign($conversationId: String!, $assignToTeamId: String, $assignToAgentId: String) {
  modifyConversation(
    input: {conversationId: $conversationId, assignToAgentId: $assignToAgentId, teamId: $assignToTeamId}
  ) {
    conversation {
      ...conversations
    }
    events {
      ...conversationTimeline
    }
    errors {
      ... on UserError {
        ...userError
      }
    }
  }
}
    ${ConversationsFragmentDoc}
${ConversationTimelineFragmentDoc}
${UserErrorFragmentDoc}`;
export const CreateConversationDocument = gql`
    mutation CreateConversation($input: CreateConversationInput!) {
  createConversation(input: $input) {
    conversation {
      ...conversations
    }
    errors {
      ... on UserError {
        ...userError
      }
    }
  }
}
    ${ConversationsFragmentDoc}
${UserErrorFragmentDoc}`;
export const ConversationByIdDocument = gql`
    query ConversationById($id: String!, $take: Int!) {
  conversationById(id: $id) {
    ...conversationById
  }
}
    ${ConversationByIdFragmentDoc}`;
export const ConversationByIdLoadMoreDocument = gql`
    query ConversationByIdLoadMore($id: String!, $take: Int!, $continuationToken: String) {
  conversationById(id: $id) {
    timeline(continuationToken: $continuationToken, take: $take) {
      items {
        ...conversationTimeline
      }
      continuationToken
    }
  }
}
    ${ConversationTimelineFragmentDoc}`;
export const ModifyConversationStatusDocument = gql`
    mutation ModifyConversationStatus($conversationId: String!, $status: ConversationStatusItem) {
  modifyConversation(input: {conversationId: $conversationId, status: $status}) {
    conversation {
      ...conversations
    }
    events {
      ...conversationTimeline
    }
    errors {
      ... on UserError {
        ...userError
      }
    }
  }
}
    ${ConversationsFragmentDoc}
${ConversationTimelineFragmentDoc}
${UserErrorFragmentDoc}`;
export const AgentWatchConversationDocument = gql`
    mutation AgentWatchConversation($conversationId: String!) {
  agentWatchConversation(input: {conversationId: $conversationId}) {
    success
  }
}
    `;
export const AgentStopWatchConversationDocument = gql`
    mutation AgentStopWatchConversation($conversationId: String!) {
  agentStopWatchConversation(input: {conversationId: $conversationId}) {
    success
  }
}
    `;
export const CreateConversationSummaryDocument = gql`
    mutation CreateConversationSummary($conversationId: String!) {
  createConversationSummary(input: {conversationId: $conversationId}) {
    summary {
      ...conversationTimeline
    }
    errors {
      ... on UserError {
        message
        code
      }
    }
  }
}
    ${ConversationTimelineFragmentDoc}`;
export const OnConversationTimelineCreatedDocument = gql`
    subscription OnConversationTimelineCreated($conversationId: String!) {
  onConversationTimelineCreated(conversationId: $conversationId) {
    ...conversationTimeline
  }
}
    ${ConversationTimelineFragmentDoc}`;
export const OnConversationTimelineModifiedDocument = gql`
    subscription OnConversationTimelineModified($conversationId: String!) {
  onConversationTimelineModified(conversationId: $conversationId) {
    ...conversationTimeline
  }
}
    ${ConversationTimelineFragmentDoc}`;
export const OnAgentTypingInConversationByIdDocument = gql`
    subscription OnAgentTypingInConversationById($conversationId: String!) {
  onAgentTypingInConversationById(conversationId: $conversationId) {
    conversationId
    typingId
    sequence
    content
    isFullContent
    agentId
  }
}
    `;
export const OnAgentStoppedTypingInConversationByIdDocument = gql`
    subscription OnAgentStoppedTypingInConversationById($conversationId: String!) {
  onAgentStoppedTypingInConversationById(conversationId: $conversationId) {
    conversationId
    typingId
    agentId
  }
}
    `;
export const OnContactTypingInConversationByIdDocument = gql`
    subscription OnContactTypingInConversationById($conversationId: String!) {
  onContactTypingInConversationById(conversationId: $conversationId) {
    conversationId
    contactId
    sequence
    content
    isFullContent
  }
}
    `;
export const OnContactStoppedTypingInConversationByIdDocument = gql`
    subscription OnContactStoppedTypingInConversationById($conversationId: String!) {
  onContactStoppedTypingInConversationById(conversationId: $conversationId) {
    conversationId
    contactId
  }
}
    `;
export const GetConversationsDocument = gql`
    query GetConversations($take: Int!, $continuationToken: String, $filter: GetAgentConversationsFilterInput!, $includeTotalCount: Boolean!) {
  conversations(
    take: $take
    continuationToken: $continuationToken
    filter: $filter
    includeTotalCount: $includeTotalCount
  ) {
    items {
      ...conversations
    }
    continuationToken
    totalCount
  }
}
    ${ConversationsFragmentDoc}`;
export const GetConversationsLoadMoreDocument = gql`
    query GetConversationsLoadMore($take: Int!, $continuationToken: String, $filter: GetAgentConversationsFilterInput!) {
  conversations(
    take: $take
    continuationToken: $continuationToken
    filter: $filter
  ) {
    items {
      ...conversations
    }
    continuationToken
  }
}
    ${ConversationsFragmentDoc}`;
export const ModifyConversationDocument = gql`
    mutation ModifyConversation($input: ModifyConversationInput!) {
  modifyConversation(input: $input) {
    conversation {
      ...conversations
    }
    errors {
      ... on UserError {
        ...userError
      }
    }
  }
}
    ${ConversationsFragmentDoc}
${UserErrorFragmentDoc}`;
export const CreateDemoConversationsDocument = gql`
    mutation CreateDemoConversations {
  createDemoConversations {
    conversations {
      ...conversations
    }
  }
}
    ${ConversationsFragmentDoc}`;
export const OnConversationCreatedDocument = gql`
    subscription OnConversationCreated {
  onConversationCreated {
    ...conversations
  }
}
    ${ConversationsFragmentDoc}`;
export const OnConversationModifiedDocument = gql`
    subscription OnConversationModified {
  onConversationModified {
    ...conversations
  }
}
    ${ConversationsFragmentDoc}`;
export const ModifyConversationSnoozeDocument = gql`
    mutation ModifyConversationSnooze($conversationId: String!, $remindAt: String!, $remindAtTimeZone: String!) {
  modifyConversation(
    input: {conversationId: $conversationId, status: SNOOZED, remindAt: $remindAt, remindAtTimeZone: $remindAtTimeZone}
  ) {
    conversation {
      ...conversations
    }
    events {
      ...conversationTimeline
    }
    errors {
      ... on UserError {
        ...userError
      }
    }
  }
}
    ${ConversationsFragmentDoc}
${ConversationTimelineFragmentDoc}
${UserErrorFragmentDoc}`;
export const TransferConversationOptionsDocument = gql`
    query TransferConversationOptions($conversationId: String!) {
  conversationTransferOptions(id: $conversationId) {
    options {
      channel
      connectedServiceId
      addressOptions {
        id
        address
        addressType
      }
    }
  }
}
    `;
export const CreateContactAddressDocument = gql`
    mutation CreateContactAddress($input: CreateAddressInput!) {
  createContactAddress(input: $input) {
    contactAddress {
      id
      address
      addressType
    }
    errors {
      __typename
      ... on ContactAddressConflictError {
        message
        conflicts {
          address
          type
          contactId
        }
        code
      }
    }
  }
}
    `;
export const GetConversationViewTeamsAndAgentsDocument = gql`
    query GetConversationViewTeamsAndAgents {
  agents: agents {
    id
    firstName
    lastName
  }
  teams: teams {
    id
    name
    emoji
  }
}
    `;
export const GetTeamsAndAgentsDocument = gql`
    query GetTeamsAndAgents {
  agents: agents {
    id
    firstName
    lastName
  }
  teams: teams {
    id
    name
    emoji
  }
}
    `;
export const CreateKnowledgeBaseArticleDocument = gql`
    mutation CreateKnowledgeBaseArticle($title: String!, $solution: String!, $audience: KnowledgeBaseArticleAudienceItem!, $draft: Boolean!, $questions: [String!]!) {
  createKnowledgeBaseArticle(
    input: {title: $title, solution: $solution, draft: $draft, audience: $audience, questions: $questions}
  ) {
    knowledgeBaseArticle {
      id
    }
  }
}
    `;
export const GetKnowledgeBaseArticleDisplayByIdDocument = gql`
    query GetKnowledgeBaseArticleDisplayById($id: String!) {
  knowledgeBaseArticleById(id: $id) {
    ...knowledgeBaseArticleDisplay
  }
}
    ${KnowledgeBaseArticleDisplayFragmentDoc}`;
export const GetKnowledgeBaseArticlesDocument = gql`
    query GetKnowledgeBaseArticles($take: Int, $continuationToken: String, $statusFilter: [KnowledgeBaseArticleStatusItem!]) {
  knowledgeBaseArticles(
    continuationToken: $continuationToken
    take: $take
    statusFilter: $statusFilter
  ) {
    items {
      ...knowledgeBaseArticles
    }
    continuationToken
  }
}
    ${KnowledgeBaseArticlesFragmentDoc}`;
export const GetKnowledgeBaseArticleModifyByIdDocument = gql`
    query GetKnowledgeBaseArticleModifyById($id: String!) {
  knowledgeBaseArticleById(id: $id) {
    ...knowledgeBaseArticleModify
  }
}
    ${KnowledgeBaseArticleModifyFragmentDoc}`;
export const GetKnowledgeBaseTenantSettingsDocument = gql`
    query GetKnowledgeBaseTenantSettings {
  knowledgeBaseTenantSettings {
    ...knowledgeBaseTenantSettings
  }
}
    ${KnowledgeBaseTenantSettingsFragmentDoc}`;
export const ModifyKnowledgeBaseTenantSettingsDocument = gql`
    mutation ModifyKnowledgeBaseTenantSettings($input: ModifyKnowledgeBaseTenantSettingsInput!) {
  modifyKnowledgeBaseTenantSettings(input: $input) {
    settings {
      ...knowledgeBaseTenantSettings
    }
    errors {
      __typename
    }
  }
}
    ${KnowledgeBaseTenantSettingsFragmentDoc}`;
export const ModifyKnowledgeBaseArticleDocument = gql`
    mutation ModifyKnowledgeBaseArticle($input: ModifyKnowledgeBaseArticleInput!) {
  modifyKnowledgeBaseArticle(input: $input) {
    knowledgeBaseArticle {
      ...knowledgeBaseArticleModify
    }
    errors {
      __typename
      ... on KnowledgeBaseArticleIsPublishingError {
        code
        message
      }
    }
  }
}
    ${KnowledgeBaseArticleModifyFragmentDoc}`;
export const CreateKnowledgeBaseArticleSuggestionsFromConversationDocument = gql`
    mutation CreateKnowledgeBaseArticleSuggestionsFromConversation($input: CreateKnowledgeBaseArticleSuggestionsFromConversationInput!) {
  createKnowledgeBaseArticleSuggestionsFromConversation(input: $input) {
    articles {
      id
      title
    }
  }
}
    `;
export const DeleteKnowledgeBaseArticleDocument = gql`
    mutation DeleteKnowledgeBaseArticle($input: DeleteKnowledgeBaseArticleInput!) {
  deleteKnowledgeBaseArticle(input: $input) {
    article {
      ...knowledgeBaseArticleModify
    }
    errors {
      __typename
      ... on UserError {
        message
        code
      }
    }
  }
}
    ${KnowledgeBaseArticleModifyFragmentDoc}`;
export const OnKnowledgeBaseArticleModifiedDocument = gql`
    subscription OnKnowledgeBaseArticleModified($id: String!) {
  onKnowledgeBaseArticleModified(id: $id) {
    ...knowledgeBaseArticleModify
  }
}
    ${KnowledgeBaseArticleModifyFragmentDoc}`;
export const CreateAgentPushSubscriptionDocument = gql`
    mutation CreateAgentPushSubscription($input: CreateAgentPushSubscriptionInput!) {
  createAgentPushSubscription(input: $input) {
    success
  }
}
    `;
export const ConversationTimelineSearchDocument = gql`
    query ConversationTimelineSearch($query: String!, $take: Int, $skip: Int) {
  searchConversationTimeline(query: $query, take: $take, skip: $skip) {
    results {
      document {
        id
        textPlain
        conversationId
      }
      highlights {
        key
        value
      }
      score
    }
    totalResults
  }
}
    `;
export const ConversationSearchDocument = gql`
    query ConversationSearch($query: String!, $take: Int, $skip: Int) {
  searchConversation(query: $query, take: $take, skip: $skip) {
    results {
      document {
        id
        description
        contact {
          id
          firstName
          lastName
        }
        teamId
        tags
      }
      highlights {
        key
        value
      }
      score
    }
    totalResults
  }
}
    `;
export const ContactSearchDocument = gql`
    query ContactSearch($query: String!, $take: Int, $skip: Int) {
  searchContact(query: $query, take: $take, skip: $skip) {
    results {
      document {
        id
        firstName
        lastName
        addresses {
          id
          address
          addressType
        }
        tags
      }
      highlights {
        key
        value
      }
      score
    }
    totalResults
  }
}
    `;
export const KnowledgeBaseSearchDocument = gql`
    query KnowledgeBaseSearch($query: String!, $take: Int, $skip: Int) {
  searchKnowledgeBase(query: $query, take: $take, skip: $skip) {
    results {
      document {
        id
        status
        audience
        title
        solution
      }
      highlights {
        key
        value
      }
      score
    }
    totalResults
  }
}
    `;
export const AgentCreateDocument = gql`
    mutation AgentCreate($firstName: String!, $lastName: String!, $email: String!, $role: TenantRoleItem!, $teamIds: [String!]!) {
  createAgent(
    input: {firstName: $firstName, lastName: $lastName, email: $email, role: $role, teamIds: $teamIds}
  ) {
    agent {
      id
      firstName
      lastName
    }
  }
}
    `;
export const AgentListDocument = gql`
    query AgentList($filter: GetAgentsFilterInput!) {
  agents(filter: $filter) {
    id
    email
    name
    firstName
    lastName
    away
    awayFromPhone
    workerId
    idle
    perTenant {
      role
      status
      teams {
        id
        name
        emoji
      }
    }
  }
}
    `;
export const AgentDeleteDocument = gql`
    mutation AgentDelete($input: DeleteAgentInput!) {
  deleteAgent(input: $input) {
    agent {
      id
    }
  }
}
    `;
export const AgentByIdDocument = gql`
    query AgentById($id: String!) {
  agentById(id: $id) {
    id
    email
    name
    firstName
    lastName
    away
    awayFromPhone
    locale
    workerId
    idle
    perTenant {
      role
      status
      teams {
        id
        name
        emoji
      }
    }
  }
}
    `;
export const ModifyAgentDocument = gql`
    mutation ModifyAgent($input: ModifyAgentInput!) {
  modifyAgent(input: $input) {
    agent {
      id
      away
      awayFromPhone
      settings {
        autoAdvance {
          action
        }
      }
    }
    errors {
      __typename
      ... on AgentNotAuthorizedError {
        message
        code
      }
      ... on AgentNotFoundError {
        message
        code
      }
    }
  }
}
    `;
export const GetBotAssistantTenantSettingsDocument = gql`
    query GetBotAssistantTenantSettings {
  botAssistantTenantSettings {
    ...botAssistantTenantSettings
  }
}
    ${BotAssistantTenantSettingsFragmentDoc}`;
export const ModifyBotAssistantTenantSettingsDocument = gql`
    mutation ModifyBotAssistantTenantSettings($input: ModifyBotAssistantTenantSettingsInput!) {
  modifyBotAssistantTenantSettings(input: $input) {
    settings {
      ...botAssistantTenantSettings
    }
    errors {
      __typename
    }
  }
}
    ${BotAssistantTenantSettingsFragmentDoc}`;
export const ChatChannelListDocument = gql`
    query ChatChannelList {
  chatChannels {
    ...chatChannelData
  }
}
    ${ChatChannelDataFragmentDoc}`;
export const ChatChannelByIdDocument = gql`
    query ChatChannelById($id: String!) {
  chatChannelById(id: $id) {
    ...chatChannelData
  }
}
    ${ChatChannelDataFragmentDoc}`;
export const CreateChatChannelDocument = gql`
    mutation CreateChatChannel($input: CreateChatChannelInput!) {
  createChatChannel(input: $input) {
    channel {
      ...chatChannelData
    }
  }
}
    ${ChatChannelDataFragmentDoc}`;
export const ModifyChatChannelDocument = gql`
    mutation ModifyChatChannel($input: ModifyChatChannelInput!) {
  modifyChatChannel(input: $input) {
    channel {
      ...chatChannelData
    }
  }
}
    ${ChatChannelDataFragmentDoc}`;
export const CreateEmailChannelDocument = gql`
    mutation CreateEmailChannel($input: CreateEmailChannelInput!) {
  createEmailChannel(input: $input) {
    channel {
      ...emailChannelItem
    }
  }
}
    ${EmailChannelItemFragmentDoc}`;
export const EmailChannelListDocument = gql`
    query EmailChannelList {
  emailChannels {
    ...emailChannelItem
  }
}
    ${EmailChannelItemFragmentDoc}`;
export const MessengerChannelListDocument = gql`
    query MessengerChannelList {
  messengerChannels {
    ...messengerChannelItem
  }
}
    ${MessengerChannelItemFragmentDoc}`;
export const MessengerPageOptionsListDocument = gql`
    query MessengerPageOptionsList($accessToken: String!) {
  facebookPageOptions(accessToken: $accessToken) {
    pageId
    pageName
  }
}
    `;
export const CreateMessengerChannelDocument = gql`
    mutation CreateMessengerChannel($input: CreateMessengerChannelInput!) {
  createMessengerChannel(input: $input) {
    channel {
      ...messengerChannelItem
    }
  }
}
    ${MessengerChannelItemFragmentDoc}`;
export const DeleteMessengerChannelDocument = gql`
    mutation DeleteMessengerChannel($input: DeleteMessengerChannelInput!) {
  deleteMessengerChannel(input: $input) {
    channel {
      ...messengerChannelItem
    }
  }
}
    ${MessengerChannelItemFragmentDoc}`;
export const SmsChannelListDocument = gql`
    query SmsChannelList {
  smsSubNumberChannels {
    ...smsSubNumberChannel
  }
  smsVonageChannels {
    ...vonageChannel
  }
}
    ${SmsSubNumberChannelFragmentDoc}
${VonageChannelFragmentDoc}`;
export const CreateSmsSubNumberChannelDocument = gql`
    mutation CreateSmsSubNumberChannel($input: CreateSmsSubNumberChannelInput!) {
  createSmsSubNumberChannel(input: $input) {
    channel {
      ...smsSubNumberChannel
    }
  }
}
    ${SmsSubNumberChannelFragmentDoc}`;
export const CreateSmsVonageChannelDocument = gql`
    mutation CreateSmsVonageChannel($input: CreateSmsVonageChannelInput!) {
  createSmsVonageChannel(input: $input) {
    channel {
      ...vonageChannel
    }
  }
}
    ${VonageChannelFragmentDoc}`;
export const CreateTeamDocument = gql`
    mutation CreateTeam($input: CreateTeamInput!) {
  createTeam(input: $input) {
    team {
      id
      name
    }
  }
}
    `;
export const DeleteTeamDocument = gql`
    mutation DeleteTeam($input: DeleteTeamInput!) {
  deleteTeam(input: $input) {
    team {
      id
    }
  }
}
    `;
export const GetTeamByIdDocument = gql`
    query GetTeamById($id: String!) {
  teamById(id: $id) {
    id
    name
    emoji
    agents {
      id
    }
  }
}
    `;
export const ModifyTeamDocument = gql`
    mutation ModifyTeam($input: ModifyTeamInput!) {
  modifyTeam(input: $input) {
    team {
      id
      name
      emoji
    }
  }
}
    `;
export const TranslateTextWithHtmlDocument = gql`
    mutation TranslateTextWithHtml($text: String!, $language: String!) {
  translateTextWithHtml(input: {text: $text, language: $language}) {
    translation
  }
}
    `;
export const FixGrammarTextWithHtmlDocument = gql`
    mutation FixGrammarTextWithHtml($text: String!) {
  fixGrammarTextWithHtml(input: {text: $text}) {
    text
  }
}
    `;
export const ImproveTextWithHtmlDocument = gql`
    mutation ImproveTextWithHtml($text: String!) {
  improveTextWithHtml(input: {text: $text}) {
    text
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    AppInitQuery(variables?: GAppInitQueryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GAppInitQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GAppInitQueryQuery>(AppInitQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AppInitQuery', 'query');
    },
    OnAgentModified(variables?: GOnAgentModifiedSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnAgentModifiedSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnAgentModifiedSubscription>(OnAgentModifiedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnAgentModified', 'subscription');
    },
    OnAgentCreated(variables?: GOnAgentCreatedSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnAgentCreatedSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnAgentCreatedSubscription>(OnAgentCreatedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnAgentCreated', 'subscription');
    },
    OnTeamModified(variables?: GOnTeamModifiedSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnTeamModifiedSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnTeamModifiedSubscription>(OnTeamModifiedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnTeamModified', 'subscription');
    },
    OnTeamCreated(variables?: GOnTeamCreatedSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnTeamCreatedSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnTeamCreatedSubscription>(OnTeamCreatedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnTeamCreated', 'subscription');
    },
    GetAgentNotifications(variables: GGetAgentNotificationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GGetAgentNotificationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GGetAgentNotificationsQuery>(GetAgentNotificationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetAgentNotifications', 'query');
    },
    MarkAgentNotificationAsSeen(variables: GMarkAgentNotificationAsSeenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GMarkAgentNotificationAsSeenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GMarkAgentNotificationAsSeenMutation>(MarkAgentNotificationAsSeenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MarkAgentNotificationAsSeen', 'mutation');
    },
    MarkAllAgentNotificationsAsSeen(variables?: GMarkAllAgentNotificationsAsSeenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GMarkAllAgentNotificationsAsSeenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GMarkAllAgentNotificationsAsSeenMutation>(MarkAllAgentNotificationsAsSeenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MarkAllAgentNotificationsAsSeen', 'mutation');
    },
    OnAgentNotificationCreated(variables?: GOnAgentNotificationCreatedSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnAgentNotificationCreatedSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnAgentNotificationCreatedSubscription>(OnAgentNotificationCreatedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnAgentNotificationCreated', 'subscription');
    },
    OnAgentNotificationModified(variables?: GOnAgentNotificationModifiedSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnAgentNotificationModifiedSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnAgentNotificationModifiedSubscription>(OnAgentNotificationModifiedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnAgentNotificationModified', 'subscription');
    },
    GetAgentNotificationSettings(variables?: GGetAgentNotificationSettingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GGetAgentNotificationSettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GGetAgentNotificationSettingsQuery>(GetAgentNotificationSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetAgentNotificationSettings', 'query');
    },
    ModifyAgentNotificationSettings(variables: GModifyAgentNotificationSettingsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GModifyAgentNotificationSettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GModifyAgentNotificationSettingsMutation>(ModifyAgentNotificationSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ModifyAgentNotificationSettings', 'mutation');
    },
    OnAgentNotificationSeenModified(variables?: GOnAgentNotificationSeenModifiedSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnAgentNotificationSeenModifiedSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnAgentNotificationSeenModifiedSubscription>(OnAgentNotificationSeenModifiedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnAgentNotificationSeenModified', 'subscription');
    },
    SetAgentAwayStatus(variables: GSetAgentAwayStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GSetAgentAwayStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GSetAgentAwayStatusMutation>(SetAgentAwayStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SetAgentAwayStatus', 'mutation');
    },
    AgentPing(variables?: GAgentPingSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GAgentPingSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GAgentPingSubscription>(AgentPingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AgentPing', 'subscription');
    },
    GetAppEvents(variables: GGetAppEventsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GGetAppEventsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GGetAppEventsQuery>(GetAppEventsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetAppEvents', 'query');
    },
    OnAgentTypingInConversationByTenantId(variables?: GOnAgentTypingInConversationByTenantIdSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnAgentTypingInConversationByTenantIdSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnAgentTypingInConversationByTenantIdSubscription>(OnAgentTypingInConversationByTenantIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnAgentTypingInConversationByTenantId', 'subscription');
    },
    OnAgentStoppedTypingInConversationByTenantId(variables?: GOnAgentStoppedTypingInConversationByTenantIdSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnAgentStoppedTypingInConversationByTenantIdSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnAgentStoppedTypingInConversationByTenantIdSubscription>(OnAgentStoppedTypingInConversationByTenantIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnAgentStoppedTypingInConversationByTenantId', 'subscription');
    },
    OnContactTypingInConversationByTenantId(variables?: GOnContactTypingInConversationByTenantIdSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnContactTypingInConversationByTenantIdSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnContactTypingInConversationByTenantIdSubscription>(OnContactTypingInConversationByTenantIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnContactTypingInConversationByTenantId', 'subscription');
    },
    OnContactStoppedTypingInConversationByTenantId(variables?: GOnContactStoppedTypingInConversationByTenantIdSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnContactStoppedTypingInConversationByTenantIdSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnContactStoppedTypingInConversationByTenantIdSubscription>(OnContactStoppedTypingInConversationByTenantIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnContactStoppedTypingInConversationByTenantId', 'subscription');
    },
    OnAgentWatchingConversationByTenantId(variables?: GOnAgentWatchingConversationByTenantIdSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnAgentWatchingConversationByTenantIdSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnAgentWatchingConversationByTenantIdSubscription>(OnAgentWatchingConversationByTenantIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnAgentWatchingConversationByTenantId', 'subscription');
    },
    OnAgentStoppedWatchingConversationByTenantId(variables?: GOnAgentStoppedWatchingConversationByTenantIdSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnAgentStoppedWatchingConversationByTenantIdSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnAgentStoppedWatchingConversationByTenantIdSubscription>(OnAgentStoppedWatchingConversationByTenantIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnAgentStoppedWatchingConversationByTenantId', 'subscription');
    },
    OnAppEventCreatedByTenantId(variables?: GOnAppEventCreatedByTenantIdSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnAppEventCreatedByTenantIdSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnAppEventCreatedByTenantIdSubscription>(OnAppEventCreatedByTenantIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnAppEventCreatedByTenantId', 'subscription');
    },
    CreateContact(variables: GCreateContactMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GCreateContactMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GCreateContactMutation>(CreateContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateContact', 'mutation');
    },
    GetContactById(variables: GGetContactByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GGetContactByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GGetContactByIdQuery>(GetContactByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetContactById', 'query');
    },
    GetContactConversations(variables: GGetContactConversationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GGetContactConversationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GGetContactConversationsQuery>(GetContactConversationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetContactConversations', 'query');
    },
    CreateConversationSnippet(variables: GCreateConversationSnippetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GCreateConversationSnippetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GCreateConversationSnippetMutation>(CreateConversationSnippetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateConversationSnippet', 'mutation');
    },
    ModifyConversationSnippet(variables: GModifyConversationSnippetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GModifyConversationSnippetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GModifyConversationSnippetMutation>(ModifyConversationSnippetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ModifyConversationSnippet', 'mutation');
    },
    DeleteConversationSnippet(variables: GDeleteConversationSnippetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GDeleteConversationSnippetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GDeleteConversationSnippetMutation>(DeleteConversationSnippetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteConversationSnippet', 'mutation');
    },
    GetConversationSnippets(variables: GGetConversationSnippetsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GGetConversationSnippetsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GGetConversationSnippetsQuery>(GetConversationSnippetsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetConversationSnippets', 'query');
    },
    GetSnippetById(variables: GGetSnippetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GGetSnippetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GGetSnippetByIdQuery>(GetSnippetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSnippetById', 'query');
    },
    OnActiveConversationCountConversationStatusModified(variables?: GOnActiveConversationCountConversationStatusModifiedSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnActiveConversationCountConversationStatusModifiedSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnActiveConversationCountConversationStatusModifiedSubscription>(OnActiveConversationCountConversationStatusModifiedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnActiveConversationCountConversationStatusModified', 'subscription');
    },
    OnActiveConversationCountConversationCreated(variables?: GOnActiveConversationCountConversationCreatedSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnActiveConversationCountConversationCreatedSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnActiveConversationCountConversationCreatedSubscription>(OnActiveConversationCountConversationCreatedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnActiveConversationCountConversationCreated', 'subscription');
    },
    CreateConversationAgentComment(variables: GCreateConversationAgentCommentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GCreateConversationAgentCommentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GCreateConversationAgentCommentMutation>(CreateConversationAgentCommentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateConversationAgentComment', 'mutation');
    },
    CreateConversationAgentMessage(variables: GCreateConversationAgentMessageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GCreateConversationAgentMessageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GCreateConversationAgentMessageMutation>(CreateConversationAgentMessageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateConversationAgentMessage', 'mutation');
    },
    AgentIsTypingInConversation(variables: GAgentIsTypingInConversationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GAgentIsTypingInConversationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GAgentIsTypingInConversationMutation>(AgentIsTypingInConversationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AgentIsTypingInConversation', 'mutation');
    },
    AgentStoppedTypingInConversation(variables: GAgentStoppedTypingInConversationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GAgentStoppedTypingInConversationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GAgentStoppedTypingInConversationMutation>(AgentStoppedTypingInConversationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AgentStoppedTypingInConversation', 'mutation');
    },
    ModifyConversationBotAssistantMode(variables: GModifyConversationBotAssistantModeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GModifyConversationBotAssistantModeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GModifyConversationBotAssistantModeMutation>(ModifyConversationBotAssistantModeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ModifyConversationBotAssistantMode', 'mutation');
    },
    ModifyConversationAssign(variables: GModifyConversationAssignMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GModifyConversationAssignMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GModifyConversationAssignMutation>(ModifyConversationAssignDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ModifyConversationAssign', 'mutation');
    },
    CreateConversation(variables: GCreateConversationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GCreateConversationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GCreateConversationMutation>(CreateConversationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateConversation', 'mutation');
    },
    ConversationById(variables: GConversationByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GConversationByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GConversationByIdQuery>(ConversationByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ConversationById', 'query');
    },
    ConversationByIdLoadMore(variables: GConversationByIdLoadMoreQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GConversationByIdLoadMoreQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GConversationByIdLoadMoreQuery>(ConversationByIdLoadMoreDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ConversationByIdLoadMore', 'query');
    },
    ModifyConversationStatus(variables: GModifyConversationStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GModifyConversationStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GModifyConversationStatusMutation>(ModifyConversationStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ModifyConversationStatus', 'mutation');
    },
    AgentWatchConversation(variables: GAgentWatchConversationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GAgentWatchConversationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GAgentWatchConversationMutation>(AgentWatchConversationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AgentWatchConversation', 'mutation');
    },
    AgentStopWatchConversation(variables: GAgentStopWatchConversationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GAgentStopWatchConversationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GAgentStopWatchConversationMutation>(AgentStopWatchConversationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AgentStopWatchConversation', 'mutation');
    },
    CreateConversationSummary(variables: GCreateConversationSummaryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GCreateConversationSummaryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GCreateConversationSummaryMutation>(CreateConversationSummaryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateConversationSummary', 'mutation');
    },
    OnConversationTimelineCreated(variables: GOnConversationTimelineCreatedSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnConversationTimelineCreatedSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnConversationTimelineCreatedSubscription>(OnConversationTimelineCreatedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnConversationTimelineCreated', 'subscription');
    },
    OnConversationTimelineModified(variables: GOnConversationTimelineModifiedSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnConversationTimelineModifiedSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnConversationTimelineModifiedSubscription>(OnConversationTimelineModifiedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnConversationTimelineModified', 'subscription');
    },
    OnAgentTypingInConversationById(variables: GOnAgentTypingInConversationByIdSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnAgentTypingInConversationByIdSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnAgentTypingInConversationByIdSubscription>(OnAgentTypingInConversationByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnAgentTypingInConversationById', 'subscription');
    },
    OnAgentStoppedTypingInConversationById(variables: GOnAgentStoppedTypingInConversationByIdSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnAgentStoppedTypingInConversationByIdSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnAgentStoppedTypingInConversationByIdSubscription>(OnAgentStoppedTypingInConversationByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnAgentStoppedTypingInConversationById', 'subscription');
    },
    OnContactTypingInConversationById(variables: GOnContactTypingInConversationByIdSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnContactTypingInConversationByIdSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnContactTypingInConversationByIdSubscription>(OnContactTypingInConversationByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnContactTypingInConversationById', 'subscription');
    },
    OnContactStoppedTypingInConversationById(variables: GOnContactStoppedTypingInConversationByIdSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnContactStoppedTypingInConversationByIdSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnContactStoppedTypingInConversationByIdSubscription>(OnContactStoppedTypingInConversationByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnContactStoppedTypingInConversationById', 'subscription');
    },
    GetConversations(variables: GGetConversationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GGetConversationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GGetConversationsQuery>(GetConversationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetConversations', 'query');
    },
    GetConversationsLoadMore(variables: GGetConversationsLoadMoreQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GGetConversationsLoadMoreQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GGetConversationsLoadMoreQuery>(GetConversationsLoadMoreDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetConversationsLoadMore', 'query');
    },
    ModifyConversation(variables: GModifyConversationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GModifyConversationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GModifyConversationMutation>(ModifyConversationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ModifyConversation', 'mutation');
    },
    CreateDemoConversations(variables?: GCreateDemoConversationsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GCreateDemoConversationsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GCreateDemoConversationsMutation>(CreateDemoConversationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateDemoConversations', 'mutation');
    },
    OnConversationCreated(variables?: GOnConversationCreatedSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnConversationCreatedSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnConversationCreatedSubscription>(OnConversationCreatedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnConversationCreated', 'subscription');
    },
    OnConversationModified(variables?: GOnConversationModifiedSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnConversationModifiedSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnConversationModifiedSubscription>(OnConversationModifiedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnConversationModified', 'subscription');
    },
    ModifyConversationSnooze(variables: GModifyConversationSnoozeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GModifyConversationSnoozeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GModifyConversationSnoozeMutation>(ModifyConversationSnoozeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ModifyConversationSnooze', 'mutation');
    },
    TransferConversationOptions(variables: GTransferConversationOptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GTransferConversationOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GTransferConversationOptionsQuery>(TransferConversationOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'TransferConversationOptions', 'query');
    },
    CreateContactAddress(variables: GCreateContactAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GCreateContactAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GCreateContactAddressMutation>(CreateContactAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateContactAddress', 'mutation');
    },
    GetConversationViewTeamsAndAgents(variables?: GGetConversationViewTeamsAndAgentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GGetConversationViewTeamsAndAgentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GGetConversationViewTeamsAndAgentsQuery>(GetConversationViewTeamsAndAgentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetConversationViewTeamsAndAgents', 'query');
    },
    GetTeamsAndAgents(variables?: GGetTeamsAndAgentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GGetTeamsAndAgentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GGetTeamsAndAgentsQuery>(GetTeamsAndAgentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetTeamsAndAgents', 'query');
    },
    CreateKnowledgeBaseArticle(variables: GCreateKnowledgeBaseArticleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GCreateKnowledgeBaseArticleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GCreateKnowledgeBaseArticleMutation>(CreateKnowledgeBaseArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateKnowledgeBaseArticle', 'mutation');
    },
    GetKnowledgeBaseArticleDisplayById(variables: GGetKnowledgeBaseArticleDisplayByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GGetKnowledgeBaseArticleDisplayByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GGetKnowledgeBaseArticleDisplayByIdQuery>(GetKnowledgeBaseArticleDisplayByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetKnowledgeBaseArticleDisplayById', 'query');
    },
    GetKnowledgeBaseArticles(variables?: GGetKnowledgeBaseArticlesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GGetKnowledgeBaseArticlesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GGetKnowledgeBaseArticlesQuery>(GetKnowledgeBaseArticlesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetKnowledgeBaseArticles', 'query');
    },
    GetKnowledgeBaseArticleModifyById(variables: GGetKnowledgeBaseArticleModifyByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GGetKnowledgeBaseArticleModifyByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GGetKnowledgeBaseArticleModifyByIdQuery>(GetKnowledgeBaseArticleModifyByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetKnowledgeBaseArticleModifyById', 'query');
    },
    GetKnowledgeBaseTenantSettings(variables?: GGetKnowledgeBaseTenantSettingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GGetKnowledgeBaseTenantSettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GGetKnowledgeBaseTenantSettingsQuery>(GetKnowledgeBaseTenantSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetKnowledgeBaseTenantSettings', 'query');
    },
    ModifyKnowledgeBaseTenantSettings(variables: GModifyKnowledgeBaseTenantSettingsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GModifyKnowledgeBaseTenantSettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GModifyKnowledgeBaseTenantSettingsMutation>(ModifyKnowledgeBaseTenantSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ModifyKnowledgeBaseTenantSettings', 'mutation');
    },
    ModifyKnowledgeBaseArticle(variables: GModifyKnowledgeBaseArticleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GModifyKnowledgeBaseArticleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GModifyKnowledgeBaseArticleMutation>(ModifyKnowledgeBaseArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ModifyKnowledgeBaseArticle', 'mutation');
    },
    CreateKnowledgeBaseArticleSuggestionsFromConversation(variables: GCreateKnowledgeBaseArticleSuggestionsFromConversationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GCreateKnowledgeBaseArticleSuggestionsFromConversationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GCreateKnowledgeBaseArticleSuggestionsFromConversationMutation>(CreateKnowledgeBaseArticleSuggestionsFromConversationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateKnowledgeBaseArticleSuggestionsFromConversation', 'mutation');
    },
    DeleteKnowledgeBaseArticle(variables: GDeleteKnowledgeBaseArticleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GDeleteKnowledgeBaseArticleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GDeleteKnowledgeBaseArticleMutation>(DeleteKnowledgeBaseArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteKnowledgeBaseArticle', 'mutation');
    },
    OnKnowledgeBaseArticleModified(variables: GOnKnowledgeBaseArticleModifiedSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnKnowledgeBaseArticleModifiedSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnKnowledgeBaseArticleModifiedSubscription>(OnKnowledgeBaseArticleModifiedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnKnowledgeBaseArticleModified', 'subscription');
    },
    CreateAgentPushSubscription(variables: GCreateAgentPushSubscriptionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GCreateAgentPushSubscriptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GCreateAgentPushSubscriptionMutation>(CreateAgentPushSubscriptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateAgentPushSubscription', 'mutation');
    },
    ConversationTimelineSearch(variables: GConversationTimelineSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GConversationTimelineSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GConversationTimelineSearchQuery>(ConversationTimelineSearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ConversationTimelineSearch', 'query');
    },
    ConversationSearch(variables: GConversationSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GConversationSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GConversationSearchQuery>(ConversationSearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ConversationSearch', 'query');
    },
    ContactSearch(variables: GContactSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GContactSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GContactSearchQuery>(ContactSearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ContactSearch', 'query');
    },
    KnowledgeBaseSearch(variables: GKnowledgeBaseSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GKnowledgeBaseSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GKnowledgeBaseSearchQuery>(KnowledgeBaseSearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'KnowledgeBaseSearch', 'query');
    },
    AgentCreate(variables: GAgentCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GAgentCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GAgentCreateMutation>(AgentCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AgentCreate', 'mutation');
    },
    AgentList(variables: GAgentListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GAgentListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GAgentListQuery>(AgentListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AgentList', 'query');
    },
    AgentDelete(variables: GAgentDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GAgentDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GAgentDeleteMutation>(AgentDeleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AgentDelete', 'mutation');
    },
    AgentById(variables: GAgentByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GAgentByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GAgentByIdQuery>(AgentByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AgentById', 'query');
    },
    ModifyAgent(variables: GModifyAgentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GModifyAgentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GModifyAgentMutation>(ModifyAgentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ModifyAgent', 'mutation');
    },
    GetBotAssistantTenantSettings(variables?: GGetBotAssistantTenantSettingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GGetBotAssistantTenantSettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GGetBotAssistantTenantSettingsQuery>(GetBotAssistantTenantSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetBotAssistantTenantSettings', 'query');
    },
    ModifyBotAssistantTenantSettings(variables: GModifyBotAssistantTenantSettingsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GModifyBotAssistantTenantSettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GModifyBotAssistantTenantSettingsMutation>(ModifyBotAssistantTenantSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ModifyBotAssistantTenantSettings', 'mutation');
    },
    ChatChannelList(variables?: GChatChannelListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GChatChannelListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GChatChannelListQuery>(ChatChannelListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ChatChannelList', 'query');
    },
    ChatChannelById(variables: GChatChannelByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GChatChannelByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GChatChannelByIdQuery>(ChatChannelByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ChatChannelById', 'query');
    },
    CreateChatChannel(variables: GCreateChatChannelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GCreateChatChannelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GCreateChatChannelMutation>(CreateChatChannelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateChatChannel', 'mutation');
    },
    ModifyChatChannel(variables: GModifyChatChannelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GModifyChatChannelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GModifyChatChannelMutation>(ModifyChatChannelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ModifyChatChannel', 'mutation');
    },
    CreateEmailChannel(variables: GCreateEmailChannelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GCreateEmailChannelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GCreateEmailChannelMutation>(CreateEmailChannelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateEmailChannel', 'mutation');
    },
    EmailChannelList(variables?: GEmailChannelListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GEmailChannelListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GEmailChannelListQuery>(EmailChannelListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'EmailChannelList', 'query');
    },
    MessengerChannelList(variables?: GMessengerChannelListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GMessengerChannelListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GMessengerChannelListQuery>(MessengerChannelListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MessengerChannelList', 'query');
    },
    MessengerPageOptionsList(variables: GMessengerPageOptionsListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GMessengerPageOptionsListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GMessengerPageOptionsListQuery>(MessengerPageOptionsListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MessengerPageOptionsList', 'query');
    },
    CreateMessengerChannel(variables: GCreateMessengerChannelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GCreateMessengerChannelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GCreateMessengerChannelMutation>(CreateMessengerChannelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateMessengerChannel', 'mutation');
    },
    DeleteMessengerChannel(variables: GDeleteMessengerChannelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GDeleteMessengerChannelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GDeleteMessengerChannelMutation>(DeleteMessengerChannelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteMessengerChannel', 'mutation');
    },
    SmsChannelList(variables?: GSmsChannelListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GSmsChannelListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GSmsChannelListQuery>(SmsChannelListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SmsChannelList', 'query');
    },
    CreateSmsSubNumberChannel(variables: GCreateSmsSubNumberChannelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GCreateSmsSubNumberChannelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GCreateSmsSubNumberChannelMutation>(CreateSmsSubNumberChannelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateSmsSubNumberChannel', 'mutation');
    },
    CreateSmsVonageChannel(variables: GCreateSmsVonageChannelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GCreateSmsVonageChannelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GCreateSmsVonageChannelMutation>(CreateSmsVonageChannelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateSmsVonageChannel', 'mutation');
    },
    CreateTeam(variables: GCreateTeamMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GCreateTeamMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GCreateTeamMutation>(CreateTeamDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateTeam', 'mutation');
    },
    DeleteTeam(variables: GDeleteTeamMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GDeleteTeamMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GDeleteTeamMutation>(DeleteTeamDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteTeam', 'mutation');
    },
    GetTeamById(variables: GGetTeamByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GGetTeamByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GGetTeamByIdQuery>(GetTeamByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetTeamById', 'query');
    },
    ModifyTeam(variables: GModifyTeamMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GModifyTeamMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GModifyTeamMutation>(ModifyTeamDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ModifyTeam', 'mutation');
    },
    TranslateTextWithHtml(variables: GTranslateTextWithHtmlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GTranslateTextWithHtmlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GTranslateTextWithHtmlMutation>(TranslateTextWithHtmlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'TranslateTextWithHtml', 'mutation');
    },
    FixGrammarTextWithHtml(variables: GFixGrammarTextWithHtmlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GFixGrammarTextWithHtmlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GFixGrammarTextWithHtmlMutation>(FixGrammarTextWithHtmlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FixGrammarTextWithHtml', 'mutation');
    },
    ImproveTextWithHtml(variables: GImproveTextWithHtmlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GImproveTextWithHtmlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GImproveTextWithHtmlMutation>(ImproveTextWithHtmlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ImproveTextWithHtml', 'mutation');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;